import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT, VIDEO_PLAYING_MODE, ANNOTATION_LOCATION} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';

export const CANTALOUPE_IMAGE_SERVER = "https://iiif.v21artspace.com/iiif/2/swpa%2F2021%2Fswp-awards%2F";

export const ANNOTATION_TEXT_ALIGNMENT = "justify";
export const ANNOTATION_TEXT_LINE_HEIGHT = "1.5";
// export const GALLERY_LINK_LABEL = "WORKS";
export const GALLERY_LINK_LABEL = `<img src='/assets/languages/iconfinder_uk.png'>`;


const AnnotationsDB = [


    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: ``,
    //     // urlLink1Label: ,
    //     // urlLink1: ,
    // },
    //
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h5></h5>`,
    //     bodyText: ``,
    //     // urlLink1Label: ,
    //     // urlLink1: ,
    // },



    /* Audio */
    {
        paintingId: 'ARCA01',
        videoId: 'ARCA01',
        standaloneVideoElementId: 'ARCA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ARCA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ARCA02',
        videoId: 'ARCA02',
        standaloneVideoElementId: 'ARCA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ARCA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ARCA03',
        videoId: 'ARCA03',
        standaloneVideoElementId: 'ARCA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ARCA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'CREA01',
        videoId: 'CREA01',
        standaloneVideoElementId: 'CREA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'CREA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'CREA02',
        videoId: 'CREA02',
        standaloneVideoElementId: 'CREA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'CREA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'CREA03',
        videoId: 'CREA03',
        standaloneVideoElementId: 'CREA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'CREA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'PORA01',
        videoId: 'PORA01',
        standaloneVideoElementId: 'PORA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'PORA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'PORA02',
        videoId: 'PORA02',
        standaloneVideoElementId: 'PORA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'PORA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'PORA03',
        videoId: 'PORA03',
        standaloneVideoElementId: 'PORA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'PORA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'DOCA01',
        videoId: 'DOCA01',
        standaloneVideoElementId: 'DOCA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'DOCA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'DOCA02',
        videoId: 'DOCA02',
        standaloneVideoElementId: 'DOCA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'DOCA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'DOCA03',
        videoId: 'DOCA03',
        standaloneVideoElementId: 'DOCA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'DOCA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ENVA01',
        videoId: 'ENVA01',
        standaloneVideoElementId: 'ENVA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ENVA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ENVA02',
        videoId: 'ENVA02',
        standaloneVideoElementId: 'ENVA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ENVA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'ENVA03',
        videoId: 'ENVA03',
        standaloneVideoElementId: 'ENVA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'ENVA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'LANA01',
        videoId: 'LANA01',
        standaloneVideoElementId: 'LANA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'LANA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'LANA02',
        videoId: 'LANA02',
        standaloneVideoElementId: 'LANA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'LANA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'LANA03',
        videoId: 'LANA03',
        standaloneVideoElementId: 'LANA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'LANA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'NWWA01',
        videoId: 'NWWA01',
        standaloneVideoElementId: 'NWWA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'NWWA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'NWWA02',
        videoId: 'NWWA02',
        standaloneVideoElementId: 'NWWA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'NWWA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'NWWA03',
        videoId: 'NWWA03',
        standaloneVideoElementId: 'NWWA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'NWWA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'POTA01',
        videoId: 'POTA01',
        standaloneVideoElementId: 'POTA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'POTA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'POTA02',
        videoId: 'POTA02',
        standaloneVideoElementId: 'POTA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'POTA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'POTA03',
        videoId: 'POTA03',
        standaloneVideoElementId: 'POTA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'POTA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'SPOA01',
        videoId: 'SPOA01',
        standaloneVideoElementId: 'SPOA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'SPOA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'SPOA02',
        videoId: 'SPOA02',
        standaloneVideoElementId: 'SPOA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'SPOA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'SPOA03',
        videoId: 'SPOA03',
        standaloneVideoElementId: 'SPOA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'SPOA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'STIA01',
        videoId: 'STIA01',
        standaloneVideoElementId: 'STIA01',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'STIA01.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'STIA02',
        videoId: 'STIA02',
        standaloneVideoElementId: 'STIA02',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'STIA02.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    {
        paintingId: 'STIA03',
        videoId: 'STIA03',
        standaloneVideoElementId: 'STIA03',
        // videoURL: 'AlA01.mp3', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        videoURL: 'STIA03.wav', // this is not used for audo. The source is set from the audio tag in src/client-data/VideosComponent.js
        displayType: ANNOTATION_VIDEO_DISPLAY.AUDIO_PLAYER, // must set annotationParent: ANNOTATION_PARENT.PARENT_NONE,
        headerText: '',
        bodyText: null,
        displayMesh: 'Y',
        useVideoMeshButton: 'Y',
        displayHeight: 90,
        videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY,
        displayAudioSprite: 'N',
        // videoPlaySpriteImageURL: BSHF_AUDIO_RED,
        // videoPauseSpriteImageURL: BSHF_PAUSE_RED,
        // videoLoop: true,
    },
    /* Audio */


    /* PRO & OPEN */
    /* Architecture */
    {
        paintingId: 'ARC0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ARC0103ES', 'ARC0103EN'],
    },
    {
        paintingId: 'ARC0103ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARC0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0104.jpg/info.json`],
        headerText: `<h5>توماش فوسيلكا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أراضي الصيد الأبدية (محرقة الحيوانات الأليفة بواسطة المهندس المعماري بيتر هاجيك)</i><br><br>هُجر مجمع درنوف العسكري السابق لمدة 17 عامًا إلى أن اشترى الصديقان، مارتن كلوم وميشال سيبا، المنشأة المتداعية لتحقيق حلمهما في بناء مكان دفن للحيوانات الأليفة. ويوضح أحد المالكين سبب إنشاء هذا المشروع: "عندما مات كلبي، وجدت أنه لا توجد أي أماكن يمكن أخذه إليها لحرقه أو دفنه." وبمساعدة المهندس المعماري التشيكي الذي يتبنى أسلوب البساطة بيتر هاجيك، أنشأوا ما يُعرف الآن باسم "أراضي الصيد الأبدية"، وهي مساحة تضم قاعة حداد ومحرقة جثث وحوالي 40 هكتارًا من الأراضي المحيطة حيث يمكن للحياة البرية أن تزدهر فيها.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ARC0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARC0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0104.jpg/info.json`],
        headerText: `<h5>Tomáš Vocelka</h5>`,
        bodyText: `<b>EN</b> <i>Eternal Hunting Grounds (Pet Crematorium by architect Petr Hajek)</i><br><br>The former Drnov military complex has been abandoned for 17 years when two friends, Martin Chlum and Michal Seba, bought the dilapidated facility in order to realise their dream of building a final resting place for pets. Explaining the reason for pursuing this project one of the owners reflects:  ‘When my dog died, I found that there weren't any places where I could take him for cremation or burial’. With the help of Czech minimalist architect Petr Hajek they established what is now known as the Eternal Hunting Grounds, a space comprising a mourning hall, a crematorium and approximately 40 hectares of surrounding land where wildlife can thrive.`,
    },
    {
        paintingId: 'ARC0203',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ARC0203ES', 'ARC0203EN'],
    },
    {
        paintingId: 'ARC0203ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARC0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0203.jpg/info.json`],
        headerText: `<h5>فرانك ماشالوفسكي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>Meisterhäuser Bauhaus-Dessau</i><br><br>على مدى السنوات القليلة الماضية، زرت وصورت Walter Gropius’s Masters’ Houses في ديساو عدة مرات. وتشكل الصور مجموعة عمل تسمى Multiexpo، وتم التقاطها كلها في فيلم باستخدام أساليب التعرض المتعددة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ARC0203EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARC0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0203.jpg/info.json`],
        headerText: `<h5>Frank Machalowski</h5>`,
        bodyText: `<b>EN</b> <i>Meisterhäuser Bauhaus-Dessau</i><br><br>Over the past few years, I have visited and photographed Walter Gropius’s Masters’ Houses in Dessau numerous times. The images form a body of work called Multiexpo, and are all taken on film, using multiple exposure techniques.`,
    },

    {
        paintingId: 'ARC0304',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ARC0304ES', 'ARC0304EN'],
    },
    {
        paintingId: 'ARC0304ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARC0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0304.jpg/info.json`],
        headerText: `<h5>غو غوانغهوي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>ترنيمة موقع البناء</i><br><br>أزور في كثير من الأحيان موقع البناء هذا في مقاطعة نينغهاى، في إقليم تشجيانغ بالصين، لأسباب تتعلق بالعمل. وباستخدام طائرة بدون طيار، قمت بتصويرهم لإظهار العمل الذي يتم كل يوم.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ARC0304EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ARC0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ARC0304.jpg/info.json`],
        headerText: `<h5>Gu Guanghui</h5>`,
        bodyText: `<b>EN</b> <i>Hymn of the Building Site</i><br><br>I often visit this building site in Ninghai County, Zhejiang Province, China for work reasons. Using a drone, I photographed them to show the work that takes place each day.`,
    },

    {
        paintingId: 'ARC0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ARC0401ES', 'ARC0401EN'],
    },
    {
        paintingId: 'ARC0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARC0401.jpg/info.json`,
        headerText: `<h5>كلاوس لينتزن</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>النافذة الزرقاء</i><br><br>الدرج في فندق حياة في دوسلدورف بألمانيا.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ARC0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ARC0401.jpg/info.json`,
        headerText: `<h5>Klaus Lenzen</h5>`,
        bodyText: `<b>EN</b> <i>The blue window</i><br><br>The stairs at the Hyatt hotel in Düsseldorf, Germany.`,
    },
    /* Architecture */

    /* Creative */
    {
        paintingId: 'CRE0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CRE0103ES', 'CRE0103EN'],
    },
    {
        paintingId: 'CRE0103ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CRE0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0104.jpg/info.json`],
        headerText: `<h5>مارك هاميلتون غروتشي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>العودة إلى القمر</i><br><br>يتكون هذا العمل من صور لم يسبق معالجتها بواسطة وكالة ناسا وJet Propulsion Laboratory. وصنعت صوري الخاصة للتعبير ليس فقط عن القضايا المعاصرة، لكن أيضًا عن بعض القضايا التي كانت ذات صلة في وقت بعثات أبولو. وتم الحصول عليها من مواد خالية من حقوق الطبع والنشر قمت بإعادة تكييفها ومعالجتها وتركيبها لإنشاء محادثة حول الجانب غير المتغير للقمر المتناقض مع الأرض، والذي لا يزال مكانًا ديناميكيًا حيث لا يمكن منع التغيير. مع الشكر لناسا وJPL.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'CRE0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CRE0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0104.jpg/info.json`],
        headerText: `<h5>Mark Hamilton Gruchy</h5>`,
        bodyText: `<b>EN</b> <i>The Moon Revisited</i><br><br>This body of work is made up of previously unprocessed images from NASA and the Jet Propulsion Laboratory. I have made my own images to express not only contemporary issues but also some that were relevant at the time of the Apollo missions. These are sourced from copyright-free materials that I have repurposed, processed and composited to create a conversation about the unchanging aspect of the Moon contrasted with the Earth, which continues to be a dynamic place where change cannot be prevented. With thanks to NASA and the JPL.`,
    },

    {
        paintingId: 'CRE0203',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CRE0203ES', 'CRE0203EN'],
    },
    {
        paintingId: 'CRE0203ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CRE0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0203.jpg/info.json`],
        headerText: `<h5>لويغي بوسولاتي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أمبيليو وأنا</i><br><br>بعد شهور من البحث، عثرت أخيرًا على ألبوم الصور القديم الذي كنت أبحث عنه. وكان ملكًا لعم لي والذي كان مثلي مصورًا شغوفًا. وعاش على ضفاف نهر بو، وهو نهر في شمال إيطاليا، بين نهاية القرن التاسع عشر وأوائل القرن العشرين. وبعد أن انتحر في غرفته المظلمة عام 1942، تعرض كل ما يخصه وما أنتجه، بما في ذلك الصور الفوتوغرافية للتدمير. وفي ربيع عام 2020، في بداية الإغلاق في إيطاليا، خطرت لي فكرة أنه يمكنني عرض صوره عن المناظر الطبيعية في بارما، ودمج رؤيته مع رؤيتي. ومن خلا هذا المشروع، أصبح النهر غرفة مظلمة طويلة ولانهائية ظهرت هذه النظرة الكامنة من مياهه.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'CRE0203EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CRE0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0203.jpg/info.json`],
        headerText: `<h5>Luigi Bussolati</h5>`,
        bodyText: `<b>EN</b> <i>Ampelio and I</i><br><br>After months of searching, I finally found the tatty photo album I’d been looking for. It belonged to an uncle who, like me, was a passionate photographer. He lived along the banks of the Po, a river in northern Italy, between the end of the 19th century and the early 20th century. After taking his own life in his darkroom in 1942, almost everything that belonged to him and that he had produced, including photographs, was destroyed. In the spring of 2020, at the beginning of lockdown in Italy, I had the idea that I could project his photographs onto the landscape of Parma, merging his vision with mine. With this project, the river has become a long and infinite darkroom from whose waters this latent gaze has emerged.`,
    },
    {
        paintingId: 'CRE0304',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CRE0304ES', 'CRE0304EN'],
    },
    {
        paintingId: 'CRE0304ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CRE0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0304.jpg/info.json`],
        headerText: `<h5>ساشا باور</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>ساشا باور</i><br><br>ظهرت مجموعة عرقية جديدة من المستعمرين الألمان في منتصف القرن الثامن عشر، عندما نشرت الإمبراطورة كاثرين الثانية ""بيان حول السماح للأجانب بالاستقرار في روسيا"" في عام 1762. لكن مع بداية القرن العشرين، أصبحوا رهائن للعلاقات المتبادلة بين روسيا (الاتحاد السوفيتي آنذاك) وألمانيا، اللتين كانتا عدوين في حربين عالميتين. وبعد شهرين من بدء الحرب الوطنية العظمى، تبنت هيئة رئاسة الاتحاد السوفيتي مرسومًا ""بشأن إعادة توطين الألمان الذين يعيشون في منطقة الفولغا""، ونتيجة لذلك تم ترحيل جميع السكان الألمان (أكثر من 800000 ألماني) إلى سيبيريا وكازاخستان.<br>وكان من بينهم جدي الذي فقد والديه في معسكرات العمل. وعاش في دار للأيتام وخدم في الجيش الروسي، لكنه لم يكن خائفًا من الاحتفاظ بلقبه الألماني. وهذا المشروع عبارة عن بيان مرئي حول علاقتي بجدي من خلال الجينات والاسم نفسه.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'CRE0304EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}CRE0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}CRE0304.jpg/info.json`],
        headerText: `<h5>Sasha Bauer</h5>`,
        bodyText: `<b>EN</b> <i>Sasha Bauer</i><br><br>A new ethnic group of German colonists emerged in the mid-18th century, when Empress Catherine II published ‘Manifesto on Allowing Foreigners to Settle in Russia’ in 1762. But by the beginning of the 20th century, they became hostages of interrelations between Russia (then USSR) and Germany, which were enemies in two world wars. Two months after the start of the Great Patriotic War, the Presidium of the USSR adopted a decree, ‘On the resettlement of Germans living in the Volga region’, as a result of which the entire German population (more than 800,000 Germans) was deported to Siberia and Kazakhstan.<br>Among them was my grandfather, who lost his parents in labour camps. He lived in an orphanage and served in the Russian army, but was not afraid to keep his German surname. This project is a visual statement about my connection with my grandfather through genes and the same name.`,
    },
    {
        paintingId: 'CRE0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CRE0401ES', 'CRE0401EN'],
    },
    {
        paintingId: 'CRE0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CRE0401.jpg/info.json`,
        headerText: `<h5>تاماري كوديتا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الفيكتورية الأفريقية</i><br><br>أردت بهذه الصورة تصوير هجين أفريقي فيكتوري: طريقتي في التحقيق في السياق النمطي لجسد الأنثى السوداء. وأقدم نسخة بديلة من الواقع، حيث تندمج الثنائيات لإنشاء لغة بصرية جديدة. وكان ارتداء فستان من العصر الفيكتوري ودمجه مع أواني الطبخ التقليدية من شونا طريقتي لإظهار هوية متعددة الأوجه.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'CRE0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}CRE0401.jpg/info.json`,
        headerText: `<h5>Tamary Kudita</h5>`,
        bodyText: `<b>EN</b> <i>African Victorian</i><br><br>With this image, I wanted to portray a hybrid African-Victorian: my way of probing the stereotypical contextualisation of the black female body. I provide an alternative version of reality, where dualities fuse to create a new visual language. Taking a Victorian dress and merging it with traditional shona cooking utensils was my way of showing a multifaceted identity.`,
    },
    /* Creative */

    /* Portfolio */
    {
        paintingId: 'POR0102',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['POR0102ES', 'POR0102EN'],
    },
    {
        paintingId: 'POR0102ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POR0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0104.jpg/info.json`],
        headerText: `<h5>لورا باناك</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>نظرة عامة على مجموعة العمل</i><br><br>هذه الصور من مجموعة متنوعة من المشاريع الشخصية. وتعتمد كل أعمالي على البحث وبناء علاقة مع من أقوم بتصويرهم، بينما توجد قابلية التعرض للخطر والأمانة في مقدمة عملي. ويتيح هذا التعاون أن تكون صوري مرحة وتزيد من حدود فن الصور الشخصية، مع ضمان اتساق أساس الثقة. وأعتقد أن الصور يجب أن تأسر المشاعر وتستحضرها، ولذا، مع كل إطار أقوم بتصويره، أفكر في العناصر الموجودة داخل الإطار وخارجه. وتعتبر الرمزية مرجعًا مهمًا لاختياراتي للتكوين والمحتوى. </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'POR0102EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POR0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0104.jpg/info.json`],
        headerText: `<h5>Laura Pannack</h5>`,
        bodyText: `<b>EN</b> <i>Portfolio Overview</i><br><br>These images are from a variety of personal projects. All of my work is driven by research and building a connection with those I photograph, while vulnerability and honesty are at the forefront of my process. Such collaborations enable my imagery to be playful and push the boundaries of portraiture, while ensuring a foundation of trust is consistent. I believe images need to captivate and evoke emotion, and so, with every frame I shoot, I consider the elements within the frame and outside it. Symbolism is an important reference for my choices of composition and content.`,
    },

    {
        paintingId: 'POR0201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['POR0201ES', 'POR0201EN'],
    },
    {
        paintingId: 'POR0201ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POR0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0203.jpg/info.json`],
        headerText: `<h5>بريس لورنزو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>عملي في عام 2020</i><br><br>التقط المصور الصحفي برايس كوتو في مسقط رأسه وحولها في أورينس بمنطقة غاليسيا، سلسلة من المشاهد المؤثرة والدرامية التي تستكشف الأحداث المحلية والقضايا التي تتراوح من آثار الجائحة إلى حرائق الغابات وموسم الكرنفال.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'POR0201EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POR0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0203.jpg/info.json`],
        headerText: `<h5>Brais Lorenzo</h5>`,
        bodyText: `<b>EN</b> <i>My Work in the Year 2020</i><br><br>Taken in and around his hometown of Ourense in the region of Galicia, photojournalist Brais Couto presents a series of poignant and dramatic scenes exploring local events and issues ranging from the effects of the pandemic to forest fires and carnival season`,
    },

    {
        paintingId: 'POR0302',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['POR0302ES', 'POR0302EN'],
    },
    {
        paintingId: 'POR0302ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POR0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0303.jpg/info.json`],
        headerText: `<h5>لولي لابوريو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>مواطنو الغد</i><br><br>بدأ مشروع "مواطنو الغد" كمشروعي الشخصي أثناء الحجر الصحي. وهو عمل قيد التقدم يجمع العالم كما اعتدنا أن نعرفه وسلسلة من الصور الشخصية، تصف الوضع الطبيعي الجديد بطريقة دراماتيكية.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'POR0302EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POR0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POR0303.jpg/info.json`],
        headerText: `<h5>Loli Laboureau</h5>`,
        bodyText: `<b>EN</b> <i>Citizens of Tomorrow</i><br><br>Citizens of Tomorrow started as my personal project during the quarantine. It's a work in progress that combines the world as we used to know it and a series of portraits, describing the new normal in a dramatic way.`,
    },

    {
        paintingId: 'POR0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['POR0401ES', 'POR0401EN'],
    },
    {
        paintingId: 'POR0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}POR0401.jpg/info.json`,
        headerText: `<h5>خانه فان</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>مواطنو الغد</i><br><br>امرأة تجفف صواني السمك في سوق سمك لونغ هاي في مقاطعة فونغ تاو في فيتنام. ويتم تجفيف آلاف الصواني من سمك السكاد فوق أسطح المنازل وفي الساحات بواسطة مئات العمال. ووصلت إلى لونغ هاي في رحلة تصوير وقد غمرني حجم قرية الصيد.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'POR0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}POR0401.jpg/info.json`,
        headerText: `<h5>Khanh Phan</h5>`,
        bodyText: `<b>EN</b> <i>Drying Fish</i><br><br>A woman dries trays of fish at Long Hai fish market in the Vung Tau province of Vietnam. Thousands of trays of scad are dried on rooftops and in yards by hundreds of workers. I came to Long Hai on a photo trip and was overwhelmed by the scale of the fishing village.`,
    },
    /* Portfolio */

    /* Documentary Projects */
    {
        paintingId: 'DOC0104',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['DOC0104ES', 'DOC0104EN'],
    },
    {
        paintingId: 'DOC0104ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DOC0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0104.jpg/info.json`],
        headerText: `<h5>فيتو فوسكو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الأقحوان القاتل</i><br><br>يُعرف نبات حشيشة الحمى باسم "زهرة الموت" - لقب يصف بدقة هذه الأقحوان الرقيق المشبع بقوة مهلكة. ويُزرع نبات حشيشة الحمى بشكل أساسي في تلال ناكورو في كينيا وهو العدو اللدود لعالم الحشرات. وعندما تصادف الحشرات هذا النبات تصاب بالشلل ثم تموت. وكان نبات حشيشة الحمى يستخدم لقرون كمبيد حشري طبيعي/ ولم يكن له تأثير على سوق المبيدات العالمية إلا في منتصف القرن العشرين، واكتسب مكانة مرموقة بين المبيدات الحشرية الطبيعية. وخلال ثمانينيات القرن العشرين، بدأت أزمة حشيشة الحمى، نتيجة التوليف الكيميائي لحشيشة الحمى الذي أدى إلى تصنيع منتجات أرخص لكن غير عضوية. ومع ذلك، يتم زراعة هذا الأقحوان الخاص اليوم مرة أخرى على تلال ناكورو الطينية على ارتفاع يزيد عن 1500 متر. قررت الحكومة الكينية تحرير إنتاج نبات حشيشة الحمى وفتحه أمام الشركات الخاصة في محاولة طموحة لإنعاش القطاع ومساعدة المزارعين المحليين على تلبية الطلب العالمي المتزايد على المنتجات العضوية. وبمجرد الزرع، يوفر النبات محصولاً كل 15 يومًا تقريبًا، على مدار السنة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'DOC0104EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DOC0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0104.jpg/info.json`],
        headerText: `<h5>Vito Fusco</h5>`,
        bodyText: `<b>EN</b> <i>The Killing Daisy</i><br><br>The pyrethrum is known as the ‘flower of death’ – a nickname that neatly describes this delicate daisy imbued with murderous power. The pyrethrum is cultivated mainly in the hills of Nakuru in Kenya and is the arch foe of the insect world. When insects encounter the substance they are stunned into paralysis and then die. Used for centuries as a natural insecticide, it was only in the mid-20th century that pyrethrum made an impact on the global pesticides market, earning an eminent position among natural insecticides. During the 1980s, the pyrethrum crisis began, instigated by the chemical synthesis of pyrethroids that led to the manufacturing of cheaper but non-organic products. Today, however, this special daisy is being grown once again on the clay hills of Nakuru at an altitude of over 1,500m. The Kenyan government has decided to liberalise the production of pyrethrum, opening it to private companies in an ambitious attempt to revive the sector and help local farmers meet the growing global demand for organic products. Once sown, the plant provides a yield approximately every 15 days, all year round.`,
    },

    {
        paintingId: 'DOC0203',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['DOC0203ES', 'DOC0203EN'],
    },
    {
        paintingId: 'DOC0203ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DOC0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0203.jpg/info.json`],
        headerText: `<h5>كريغ إيستون</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أطفال تاتشر</i><br><br>يدرس مشروع أطفال تاتشر طبيعة الفقر المزمن بين الأجيال، ويستكشف آثار السياسات الاجتماعية للحكومات المتعاقبة كما عاشتها ثلاثة أجيال لعائلة واحدة في شمال إنجلترا. قابلت عائلة ويليامز لأول مرة في بلاكبول في عام 1992: والدان وستة أطفال يعيشون في نزل للعائلات المشردة. وكانوا محاصرين في حلقة من البطالة والفقر. ولطالما تساءلت عما حل بالعائلة. تعقبتهم أخيرًا في عام 2016 وما زلت أعمل معهم منذ ذلك الحين. لدى الأطفال الستة الآن ما يقرب من 30 طفلاً، وجميعهم تقريبًا يعيشون في ظروف مماثلة لتلك التي وجدتهم فيها في عام 1992. الآن، مع ذلك، فهم محاصرون بعقود صفرية الساعات و"الفقر أثناء العمل". وأرى أن تجربتهم توضح ما حدث لمجتمع خلفته السياسات الاجتماعية المطبقة في ثمانينيات وتسعينيات القرن الماضي. </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'DOC0203EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DOC0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0203.jpg/info.json`],
        headerText: `<h5>Craig Easton</h5>`,
        bodyText: `<b>EN</b> <i>Thatcher's Children</i><br><br>Thatcher’s Children investigates the chronic intergenerational nature of poverty, exploring the effects of successive governments’ social policies as experienced by three generations of one family in the north of England. I first met the Williams family in Blackpool in 1992: two parents and six children living in a hostel for homeless families. They were trapped in a cycle of unemployment and poverty. I had long wondered what became of the family; I finally traced them in 2016 and have been working with them ever since. The six children now have almost 30 children between them, almost all living in similar conditions to those in which I found them in 1992. Now, however, they are trapped by zero-hours contracts and ‘in-work poverty’. I see their experience as being illustrative of what happened to a society that was left behind by the social policies implemented in the 1980s and ’90s.`,
    },

    {
        paintingId: 'DOC0303',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['DOC0303ES', 'DOC0303EN'],
    },
    {
        paintingId: 'DOC0303ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DOC0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0303.jpg/info.json`],
        headerText: `<h5>لورينزو توغنولي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>انفجار مرفأ بيروت</i><br><br>بعد بضع دقائق من السادسة مساءً في 4 أغسطس 2020، هز انفجار هائل بيروت ودمر مرفأها ومساحات شاسعة من المدينة. وقُتل ما لا يقل عن 200 شخص وأصيب أكثر من 6000 عندما انفجر 2750 طنًا من نترات الأمونيوم. تم تخزين المواد في مستودع في مرفأ بيروت منذ أن صادرتها سلطات الجمارك في عام 2014، على الرغم من التحذيرات المتكررة من الخطر من قبل مسؤولي المرفأ وقربه من منطقة مكتظة بالسكان في المدينة. في الأيام التالية، مع استمرار انتشال الجثث من تحت الأنقاض، احتل المتظاهرون الوزارات الحكومية وأشعلوا الحرائق وواجهوا قوات الأمن.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'DOC0303EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}DOC0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}DOC0303.jpg/info.json`],
        headerText: `<h5>Lorenzo Tugnoli</h5>`,
        bodyText: `<b>EN</b> <i>Beirut Port Explosion</i><br><br>A few minutes after 6pm on August 4, 2020, a massive explosion shook Beirut, obliterating its port and destroying swathes of the city. At least 200 people were killed and more than 6,000 injured when 2,750 tons of ammonium nitrate detonated. The material had been stored in a warehouse in Beirut’s port since being seized by custom authorities in 2014, despite repeated warnings of the danger from port officials and its proximity to a densely populated area of the city. In the following days, as bodies continued to be pulled from the rubble, protesters occupied government ministries, set fires and faced off against security forces.`,
    },

    {
        paintingId: 'DOC0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['DOC0401ES', 'DOC0401EN'],
    },
    {
        paintingId: 'DOC0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DOC0401.jpg/info.json`,
        headerText: `<h5>ف. ديليك أويار</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>التطهير</i><br><br>أثناء جائحة فيروس كورونا، ترش وحدة الشؤون الصحية ببلدية أنقرة كل وسائل النقل العام ليلاً ونهارًا.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'DOC0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}DOC0401.jpg/info.json`,
        headerText: `<h5>F.Dilek Uyar</h5>`,
        bodyText: `<b>EN</b> <i>Disinfection</i><br><br>During the coronavirus pandemic, the Health Affairs unit of Ankara Municipality sprays all public transportation, day and night.`,
    },
    /* Documentary Projects */

    /* Environment */
    {
        paintingId: 'ENV0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ENV0103ES', 'ENV0103EN'],
    },
    {
        paintingId: 'ENV0103ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ENV0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0104.jpg/info.json`],
        headerText: `<h5>سيمون ترامونتي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>انتقال بدون انبعاثات مضرة بالبيئة</i><br><br>أدت جائحة فيروس كورونا إلى أسوأ انكماش اقتصادي شهده العالم في السنوات الأخيرة. ومع ذلك، قدمت هذه الأزمة أيضًا للبلدان فرصة غير مسبوقة للتحول نحو العيش المستدام. انعزلت أيسلندا وواجهت تحديات بسبب المناخ القاسي، وبعد الأزمة المالية في عام 2008 نجحت في تحويل اقتصادها من خلال استخدام الطاقة المتجددة. وفي غضون بضعة عقود، ابتعدت الدولة عن الوقود الأحفوري لإنتاج الكهرباء بنسبة 100% من مصادر متجددة. وعزز هذا التحول نظامًا بيئيًا للابتكار وريادة الأعمال أدى إلى نمو أعمال تجارية مربحة بهدف إحداث تأثير ضئيل على البيئة. وهكذا أصبحت أيسلندا رائدة عالميًا في التقنيات التي تعزز الطاقة النظيفة وتقليل الانبعاثات. وتقدم هذه الدولة الصغيرة العديد من الطرق التي يمكن من خلالها معالجة أزمة المناخ العالمية وتقود الانتقال إلى مستقبل مستدام بدون انبعاثات مضرة بالبيئة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ENV0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ENV0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0104.jpg/info.json`],
        headerText: `<h5>Simone Tramonte</h5>`,
        bodyText: `<b>EN</b> <i>Net-zero Transition</i><br><br>The coronavirus pandemic has led to the most severe economic downturn the world has seen in recent years. However, this crisis also presented countries with an unprecedented opportunity to shift towards sustainable living. Iceland is isolated and challenged by a harsh climate and following the financial crisis in 2008 has successfully transformed its economy through the use of renewable energy. In a few decades, the country moved away from fossil fuels to producing 100% of its electricity from renewable sources. This transition nurtured an ecosystem of innovation and entrepreneurship that grew profitable businesses aiming to make minimal impact on the environment. Thus Iceland has become a global leader in technologies that foster clean energy and emission reduction. This small nation presents many ways in which the global climate crisis can be tackled and is leading the transition to a net-zero sustainable future.`,
    },

    {
        paintingId: 'ENV0203',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ENV0203ES', 'ENV0203EN'],
    },
    {
        paintingId: 'ENV0203ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ENV0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0203.jpg/info.json`],
        headerText: `<h5>محمد مدادي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>مدينة تحت غيوم الغبار</i><br><br>تُصنف الأهواز على الدوام كواحدة من أسوأ مدن العالم من حيث تلوث الهواء وفقًا لمنظمة الصحة العالمية، حيث تصدرت القائمة في مناسبات عديدة خلال العقد الماضي. وتعد المصادر الصناعية، وعلى رأسها المصافي والمكونات الأخرى لصناعة البتروكيماويات الضخمة في مقاطعة خوزستان، فضلاً عن العواصف الترابية الضخمة، من عوامل الإسهام الرئيسية في تلوث الهواء. وتؤثر جودة الهواء الرديئة بشكل كبير على حياة سكان الأهواز. وفي كل عام، يسعى الآلاف للحصول على العلاج الطبي لأمراض الجهاز التنفسي. وأدى تلوث الهواء كذلك إلى زيادة الهجرة خارج المدينة، ومحدودية الاستثمارات والسياحة، والبنية التحتية المتضررة، وأضاف إلى الاستهلاك المرتفع بالفعل للكهرباء والمياه في المدينة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ENV0203EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ENV0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}ENV0203.jpg/info.json`],
        headerText: `<h5>Mohammad Madadi</h5>`,
        bodyText: `<b>EN</b> <i>A City Under Dust Clouds</i><br><br>Ahvaz has been consistently ranked as one of the world's worst cities for air pollution according to the World Health Organization, topping the list on numerous occasions in the past decade. Industrial sources, chief among them the refineries and other components of the vast petrochemical industry in Khuzestan Province, as well as massive dust storms, are the main contributors to air pollution. The poor air quality has a significant impact on the lives of the residents of Ahvaz. Each year, thousands seek medical treatment for respiratory conditions. The air pollution has also increased immigration out of the city, limited investments and tourism, damaged infrastructure, and added to the already high electricity and water consumption of the city.`,
    },

    {
        paintingId: 'ENV0302',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ENV0302ES', 'ENV0302EN'],
    },
    {
        paintingId: 'ENV0302ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ENV0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ENV0302.jpg/info.json`],
        headerText: `<h5>أنطونيو بيريز</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>البحر يحركنا، والبحر يحرك فوفيمه</i><br><br>اختفت قرية فوفيمه بغانا، وهي قرية صيد تقع بين المحيط الأطلسي ومصب نهر فولتا. ,لا يمكن العثور عليها حتى على خرائط Google، وهي موجودة الآن فقط في ذكريات من عاشوا هناك. ويساهم تآكل السواحل وارتفاع مستوى سطح البحر - نتيجة مباشرة للاحترار العالمي - في اختفاء المجتمعات الساحلية في غرب أفريقيا. وفوفيمه مثال واضح على ذلك.<br>وعلى مر السنين، رأى سكان هذه القرية، شيئًا فشيئًا، أراضيهم ومنازلهم وسبل عيشهم تختفي. وابتلع البحر الدفاعات والحواجز وحواجز الأمواج التي أقامتها مشاريع التعاون. وهؤلاء هم سكان فوفيمه الذين استطاعوا الفرار إلى قرى أخرى ومنازل أخرى وبلدان أخرى. وبقي البعض على بعد مئات الأمتار فقط من الشاطئ، على أمل ألا يبتلع البحر حياتهم مرة أخرى.  وفي بعض الأحيان، عند انخفاض المد، يعودون إلى ما تبقى من منازلهم: الجدران والشبابيك وإطارات الأبواب. وفي بعض الأحيان لا يوجد شيء. وهي مساحة فارغة يملأها الناس بذكرياتهم. واُلتقطت هذه الصور للأشخاص وما تبقى من منازلهم في تلك اللحظات.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ENV0302EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}ENV0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}ENV0302.jpg/info.json`],
        headerText: `<h5>Antonio Pérez</h5>`,
        bodyText: `<b>EN</b> <i>The Sea Moves Us, the Sea Moves Fuvemeh</i><br><br>Fuvemeh, Ghana, a fishing village located between the Atlantic Ocean and the mouth of the Volta River, has disappeared. It cannot even be found on Google Maps, and now only exists in the memories of those who lived there. Coastal erosion and rising sea levels – a direct consequence of global warming – are contributing to the disappearance of coastal communities in West Africa. Fuvemeh is a clear example of this.<br>Over the years, the inhabitants of this village, little by little, saw their lands, their houses and their livelihoods disappear. The defenses, barriers and breakwaters, built by cooperation projects, have also been swallowed up by the sea. Those inhabitants of Fuvemeh who are able to have fled to other villages, other houses, other countries. Some remain, only a few hundred metres from the shore, hoping the sea will not swallow their lives up again.  Sometimes, at low tide, they return to what is left of their houses: walls; windows; a doorframe. Sometimes there is nothing. It’s an empty space, which the people fill with their memories. These photographs of the people and what remains of their house are taken in those moments.`,
    },

    {
        paintingId: 'ENV0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ENV0401ES', 'ENV0401EN'],
    },
    {
        paintingId: 'ENV0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ENV0401.jpg/info.json`,
        headerText: `<h5>ماريانو بلمار</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>دياس دي بلايا</i><br><br>الصيف، البحر الأبيض المتوسط، إسبانيا، أليكانتي، المشي على الشاطئ في الصباح: أسلوب حياة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ENV0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ENV0401.jpg/info.json`,
        headerText: `<h5>Mariano Belmar</h5>`,
        bodyText: `<b>EN</b> <i>Días de Playa</i><br><br>Summer, Mediterranean Sea, Spain, Alicante, beach and morning walk: a way of life.`,
    },
    /* Environment */

    /* Landscape */
    {
        paintingId: 'LAN0102',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAN0102ES', 'LAN0102EN'],
    },
    {
        paintingId: 'LAN0102ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAN0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAN0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAN0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAN0104.jpg/info.json`],
        headerText: `<h5>ماجد حجتي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الأحياء الصامتة</i><br><br>كل شيء في الحياة يتكون من انطباعات من الماضي وكل ما يحدث لنا اليوم. ويأخذ النسيج الذي اتخذ شكلًا واحدًا أمس شكلاً جديدًا الآن. ولا تزال جميع المخلوقات تقاتل من أجل بقائها. وتمثل الطبيعة ساحة المعركة. ولا تزال قوى العالم كما كانت هي دون تغيير: أمواج البحر والعواصف والأرض نفسها. لكن في النهاية، فإن الإنسانية هي التي تسير في كل مكان وتطالب بكل شيء وتثبت للعالم أنها ستدوم. وقد سعينا جاهدين للعيش والاستيلاء والسيطرة، قبل أن نعرف حتى ماذا نسمي أنفسنا. ونعتقد أننا سنستمر إلى الأبد، لذا فنحن نصطاد ونبني ونرتدي الملابس ونستهلك ونغير أفكارنا وأدواتنا على مر السنين، لكننا لا نغير طرقنا أبدًا. وقد واصلنا المطاردة أكثر فأكثر وكان هناك دائمًا شيء ما خلفناه وراءنا. هُجرت المنازل، وتركت الكراسي فارغة ولم يتم ارتداء الملابس، حتى أزرار القميص فقدت. لقد تسابقنا إلى الأبد ونعلم أن الحياة زائلة، تاركين الأنوار مضاءة وراءنا كما لو كنا نقول إننا في يوم من الأيام كنا على قيد الحياة. ها هي الأحياء الصامتة: تلك الأماكن الخالية من الوجود الإنساني. ويمكن سماع ضجيج صمتها في كل مكان - لكن هنا في هذه الأماكن محكوم علينا ألا نسمع شيئًا.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAN0102EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAN0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAN0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAN0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAN0104.jpg/info.json`],
        headerText: `<h5>Majid Hojjati</h5>`,
        bodyText: `<b>EN</b> <i>Silent Neighborhoods</i><br><br>Everything in life is made up of impressions from the past and whatever befalls us today. The fabric which took one form yesterday takes on a new form now. All creatures still fight for their survival. Nature is the battlefield. The forces of the world are as they have ever been; the waves of the sea, storms, the earth itself. But ultimately it is humanity, marching everywhere, claiming everything, proving to the world that it will endure. We strove to live, to take and to control, before even knowing what to call ourselves. We think we will last forever so we hunt, build, wear clothes and consume, changing our ideas and our tools over the years but never changing our ways. We chased after more and more and something was always left behind. Homes were abandoned, chairs left empty and clothes unworn, even the buttons of a shirt were lost. We have raced to eternity, knowing life is fleeting, leaving the lights on behind us as if to say that once upon a time we were alive. Here are the silent neighbourhoods: those places free of the presence of humanity. The noise of their silence can be heard everywhere – but here in these places we are condemned to hear nothing.`,
    },

    {
        paintingId: 'LAN0202',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAN0202ES', 'LAN0202EN'],
    },
    {
        paintingId: 'LAN0202ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAN0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAN0202.jpg/info.json`],
        headerText: `<h5>أندريا فيرو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الزعيم</i><br><br>في الثقافات العربية، يرتبط تصوير الكائنات الحية ارتباطًا وثيقًا بالوثنية. يدين القرآن الوثنية، لأن الله يجب أن يكون الإله المبجل وحده. ومع ذلك، في لبنان وكذلك في البلدان ذات الأغلبية المسلمة الأخرى، ينتشر استخدام الصور لأغراض دعائية يصور السياسيين والشخصيات المحلية في صورة "آلهة" يجب تبجيلهم. وتعد طرابلس ثاني أكبر مدينة في لبنان من حيث عدد السكان والمساحة، وتعتبرها الأمم المتحدة أفقر مدينة على ساحل البحر الأبيض المتوسط. ومن المحتمل أيضًا أن تكون المدينة اللبنانية التي يوجد بها أقوى تمثيل بصري للشخصيات المحلية والوطنية. ويكشف مشروعي عن العلاقة بين الجوانب التعبدية للأيقونات وانتشارها على المستوى المكاني والحضري.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAN0202EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAN0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAN0202.jpg/info.json`],
        headerText: `<h5>Andrea Ferro</h5>`,
        bodyText: `<b>EN</b> <i>Zaïm</i><br><br>In Arab cultures, depicting living beings is strictly connected to idolatry. The Quran condemns the worship of idols, since God should be the only subject of veneration. However, in Lebanon as well as in other majority Muslim countries, the use of images for propaganda purposes portrays politicians and local personalities almost as ‘divinities’ to be venerated. Tripoli is the second largest city in Lebanon by population and size, and is considered by the UN to be the poorest city on the Mediterranean coast. It is also probably the Lebanese city where the presence of representations of both local and national personalities has the strongest visual impact. My project reveals the correlation between devotional aspects of iconography and its pervasiveness at a spatial and urban level.`,
    },

    {
        paintingId: 'LAN0302',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAN0302ES', 'LAN0302EN'],
    },
    {
        paintingId: 'LAN0302ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAN0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAN0302.jpg/info.json`],
        headerText: `<h5>فيودور سافينتسيف</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>البركان</i><br><br>التقطتُ هذه الصور خلال رحلتي الأولى إلى براكين كامتشاتكا في شرق روسيا. وزرتها في الخريف، عندما لا يوجد ثلج يغطي البراكين، وقد أدهشني كيف بدت الأوراق الصفراء على الرماد الأسود. واستغرقت زيارتي حوالي أسبوعين والتقطت الصور في جميع الظروف الجوية المتغيرة وأوقات اليوم المختلفة. وتختلف شبه جزيرة كامتشاتكا تمامًا عن أي شيء آخر رأيته. وانشغلت تمامًا بجمالها وأردت تصوير الحزام البركاني على أنه كائن حي. وأخطط لمواصلة السلسلة هذا العام.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAN0302EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAN0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAN0302.jpg/info.json`],
        headerText: `<h5>Fyodor Savintsev</h5>`,
        bodyText: `<b>EN</b> <i>Volcano</i><br><br>I took these photographs during my first trip to the volcanoes of Kamchatka in eastern Russia. I visited in the autumn, when there is no snow covering the volcanoes, and was struck by how the yellowing leaves looked against the black ash. My visit lasted around two weeks and I photographed in all different weather conditions and times of the day. The Kamchatka Peninsula is completely different from anything else I’ve seen. I was completely absorbed by its beauty and wanted to portray the volcanic belt as a living organism. I plan to continue the series this year.`,
    },

    {
        paintingId: 'LAN0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAN0401ES', 'LAN0401EN'],
    },
    {
        paintingId: 'LAN0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAN0401.jpg/info.json`,
        headerText: `<h5>خوان لوبيز رويز</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>عاصفة كهربائية فوق الخزامى</i><br><br>عاصفة كهربائية فوق شجرة منعزلة في حقول الخزامى في بريهويغا في غوادالاخارا بإسبانيا.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAN0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAN0401.jpg/info.json`,
        headerText: `<h5>Juan López Ruiz</h5>`,
        bodyText: `<b>EN</b> <i>Electric Storm on Lavender</i><br><br>Electric storm above a solitary tree in the lavender fields of Brihuega, Guadalajara, Spain.`,
    },
    /* Landscape */

    /* Wildlife & Nature */
    {
        paintingId: 'NWW0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NWW0103ES', 'NWW0103EN'],
    },
    {
        paintingId: 'NWW0103ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NWW0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0104.jpg/info.json`],
        headerText: `<h5>لويس تاتو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>غزو الجراد في شرق أفريقيا</i><br><br>يعد الجراد الصحراوي أكثر الآفات المهاجرة تسببًا للدمار في العالم. ويزدهر المليارات من الجراد في ظروف رطبة في البيئات شبه القاحلة إلى القاحلة، ويتغذى في جميع أنحاء شرق أفريقيا، ويلتهم كل شيء في طريقه، ويشكل تهديدًا كبيرًا للإمدادات الغذائية وسبل عيش الملايين من الأشخاص. ويقف المزارعون مكتوفي الأيدي بينما تأكل جيوش الحشرات المفترسة محاصيلهم؛ وفي غضون ذلك، يشاهد الرعاة المراعي وهي مجردة من المحاصيل قبل أن تصل مواشيهم إليها. وأدت أحداث هطول الأمطار الغزيرة والتغير الجوي القاسي إلى خلق ظروف مثالية لتكاثر الجراد وتغذيته. وبدأت أسراب الجراد الصحراوي القادمة من شبه الجزيرة العربية بالانتشار عبر شرق أفريقيا في أوائل عام 2020، والتهمت المحاصيل والغطاء النباتي حيث حلت. ووصلت الأزمة إلى أبعاد تاريخية، حيث عانت 10 دول في القرن الأفريقي الكبير واليمن من تفشي الوباء. ولم تشهد بعض مناطق شرق أفريقيا، مثل كينيا، تفشي الجراد الصحراوي الشديد منذ أكثر من 70 عامًا. وأدت قيود فيروس كورونا إلى إبطاء الجهود المبذولة لمكافحة الغزو بشكل كبير، حيث أصبح عبور الحدود أكثر صعوبة، مما أدى إلى حدوث تأخيرات وتعطيل سلاسل التوريد الخاصة بالمبيدات والمنتجات اللازمة لمنع هذه الآفات من القضاء على الغطاء النباتي في جميع أنحاء المنطقة وتعريض ملايين الأشخاص إلى مستويات عالية من انعدام الأمن الغذائي.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'NWW0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NWW0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0104.jpg/info.json`],
        headerText: `<h5>Luis Tato</h5>`,
        bodyText: `<b>EN</b> <i>Locust Invasion in East Africa</i><br><br>Desert locusts are the most destructive migratory pests in the world. Thriving in moist conditions in semi-arid to arid environments, billions of locusts have been feeding throughout East Africa, devouring everything in their path, and posing a huge threat to the food supply and livelihoods of millions of people. Farmers stand by as armies of ravenous insects eat their crops; meanwhile, herders watch the rangelands stripped bare before their livestock can get to them. Extreme rainfall events and severe weather anomalies have created ideal conditions for locust breeding and feeding. Swarms of desert locusts from the Arabian Peninsula began rampaging across East Africa in early 2020, devouring crop and vegetation where they landed. The crisis reached historic proportions, with 10 countries in the Greater Horn of Africa and Yemen experiencing infestations. Some areas of East Africa, such as Kenya, had not seen such severe desert locust outbreaks in more than 70 years. Covid-19 restrictions have significantly slowed efforts to fight the infestation, as crossing borders has become more difficult, creating delays and disrupting the supply chains of pesticides and products needed to prevent these pests from wiping out vegetation across the region and exposing millions of people to high levels of food insecurity.`,
    },

    {
        paintingId: 'NWW0203',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NWW0203ES', 'NWW0203EN'],
    },
    {
        paintingId: 'NWW0203ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NWW0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0203.jpg/info.json`],
        headerText: `<h5>غرايم بوردي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الطبيعة الأم</i><br><br>اُلتقطت هذه السلسلة من الصور باستخدام عدسات ذات زاوية عريضة ومشغلات لاسلكية. ومع هذه الحيوانات البرية الشهيرة، فإن التواجد على مقربة منها خطير للغاية، لذلك يجب أن تكون مبدعًا ومبتكرًا. يكتمل هذا المنظور الفريد من خلال صورة جوية لقطيع من أفراس النهر، بالإضافة إلى صور تحت الماء على بعد بوصات من التماسيح البرية. وهدفت إلى تقديم منظور فريد يُظهر الجمال البكر وقوة البرية؛ وآمل، من خلال المزيد من التعاطف مع الطبيعة، أن نتعلم الحفاظ عليها. جميع الحيوانات برية وحرة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'NWW0203EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NWW0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}NWW0203.jpg/info.json`],
        headerText: `<h5>Graeme Purdy</h5>`,
        bodyText: `<b>EN</b> <i>Raw Nature</i><br><br>This series of images was taken using wide angle lenses and wireless triggers. With these iconic wild animals, being in close proximity is too dangerous, so you need to be inventive and innovative. This unique perspective is complemented by an aerial image of a hippo pod, as well as underwater images inches away from wild crocodiles. I have aimed for a unique perspective showing the raw beauty and power of the wild; hopefully, through more empathy with nature, we will learn to preserve it. All animals are wild and free.`,
    },

    {
        paintingId: 'NWW0301',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NWW0301ES', 'NWW0301EN'],
    },
    {
        paintingId: 'NWW0301ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NWW0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}NWW0302.jpg/info.json`],
        headerText: `<h5>أنجيل فيتور</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>قطرات البحر</i><br><br>تخيلت المحيط في شكل كائن خارق، وبحار العالم في شكل أعضائه، ومخلوقاته في شكل الأنسجة التي تربط كل شيء. وبالغرق فيه أكثر، لا يوجد شيء... سوى قطرات البحر.<br>يفتح هذا المفهوم المجازي قطرات البحر، وهو مقال مصور يهدف إلى استكشاف توهج الحياة داخل قطرات مياه البحر. ويلتقط المشروع باستخدام الماصات الدقيقة الخاصة بالمختبر وإعداد استوديو صغير مصمم ذاتيًا، جمال وعادات العوالق الحية، التي تتراوح من 200 إلى 1500 ميكرون، داخل قطرات مضاءة خصيصًا من الماء. ويروي قصة واحدًا من أكثر المجتمعات البيولوجية المحورية للأرض بمنظور مبتكر، يندرج في مكان ما بين الفن والعلم. وتكشف الصور عن التنوع المذهل للمخلوقات غير المرئية بالعين المجردة، بالإضافة إلى سلوكها المذهل، والذي من المحتمل ألا يكون بعضها قد تم توثيقه من قبل. وقد يكون هذا جديدًا على العلم. ومن الجمال الآسر للياقوت البحري، إلى الرقصات الغامضة بشكل مذهل للديدان الحلقية، يفتح المشروع نافذة على شكل قطرة لعالم جديد. وتم التعامل مع جميع العينات بعناية تحت خبرة عالم أحياء، وتم إعادة إطلاقها حية ودون أن تصاب بأذى مرة أخرى إلى البحر.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'NWW0301EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}NWW0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}NWW0302.jpg/info.json`],
        headerText: `<h5>Angel Fitor</h5>`,
        bodyText: `<b>EN</b> <i>Sea Drops</i><br><br>‘I have imagined the ocean as a superorganism, with the world's seas as its organs, and its creatures as the tissues that interconnect everything. Sinking further down on to it, there is nothing… but sea drops.’<br>This figurative concept opens Sea Drops, a photo essay aimed to explore the effervescence of life inside drops of sea water. By using lab micropipettes, and a self-designed micro studio setup, the project captures the beauty and manners of live plankton, which are in the range of 200 to 1,500 microns, inside specially lit drops of water. It tells the story of one of Earth's most pivotal biological communities with an innovative perspective, falling somewhere between art and science. The images reveal the astonishing diversity of creatures otherwise invisible to the naked eye, as well as their amazing behaviour, some of which is likely never to have been documented before. It may even be new to science. From the enthralling beauty of sea sapphires, to the mesmerisingly mysterious dances of annelid worms, the project opens a drop-shaped window to a new world. All specimens were carefully handled under a biologist's expertise, and released alive and unharmed back into the sea.`,
    },

    {
        paintingId: 'NWW0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NWW0401ES', 'NWW0401EN'],
    },
    {
        paintingId: 'NWW0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NWW0401.jpg/info.json`,
        headerText: `<h5>كريستو بيهلامي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>قبلة صغيرة</i><br><br>قبلة صغيرة؟</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'NWW0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}NWW0401.jpg/info.json`,
        headerText: `<h5>Cristo Pihlamäe</h5>`,
        bodyText: `<b>EN</b> <i>Little Kiss</i>`,
    },
    /* Wildlife & Nature */

    /* Portraiture */
    {
        paintingId: 'POT0109',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['POT0109ES', 'POT0109EN'],
    },
    {
        paintingId: 'POT0109ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POT0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0104.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0105.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0106.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0107.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0108.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0109.jpg/info.json`],
        headerText: `<h5>كريغ إيستون</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>Bank Top</i><br><br>يفحص مشروع Bank Top، وهو تعاون مع الكاتب والأكاديمي عبد العزيز حافظ، التمثيل والتحريف للمجتمعات في شمال إنجلترا، ويركز على حي متماسك في بلاكبيرن. ويلاحظ كريغ إيستون أن بلاكبيرن أصبحت مرادفًا لاستخدام كلمات مثل الفصل العنصري (BBC Panorama) والتكامل (The Casey Review) من جانب وسائل الإعلام وصانعي السياسات - وهي مصطلحات يُعتقد أنها مبسطة للغاية بحيث لا تفسر التحديات التي تواجهها مثل هذه الأحياء والمدن. ويهدف من مشروع Bank Top إلى مواجهة ما يعتبره خطابات مهيمنة في وسائل الإعلام تفشل في الاعتراف بالإرث التاريخي والتكاليف الاجتماعية للتوسع الصناعي والاستعمار. ويستخدم هذا التعاون الطويل القصص والخبرات في مشروع Bank Top لمعالجة قضايا أوسع حول الحرمان الاجتماعي والإسكان والبطالة والهجرة والتمثيل، فضلاً عن تأثير السياسة الخارجية السابقة والحالية.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'POT0109EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POT0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0104.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0105.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0106.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0107.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0108.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0109.jpg/info.json`],
        headerText: `<h5>Craig Easton</h5>`,
        bodyText: `<b>EN</b> <i>Bank Top</i><br><br>Bank Top, a collaboration with writer and academic Abdul Aziz Hafiz, examines the representation and misrepresentation of communities in northern England, and focuses on a tight-knit neighbourhood in Blackburn. Craig Easton notes that Blackburn has become synonymous with the use of words such as segregation (BBC Panorama) and integration (The Casey Review) by the media and policy makers – terms which he believes are too simplistic to explain the challenges faced by such neighbourhoods and towns. His aim with Bank Top is to confront what he sees as dominant discourses in the media which fail to acknowledge the historical legacy and social costs of industrial expansion and colonialism. This long-form collaboration uses the stories and experiences in Bank Top to address wider issues around social deprivation, housing, unemployment, immigration and representation, as well as the impact of past and present foreign policy.`,
    },

    {
        paintingId: 'POT0204',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['POT0204ES', 'POT0204EN'],
    },
    {
        paintingId: 'POT0204ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POT0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0203.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0204.jpg/info.json`],
        headerText: `<h5>جوليا فولرتون باتن</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>النظر من الداخل، 2020</i><br><br>لا يزال الوقت جامدًا في مكانه بالنسبة لمعظمنا. وهو وقت حساس؛ نشعر فيه جميعًا بالضعف والقلق. وشعرت بالخدر، لكنني كنت أعرف أنني لا أستطيع الوقوف وعدم فعل أي شيء، لذلك قررت أن أوثق وجود اليوم كما يعيشه الآن العديد من الناس. واخترت أن التقط صورهم في عزلة مغلقة، ومسجونين فعليًا خلف نوافذ منازلهم وينظرون إلى عالم كئيب مختلف. وساعد ابني البالغ من العمر 12 عامًا في حمل الإضاءة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'POT0204EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POT0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0203.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0204.jpg/info.json`],
        headerText: `<h5>Julia Fullerton-Batten</h5>`,
        bodyText: `<b>EN</b> <i>Looking Out from Within, 2020</i><br><br>Time stands still for most of us. It is a sensitive time; we all feel vulnerable and anxious. I felt numb, but I knew I couldn’t stand around and do nothing, so I decided to document today’s existence as lived now by many people. I chose to capture them in their lockdown isolation, effectively imprisoned behind the windows of their homes looking out onto a different desolate world. My 12-year old son helped carry the lighting.`,
    },
    {
        paintingId: 'POT0303',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['POT0303ES', 'POT0303EN'],
    },
    {
        paintingId: 'POT0303ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POT0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0303.jpg/info.json`],
        headerText: `<h5>جين هيلتون</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>رعاة بقر في ملابس النساء</i><br><br>تم التقاط هذه الصور قبل وصول الجائحة إلى الولايات المتحدة في فبراير 2020. ويمثل مشروع رعاة البقر في ملابس النساء تعاونًا مع مجتمع نابض بالحياة من فناني الأداء في لاس فيغاس. والتقطت الصور في ولاية نيفادا، وكانت مستوحاة من مواقع وانتقال الشخصيات في فيلم جون هيوستن The Misfits (1961)، واختارت كل الشخصيات وصنعت بدقة ملابس "مواطني الغد" الخاصة بهم "الغربية"؛ بما في ذلك الإكسسوارات والشعر المستعار والمكياج الخاص بكل منهم. وبعد اكتساب ثقتهم، وجهتهم بعيدًا عن موطنهم الليلي المتمثل في الحانات والنوادي. ومع عدم وجود إضاءة صناعية أو تقنية رقمية، التقطت هذه الصور على فيلم أبيض وأسود، باستخدام كاميرا لوحة، في الضوء الطبيعي للغرب الأمريكي.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'POT0303EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}POT0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}POT0303.jpg/info.json`],
        headerText: `<h5>Jane Hilton</h5>`,
        bodyText: `<b>EN</b> <i>Drag Queen Cowboys</i><br><br>These portraits were taken just before the pandemic reached the USA in February 2020. Drag Queen Cowboys is a collaboration with the vibrant community of performers based in Las Vegas. Set in Nevada, and inspired by the locations and displacement of characters in John Houston’s film The Misfits (1961), all drag queens chose and painstakingly made theiCitizens of Tomorrowr own ‘Western’ outfits; including accessories, wigs and applying their own make-up. After gaining their trust, I steered them away from their nocturnal habitat of bars and clubs. With no artificial lighting or digital technology, I shot these portraits on black-and-white film, using a plate camera, in the natural light of the American West.`,
    },

    {
        paintingId: 'POT0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['POT0401ES', 'POT0401EN'],
    },
    {
        paintingId: 'POT0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}POT0401.jpg/info.json`,
        headerText: `<h5>ليودميلا سابانينا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الابن</i><br><br>جانب آخر من جوانب الطفولة: التأمل والهدوء.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'POT0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}POT0401.jpg/info.json`,
        headerText: `<h5>Lyudmila Sabanina</h5>`,
        bodyText: `<b>EN</b> <i>Son</i><br><br>Another side of childhood: contemplation and calm.`,
    },
    /* Portraiture */

    /* Sport */
    {
        paintingId: 'SPO0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['SPO0103ES', 'SPO0103EN'],
    },
    {
        paintingId: 'SPO0103ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SPO0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0104.jpg/info.json`],
        headerText: `<h5>أنس الخربوطلي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>سوريا: الرياضة والمرح بدلاً من الحرب والخوف</i><br><br>في قرية الجينة السورية بالقرب من مدينة حلب، افتتح وسيم ساتوت مدرسة كاراتيه للأطفال. وما يجعل الأمر مميزًا هو تعلم الفتيات والفتيان المعاقين وغير المعاقين معًا. وتتراوح أعمارهم بين 6 و15 عامًا. ويريد ساتوت من خلال مدرسته خلق شعور بالانتماء للمجتمع والتغلب على أي صدمات حرب في أذهان الأطفال.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'SPO0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SPO0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0104.jpg/info.json`],
        headerText: `<h5>Anas Alkharboutli</h5>`,
        bodyText: `<b>EN</b> <i>Syria: Sport and Fun Instead of War and Fear</i><br><br>In the Syrian village of Aljiina, near the city of Aleppo, Wasim Satot has opened a karate school for children. What makes it special is that girls and boys with and without disabilities are taught together. They’re aged between six and 15 years old. With his school, Satot wants to create a sense of community and overcome any traumas of war in the minds of the children.`,
    },

    {
        paintingId: 'SPO0203',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['SPO0203ES', 'SPO0203EN'],
    },
    {
        paintingId: 'SPO0203ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SPO0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0203.jpg/info.json`],
        headerText: `<h5>باتريك ماينهاردت</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>Iron Fit كينيا</i><br><br>في مارس 2020، أوقفت كينيا جميع الأنشطة الرياضية لوقف انتشار فيروس كورونا، إلى جانب تدابير أخرى مثل إغلاق الحدود والمدارس وفرض حظر تجول ليلي. وبعد ستة أشهر، أعطت وزيرة الرياضة أمينة محمد الضوء الأخضر لاستئناف الرياضات التي لا تتطلب الاحتكاك الجسدي، مما سمح لعشاق اللياقة البدنية بالمشاركة في مسابقة Iron Fit Bodybuilding الثانية في نيروبي. وشارك مائة وثلاثون رياضيًا من جميع أنحاء شرق أفريقيا في هذا الحدث، وتضمن فئات مثل البيكيني والشكل واللياقة البدنية وكمال الأجسام.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'SPO0203EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SPO0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0203.jpg/info.json`],
        headerText: `<h5>Patrick Meinhardt</h5>`,
        bodyText: `<b>EN</b> <i>Iron Fit Kenya</i><br><br>In March 2020, Kenya halted all sporting activities to stop the spread of Covid-19, alongside other measures such as closing borders and schools, and imposing a nighttime curfew. Six months later, Sports Minister Amina Mohamed gave the green light for non-contact sports to resume, allowing fitness enthusiasts to participate in the second Iron Fit Bodybuilding competition in Nairobi. One hundred and thirty athletes from all across East Africa took part in this event, which included categories such as Bikini, Figure, Physique and Bodybuilding.`,
    },

    {
        paintingId: 'SPO0303',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['SPO0303ES', 'SPO0303EN'],
    },
    {
        paintingId: 'SPO0303ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SPO0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0303.jpg/info.json`],
        headerText: `<h5>فرزام صالح</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أسطح المنازل</i><br><br>في مارس 2020، ردًا على تفشي فيروس كورونا، أعلنت الحكومة الإيرانية الإغلاق الفوري لجميع الملاعب الرياضية والأندية الرياضية ومراكز التدريب في جميع أنحاء إيران. وبعد تنفيذ هذا الأمر، أخذ الرياضيون في إيران التدريب على أسطح منازلهم للحفاظ على درجة من لياقتهم البدنية والعقلية والبراعة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'SPO0303EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}SPO0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}SPO0303.jpg/info.json`],
        headerText: `<h5>Seyed Ali (Farzam) Saleh</h5>`,
        bodyText: `<b>EN</b> <i>Rooftop</i><br><br>In March 2020, in reaction to the Covid-19 outbreak, the Iranian government announced the immediate closure of all athletic venues, sports clubs and training centres across Iran. Following the implementation of this mandate, athletes in Iran took to training on the rooftops of their homes in order to maintain a degree of their physical and mental fitness and prowess.`,
    },

    {
        paintingId: 'SPO0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['SPO0401ES', 'SPO0401EN'],
    },
    {
        paintingId: 'SPO0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}SPO0401.jpg/info.json`,
        headerText: `<h5>ماريجو مادونا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>قوة الفتيات</i><br><br>فتاة صغيرة تستعرض مهاراتها في الغوص من جرف في جزيرة لوكروم في كرواتيا.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'SPO0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}SPO0401.jpg/info.json`,
        headerText: `<h5>Marijo Maduna</h5>`,
        bodyText: `<b>EN</b> <i>Girl Power</i><br><br>A young girl shows off her skills, diving from a cliff on the island of Lokrum in Croatia.`,
    },
    /* Sport */

    /* Still Life */
    {
        paintingId: 'STI0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STI0103ES', 'STI0103EN'],
    },
    {
        paintingId: 'STI0103ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STI0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0103.jpg/info.json`],
        headerText: `<h5>بيتر إلفيلد</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>تكوين الطبيعة الصامتة، لقطة على لوح مبلل</i><br><br>استخدمت في هذا المشروع، أشياء عادية، مثل الأواني الزجاجية والفواكه والزهور وطبقت أسلوب سائل الكولوديون للوح المبلل لتحويلها إلى شيء غير عادي. وبمجرد أن وجدت هدفي بدأت أتخيل كيف سيبدو عند طباعته. وتتطلب هذه العملية الخاصة الكثير من الصبر والتخطيط الدقيق للتكوين والإضاءة وأوقات التعريض. ويؤتي العمل الشاق ثماره عندما يجتمع كل شيء أخيرًا في لحظة سحرية فريدة واحدة بينما تشاهد الصورة تتطور ببطء أمام عينيك. ولا تحدث هذه اللحظة طوال الوقت، لكن عندما يحدث ذلك، تتبقى لك صورة فريدة من نوعها (لوحة).</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STI0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STI0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0103.jpg/info.json`],
        headerText: `<h5>Peter Eleveld</h5>`,
        bodyText: `<b>EN</b> <i>Still Life Composition, Shot on  Wet Plate</i><br><br>For this project I used ordinary objects, like glassware, fruits and flowers and applied the wet plate collodion technique to turn them into something extraordinary. Once I found my subject I started imagining how it will look printed. This particular process requires a lot of patience and careful planning of composition, lighting and exposure times. The hard work pays off when finally it all comes together in one unique, magical moment as you watch the photograph slowly develop in front of your eyes. This moment doesn’t happen all the time but when it does you’re left with one of a kind image (plate).`,
    },

    {
        paintingId: 'STI0202',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STI0202ES', 'STI0202EN'],
    },
    {
        paintingId: 'STI0202ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STI0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STI0202.jpg/info.json`],
        headerText: `<h5>بالوما رينكون</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>العيد المكسيكي</i><br><br>العيد المكسيكي هو احتفال بالثقافة المكسيكية من خلال فن الطهي وتقاليد الحرف اليدوية. وأجمع في هذه السلسلة، هذين العالمين معًا في تركيبات تمزج الطعام مع الخيال. وصفتي مصورًا مكسيكي منشأ، تشكل تأثيرات اللون والتركيبات والأضواء الساطعة والسلع المصنوعة يدويًا جزءًا مهمًا من أسلوبي. وتجمع صوري بين أطباق الطعام المكسيكية والمكونات مع الحرف اليدوية التقليدية والأدوات المحلية اليومية المعروفة. وتم تصوير هذه السلسلة في استوديو في مدريد، حيث أقيم.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STI0202EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STI0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STI0202.jpg/info.json`],
        headerText: `<h5>Paloma Rincon</h5>`,
        bodyText: `<b>EN</b> <i>Mexican Feast</i><br><br>Mexican Feast is a celebration of Mexican culture through its gastronomy and its handcraft traditions. In this series I bring these two worlds together in compositions that mix the edible with the imaginary. As a Mexican born photographer, the influences of colour, textures, bright lights and handmade goods form an important part of my style. My images juxtapose Mexican food platters and ingredients with traditional handcrafts and recognisable everyday local props. This series was shot in a studio in Madrid, where I am based.`,
    },

    {
        paintingId: 'STI0305',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STI0305ES', 'STI0305EN'],
    },
    {
        paintingId: 'STI0305ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STI0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0304.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0305.jpg/info.json`],
        headerText: `<h5>أليساندرو بوليو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الاهتمامات المتقلبة</i><br><br>الاهتمامات المتقلبة عبارة عن تحقيق مرئي وُلد وتطور خلال أول إغلاق وطني في ميلانو بإيطاليا. وتنبض الطبيعة الصامتة، التي تم إنشاؤها من خلال مزيج من الطعام أو الأشياء اليومية الأخرى المتاحة بسهولة في المنزل، بالحياة على سطح مطبخ خالٍ، وهو عنصر حاسم ومركزي في البيئة المنزلية. وتضيف الطبيعة المتغيرة للضوء واستخدام مناظير مختلفة نكهة فريدة للتركيبات، التي أصبحت ذكريات رئيسية للعزلة وتذكارات للحجر الصحي القسري.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STI0305EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STI0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0304.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STI0305.jpg/info.json`],
        headerText: `<h5>Alessandro Pollio</h5>`,
        bodyText: `<b>EN</b> <i>Volatile Interests</i><br><br>Volatile Interests is a visual investigation born and developed during the first national lockdown in Milan, Italy. The still lifes, created by the combination of food or other everyday objects easily available at home, come to life on a bare kitchen countertop, a crucial and central element of the domestic environment. The ever-changing nature of light and the use of different perspectives, add a unique flavour to the compositions, which become key memories of the isolation and mementos of the forced quarantine.`,
    },

    {
        paintingId: 'STI0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STI0401ES', 'STI0401EN'],
    },
    {
        paintingId: 'STI0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}STI0401.jpg/info.json`,
        headerText: `<h5>كاتا زيه</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>تذكار</i><br><br>خريف 2020... الجائحة، الإغلاق، العزلة، الذكريات...</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STI0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}STI0401.jpg/info.json`,
        headerText: `<h5>Kata Zih</h5>`,
        bodyText: `<b>EN</b> <i>Memento</i><br><br>Autumn of 2020... Pandemic, lockdown, solitude, memories...`,
    },
    /* Still Life */
    /* PRO & OPEN */

    /* Youth */
    {
        paintingId: 'YOU0101',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['YOU0101ES', 'YOU0101EN'],
    },
    {
        paintingId: 'YOU0101ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}YOU0101.jpg/info.json`,
        headerText: `<h5></h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>لا هروب من الواقع</i><br><br>صنعت هذه الصورة بفكرة تمثيل الشعور بأنك محاصر في لحظة، أو في واقع المرء. ورأيت الستائر في شكل نسيج من التسلسل المكاني الزمني، والتي فشلت هاتان اليدان في كسرهما. ويعطي الظل الذي تلقيه القضبان المتوازية على القماش أيضًا انطباعًا بوجود قفص، حيث يُحاصر الكيان إلى الأبد.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'YOU0101EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}YOU0101.jpg/info.json`,
        headerText: `<h5>Pubarun Basu</h5>`,
        bodyText: `<b>EN</b> <i>No Escape From Reality</i><br><br>I created this picture with the idea of representing the feeling of being trapped in a moment, or in one's own reality. I saw the curtains as the fabrics of the space-time continuum, which those two hands fail to break out of. The shadow cast by the parallel railings on to the fabric also gives the impression of a cage, in which the entity is trapped for eternity.`,
    },
    /* Youth */

    /* Students */
    {
        paintingId: 'STU0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STU0103ES', 'STU0103EN'],
    },
    {
        paintingId: 'STU0103ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0103.jpg/info.json`],
        headerText: `<h5>كوينراد هـ. تورلاج</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>المزارعون الشباب</i><br><br>ولدت في مزرعة في جنوب أفريقيا، ونشأت مع الماشية والخيول والحمير والدجاج، وما زلت أملك الكثير منها وأحبها حتى يومنا هذا. وتعتبر الزراعة مهنة مكثفة تتطلب شغفًا وتفانيًا حازمًا. وشرعت في تصوير الشباب الذين اختاروا هذه الحياة لأنهم، مثلي، يعتقدون أن لديهم مسؤولية. ويقع تأثير هذا كأنه حمل ثقيل على أكتافنا. وتعد جنوب أفريقيا أرضًا لا يمكن التنبؤ بها مع الجفاف الشديد، ومخاوف تتعلق بالسلامة والنزاعات حول ملكية الأراضي. وعلى الرغم من هذه التحديات، يعمل المزارعون الشباب لبناء مستقبل أكثر إنصافًا ومساواة للأمن الغذائي المستدام. وهم زملائي وأصدقائي وعائلتي، وهذا وقتنا لإطعام الوطن.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STU0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0103.jpg/info.json`],
        headerText: `<h5>Coenraad H Torlage</h5>`,
        bodyText: `<b>EN</b> <i>Young Farmers</i><br><br>I was born on a farm in South Africa, and grew up with cattle, horses, donkeys and chickens, many of which I still own and love to this day. Farming is an intense occupation that requires passion and unwavering dedication. I set out to photograph young people who choose this life because, like me, they believe they have a responsibility. This sits heavily on all of our shoulders. South Africa is an unpredictable land with severe droughts, safety concerns and debates around land ownership. Despite these challenges, young farmers are working toward a fairer and more equitable future of sustainable food security. They are my peers, my friends and my family, and this is our time to feed the nation.`,
    },

    {
        paintingId: 'STU0201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STU0201ES', 'STU0201EN'],
    },
    {
        paintingId: 'STU0201ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0202.jpg/info.json`],
        headerText: `<h5>كلوديا ماودرير</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أمس واليوم وغدًا</i><br><br>تشكل الأزياء المنتجة على نطاق واسع جزءًا مهمًا من النفايات الناتجة عن الثقافة الاستهلاكية، لكن يبذل الشباب جهودًا كبيرة لتشجيع معاصريهم لأن يكونوا أكثر وعياً بشأن النفايات، من خلال تشجيع إعادة التدوير وإعادة التصنيع وإعادة الاستخدام. ويهدف عملي إلى التقاط الأفكار حول هذا. ابتكرت مصممة الأزياء والرسامة الجنوب أفريقية لارا كلاويكوفسكي مجموعة من الملابس المصنوعة من قطع بلاستيكية معاد تدويرها ومعاد تصنيعها ومعاد استخدامها، بالإضافة إلى أجزاء من المواد الصناعية، مستوحاة من الزهور التي صورتها في حديقة كريستينبوش النباتية الوطنية.<br>وساهمت المنتجات البلاستيكية بمبلغ 76 مليار راند في اقتصاد جنوب أفريقيا في عام 2016، ووفقًا لتقرير صادر عن هيئة الصناعة البلاستيكية، يعمل ما يصل إلى 60 ألف شخص في الأعمال المتعلقة بالبلاستيك. تعتمد الموضة السريعة بشكل كبير على إنتاج البلاستيك الخام؛ ويقدر التقرير أن 63 في المائة من المواد المستخدمة في الملابس في عام 2015 كانت من البلاستيك الخام، في حين أن أقل من ثلاثة في المائة كانت من المواد المعاد تدويرها.<br>ويحتوي نبات الأمس واليوم والغد (Brunfelsia pauciflora) على أوراق شجر خضراء مورقة، مزينة بزهور عطرية يتغير لونها. وتتفتح الأزهار من خلال ثلاث دورات متغيرة اللون على مدار ثلاثة أيام. واخترت تسمية عملي نسبة إليها، لأنه لا يمكن تغيير الأمس، ولا يمكن عكس الضرر الناتج عن البلاستيك؛ ونطمح اليوم لأن نكون أفضل؛ وسنجري غدًا تغييرات بينما نستمر في التثقيف وإدراك الهدر.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STU0201EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0202.jpg/info.json`],
        headerText: `<h5>Claudia Mauderer</h5>`,
        bodyText: `<b>EN</b> <i>Yesterday, Today and Tomorrow</i><br><br>Mass-produced fashion forms a significant part of the waste created by consumer culture, but young people are making great efforts to encourage their contemporaries to be more mindful about waste, by promoting recycling, upcycling and reusing. My work aims to capture the ideas around this. South African fashion designer and illustrator Lara Klawikowski created a collection of garments made from recycled, upcycled and reused pieces of plastic, as well as offcuts of industrial material, inspired by flowers I photographed in Kirstenbosch National Botanical Garden.<br>Plastic products contributed R76 billion to South Africa’s economy in 2016 and, according to a report by the industry body Plastics SA, up to 60,000 people work in plastics-related businesses. Fast fashion relies enormously on virgin plastic production; the report estimates 63 per cent of the materials used for clothing in 2015 was virgin plastic, while less than three per cent was recycled material.<br>The yesterday-today-and-tomorrow plant (Brunfelsia pauciflora) has lush, green foliage, accentuated with aromatic blossom that changes in colour. The flowers bloom through three colour-changing cycles over a three-day period. I chose to name my work after it, because yesterday cannot be changed, nor can the impact damage from plastic be reversed; today we aspire to be better; tomorrow we will make changes as we continue to educate and be mindful of waste. `,
    },

    {
        paintingId: 'STU0301',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STU0301ES', 'STU0301EN'],
    },
    {
        paintingId: 'STU0301ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0302.jpg/info.json`],
        headerText: `<h5>لي يانان</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>اقتصاد البث المباشر</i><br><br>أدى النمو الهائل في خدمات البث المباشر إلى شكل من أشكال المبيعات عبر الإنترنت الذي أصبح الوسيلة الأساسية للتسويق في الصين. وعانت المتاجر خلال تفشي فيروس كورونا من انخفاضات هائلة في دخلها. ومع ذلك، أنشأ البث المباشر جسرًا بين التجار والمستهلكين، مستفيدًا من حالة الاتصال في جميع الأحوال الجوية وإلغاء المسافات وعدم وجود تلامس. ولم يقتصر الأمر على إنشاء قنوات مبيعات جديدة للصناعات التقليدية فحسب، بل عوض أيضًا عن الخسائر التي تكبدها نقص المبيعات وجهًا لوجه. ويُعد اقتصاد البث المباشر دليلاً على قدرة جيلي على الابتكار والاستفادة من وضعنا.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STU0301EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0302.jpg/info.json`],
        headerText: `<h5>Li Yanan</h5>`,
        bodyText: `<b>EN</b> <i>Live Stream Economy</i><br><br>The exponential growth in live streaming has resulted in a form of online sales that has become the primary means of marketing in China. During the Covid-19 outbreak, shops suffered huge declines in their incomes. However, live streaming created a bridge between merchants and consumers, taking advantage of its all-weather, zero distance, no contact status. Not only did it create new sales channels for traditional industries but also it made up for the losses sustained by the lack of face-to-face sales. The live stream economy is proof of my generation’s ability to innovate and take advantage of our situation.`,
    },

    {
        paintingId: 'STU0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STU0401ES', 'STU0401EN'],
    },
    {
        paintingId: 'STU0401ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0401.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0402.jpg/info.json`],
        headerText: `<h5>توماس هينج</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>وجوه مستقبل الصحافة</i><br><br>من مؤامرات الإنترنت الهامشية التي تشق طريقها إلى التيار الرئيسي إلى المسؤولين الحكوميين الذين يشجعون التخلي عن الثقة في وسائل الإعلام، أعتقد أننا نعيش في أحلك أوقات عصر المعلومات وأكثرها خطورة. والأمر متروك لنا جميعًا لتحمل عبء هذا الصراع، لكن الصحفيين على وجه الخصوص يجدون أنفسهم في الخطوط الأمامية. وغالبًا ما يتقاضى الصحفيون أجورًا منخفضة ويرهقون أنفسهم في العمل، ويقودهم شعور عميق بالهدف.<br>وأسلط الضوء من خلال هذا المشروع على الصحفيين الشباب والطامحين والعاملين من مختلف مناحي الحياة الذين اختاروا هذه المهنة رغم أعبائها ومخاطرها المحتملة. واختار هؤلاء الشباب تكريس حياتهم للسعي وراء الحقيقة، على أمل المساعدة في رفع مستوى الآخرين، وإعطاء صوت لأولئك الذين يتم تجاهلهم وتهميشهم.<br>ويعمل البعض في المدينة نفسها التي نشأوا فيها ويركزون على النهوض بمجتمعهم. وسافر آخرون من جميع أنحاء العالم لدراسة وممارسة الصحافة في الولايات المتحدة، متحلين بثقة كبيرة في سن مبكرة. وهم مختلفون بشكل كبير من حيث خلفياتهم وخبراتهم واهتماماتهم وتطلعاتهم للحياة. لكن القاسم المشترك الذي يربطهم هو تفانيهم الذي لا يتزعزع نحو الصحافة والاعتقاد بأنهم يستطيعون إحداث فرق في عملهم.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STU0401EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0401.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0402.jpg/info.json`],
        headerText: `<h5>Thomas Hengge</h5>`,
        bodyText: `<b>EN</b> <i>Faces of the Future of Journalism</i><br><br>From fringe internet conspiracies making their way into the mainstream to government officials encouraging the abandoning of trust in the media, I believe we are living through the information age’s darkest and most dangerous time. It is up to us all to shoulder the burden of this conflict, but journalists in particular find themselves on the frontline. Often underpaid and overworked, journalists are driven by a deep sense of purpose.<br>With this project, I am highlighting young, aspiring and working journalists from different walks of life, who have chosen this career despite its potential burdens and dangers. These young adults have chosen to dedicate their lives to the pursuit of truth, with the hope of helping to elevate others, and giving a voice to those who are overlooked and marginalised.<br>Some work in the same town in which they grew up, and focus on uplifting their community. Others travelled from across the world to study and practise journalism in the United States, taking a leap of faith at a young age. They are vastly different in their backgrounds, experiences, interests and outlooks on life. But the commonality that binds them is their unwavering dedication to journalism and the belief that they can make a difference with their work.`,
    },

    {
        paintingId: 'STU0501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STU0501ES', 'STU0501EN'],
    },
    {
        paintingId: 'STU0501ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0501.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0502.jpg/info.json`],
        headerText: `<h5>ماتياس أليخاندرو أكونيا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>حراس الجبل</i><br><br>كل عام، تلتهم النيران الآلاف من الغابات الأصلية حول العالم، مما يؤدي إلى نتائج كارثية. ويبحث هذا المشروع الزيادة في حرائق الغابات في باتاغونيا بالأرجنتين - انعكاس لتغير المناخ على مستوى العالم. وتعد المنطقة التي يمكنك العثور فيها على جبل بيلتريكيترون التي يبلغ ارتفاعه 2260 مترًا موطنًا لمجتمع مابوتشي الأصلي. ومثل أسلافهم، يرتبطون بالطبيعة، ويعيشون بدون كهرباء أو ماء نقي. وهم أول المستجيبين لأي حريق في الغابات، ويخاطرون بحياتهم، مستخدمين فقط أبسط المعدات، ويقاتلون للدفاع عن أراضيهم في درجات حرارة يمكن أن تصل إلى 60 درجة مئوية.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STU0501EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0501.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0502.jpg/info.json`],
        headerText: `<h5>Matias Alejandro Acuña</h5>`,
        bodyText: `<b>EN</b> <i>Guardians of the Mountain</i><br><br>Every year, thousands of native forests around the world are devoured by flames, with catastrophic results. This project looks at the increase in forest fires in Patagonia, Argentina – a reflection of climate change globally. The region in which the 2,260m-high Piltriquitrón can be found is home to the Mapuche indigenous community. Like their ancestors, they are connected to nature, and live without electricity or fresh water on tap. They are also the first responders to any forest fire, risking their lives, using only the most basic equipment, and fighting to defend their land in temperatures that can reach as high as 60°C.`,
    },

    {
        paintingId: 'STU0603',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STU0603ES', 'STU0603EN'],
    },
    {
        paintingId: 'STU0603ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0601.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0602.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0603.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0604.jpg/info.json`],
        headerText: `<h5>إيرين فاكويتي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>(من) أنا</i><br><br>وفقًا لمنظمة الصحة العالمية (WHO)، يؤثر نمو الاضطرابات النفسية على الصحة والاقتصاد في كل بلد. وفي أوروبا، يُقال إن واحدًا من كل ستة يعاني من اضطراب عقلي. وأكثر هذه الأنواع شيوعًا هو الاكتئاب، الذي يُقدر أنه يؤثر على 264 مليون شخص على الأقل في جميع أنحاء العالم. بالإضافة إلى ذلك، تشير التقديرات إلى أن 10-20% من المراهقين على مستوى العالم يعانون من حالات صحية عقلية، ومع ذلك لا تزال هذه الحالات غير مشخصة ولا يتم علاجها.<br>في إيطاليا، كان موضوع علم النفس بطيئًا في التعامل معه على محمل الجد؛ وتم تقديم أول دورتين دراسيتين للحصول على شهادة في هذا الموضوع مؤخرًا في عام 1971. ومع ذلك، سلطت جائحة فيروس كورونا الضوء على أهمية الموضوع: وفقًا لمسح أجراه معهد بيبولي للمجلس الوطني لنقابة علماء النفس، يعتقد الآن سبعة إيطاليين من أصل 10 (مقارنة باثنين من كل 10 في الاستطلاعات السابقة) أن شكلاً من أشكال الدعم النفسي الجماعي ضروري.<br>لبعض الوقت، كان عدد الطلبات المقدمة إلى كليات علم النفس في الجامعات في ازدياد، وتكشف أحدث الأرقام عن متوسط زيادة بنسبة 20% عن العام السابق. ويوضح هذا اهتمام زملائي بالموضوع، والتزامنا بإيجاد حلول يمكن أن تساعد في المرونة العاطفية للبلد والحفاظ على شبابها في المستقبل.<br>يعرض مشروعي، المقدم في شكل أرشيف، شبابًا إيطاليين تتراوح أعمارهم بين 20 و30 عامًا، يقدمون من خلال شهاداتهم صورة عامة عن المجتمع الحديث والصحة العقلية. وكما تقول منظمة الصحة العالمية، الصحة العقلية ليست مجرد غياب للاضطراب العقلي. ويتم تعريفه على أنه حالة صحية يدرك فيها كل فرد قدراته الخاصة، ويمكنه التعامل مع ضغوط الحياة العادية، ويمكنه العمل بشكل منتج، ويكون قادرًا على المساهمة في مجتمعه.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STU0603EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0601.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0602.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0603.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}STU0604.jpg/info.json`],
        headerText: `<h5>Irene Facoetti</h5>`,
        bodyText: `<b>EN</b> <i>(WHO) I Am</i><br><br>According to the World Health Organization (WHO), the growth of mental disorders impacts the health and economies of every country. In Europe, it is said that one in six suffers from a mental disorder. The most common of these is depression, which is estimated to affect at least 264 million people worldwide. In addition, it is estimated that 10-20% of adolescents globally experience mental health conditions, yet these remain underdiagnosed and undertreated.<br>In Italy, the subject of psychology was slow to be taken seriously; the first two degree courses in the subject were introduced as recently as 1971. However, the Covid-19 pandemic highlighted the topic’s importance: according to a survey conducted by the Piepoli Institute for the National Council of the Order of Psychologists, seven Italians out of 10 (compared to two out of 10 in previous surveys) now believe that some form of collective psychological support is essential.<br>For some time, the number of applications to psychology faculties at universities has been on the rise, and the most recent figures reveal an average increase of 20% on the previous year. This demonstrates my peers' interest in the subject, and our commitment to finding solutions that can aid the emotional resilience of the country and sustain its future young people.<br>My project, presented in the form of an archive, features young Italians between the ages of 20 and 30, who, through their own testimonies, provide a general picture of modern society and mental health. As the WHO states, ‘Mental health is not just the absence of mental disorder. It is defined as a state of well-being in which every individual realizes his or her own abilities, can cope with the normal stresses of life, can work productively, and is able to make a contribution to her or his community.’`,
    },

    {
        paintingId: 'STU0701',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STU0701ES', 'STU0701EN'],
    },
    {
        paintingId: 'STU0701ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0701.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0702.jpg/info.json`],
        headerText: `<h5>تايلا نيبسكي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أربعة جدران</i><br><br>تخضع إنجلترا لأقسى عملية إغلاق منذ مارس 2020. وعند التفكير في الطرق التي يغير بها معاصريّ العالم، اعتقدت أنه من الأهمية بمكان الاعتراف بالتجربة الأكثر عالمية التي نشاركها جميعًا: البقاء في المنزل. وعند التفكير في هذه الفكرة، فإن هذه الصور لمساحة نمت ملاحظتها وباتت مألوفة بشكل متزايد لي - منزلي.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STU0701EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0701.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0702.jpg/info.json`],
        headerText: `<h5>Tayla Nebesky</h5>`,
        bodyText: `<b>EN</b> <i>Four walls</i><br><br>England is in its toughest lockdown since March 2020. In considering the ways my contemporaries are changing the world, I thought it crucial to acknowledge the most universal experience we are all sharing: staying at home. Reflecting on this idea, these images are of a space I have grown increasingly observant of and familiar with – my home.`,
    },

    {
        paintingId: 'STU0802',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STU0802ES', 'STU0802EN'],
    },
    {
        paintingId: 'STU0802ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0801.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0802.jpg/info.json`],
        headerText: `<h5>ماتياس غارسيا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أصوات الأمازون - وايلا نونا</i><br><br>يروي مشروعي قصة مجتمع أصلي يعيش بين نهرين: إليكولين وجاتونياكو. تقع هذه المنطقة في منطقة الأمازون في الإكوادور، وقد عانت هذه المنطقة من التعدين وإزالة الغابات والممارسات السياحية السيئة التي لم تهدد المياه والنباتات والحيوانات فحسب، بل أيضًا المجتمعات التي تعيش فيها.<br>أردت أن أحكي قصة مجتمع كيشوا في سيرينا، الذي تولت نسائه قيادة الأنشطة الاقتصادية والاجتماعية، ونجحن في تفكيك نظامهن الأبوي وإنشاء تسلسل هرمي بقيادة النساء. وتتولى هؤلاء النسوة إعالة أسرهن وحماية بيئتهن، مع إعادة ابتكار الطريقة التي تتفاعل بها مجتمعات السكان الأصليين وتعمل داخل العالم الصناعي. وبمساعدة المنظمات الدولية والكيانات المحلية، طور مجتمع سيرينا ثقافة قائمة على الحفظ تعمل على تثقيف الأجيال الشابة والتأثير على العقليات الأجنبية، والأهم من ذلك، اتخاذ موقف من أجل موطنها وفلسفاتها ونظرتها للعالم. ونحن بحاجة إلى توصيل أصوات هذه المجتمعات، والاعتراف بفهمها للترابط الطبيعي واعتمادنا على الطبيعة. وهي تمثل أصوات المستقبل.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STU0802EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0801.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0802.jpg/info.json`],
        headerText: `<h5>Matias Garcia</h5>`,
        bodyText: `<i>The Voices of the Amazon – Waylla Nuna</i><br><br>My project tells the story of an indigenous community that lives between two rivers: the Ilikulin and the Jatunyacu. Located in Ecuador’s Amazon region, this area has suffered from mining, deforestation and poor touristic practises that have endangered not only water, flora and fauna but also the communities that inhabit it.<br>I wanted to tell the story of the Kichwa community of Serena, whose women have taken leadership of economic and societal activities, deconstructing their patriarchal system and creating a female-led hierarchy. These women provide for their families and protect their environment, while reinventing the way in which indigenous communities interact and function within the industrialised world. With the help of international organisations and local entities, the Serena community has developed a preservation-based culture that educates the younger generations, influences foreign mentalities and, most importantly, takes a stand for its home, its philosophies and its worldview. We need to raise the voices of such communities, and acknowledge their understanding of natural interconnection and our dependence on nature. They are the voices of the future.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'STU0901',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STU0901ES', 'STU0901EN'],
    },
    {
        paintingId: 'STU0901ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0901.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0902.jpg/info.json`],
        headerText: `<h5>هانا ديفي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الكل للجميع</i><br><br>رغم التحول الإيجابي نحو تحسين التنوع والشمولية في الإعلان والإعلام والفنون، لا تزال هناك فجوة في تمثيل الأشخاص المعاقين. وغالبًا ما يكون الأشخاص المعاقون مهمشين وغير مرئيين في وسائل الإعلام الرئيسية، ويمثلون 15 في المائة من سكان العالم ويحققون أكثر من 10 تريليون دولار من الدخل السنوي المتاح على مستوى العالم، وفقًا لتقرير عام 2020 الصادر عن ""Return on Disability"". ,تقول منظمة الصحة العالمية، ""يعد المعاقون هم من بين أكثر الفئات تهميشًا في العالم... تُفهم الإعاقة الآن كقضية من قضايا حقوق الإنسان. يتعرض الأشخاص للإعاقة بواسطة المجتمع، وليس فقط بواسطة أجسادهم.<br>في عام 2019، شاركت رائدة الأعمال في مجال الأزياء غريس ستراتون في تأسيس المؤسسة الرائدة المسماة All is for All. وتساعد هذه المبادرة العالمية الأولى الأشخاص المعاقين على تفصح الموضة وشراء المنتجات عبر الإنترنت. ونمت منذ ذلك الحين لتصبح وكالة مواهب واتصالات وإعلام، وكسرت الحدود وأوجدت التوازن، وخلقت مساحة مطلوبة للغاية للأشخاص المعاقين.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STU0901EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}STU0901.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}STU0902.jpg/info.json`],
        headerText: `<h5>Hannah Davey</h5>`,
        bodyText: `<b>EN</b> <i>All is for all</i><br><br>Despite the positive shift towards improved diversity and inclusivity in advertising, media and the arts, there remains a gap in the representation of people living with disabilities. Often marginalised and invisible in mainstream media, disabled people represent 15 per cent of the world’s population and globally have more than $10trillion in annual disposable income, according to a 2020 report by Return on Disability. The World Health Organization states, ‘People with disabilities are among the most marginalized groups in the world… Disability is now understood to be a human rights issue. People are disabled by society, not just by their bodies.’<br>In 2019, fashion entrepreneur Grace Stratton co-founded the groundbreaking enterprise, All is for All. This world-first initiative helps those with disabilities to navigate fashion and buy products online. It has since grown into a talent, communications and media agency, breaking boundaries and establishing balance, creating a much-needed space for those with disabilities.`,
    },
    /* Students */

    /* 2021 Latin America Competition: LATAM */
    {
        paintingId: 'LAT0101',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT0101ES', 'LAT0101EN'],
    },
    {
        paintingId: 'LAT0101ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAT0101.jpg/info.json`,
        headerText: `<h5>فاكوندو باليستا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>العشاء الأخير - 2008</i><br><br>انتحال العمل الأصلي لليوناردو دافنشي</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT0101EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAT0101.jpg/info.json`,
        headerText: `<h5>Facundo Ballesta</h5>`,
        bodyText: `<b>EN</b> <i>The Last Supper-2008</i><br><br>Appropriation of the original work of Leonardo da Vinci`,
    },

    {
        paintingId: 'LAT0102',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LAT0102.jpg/info.json`,
        headerText: `<h5>Facundo Ballesta</h5>`,
        bodyText: `<i>The drunks 2011</i><br><br>Appropriation of the original work Diego velazquez`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT0201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT0201ES', 'LAT0201EN'],
    },
    {
        paintingId: 'LAT0201ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0202.jpg/info.json`],
        headerText: `<h5>أليخاندرو بريتو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>لا للجدار الحدودي</i><br><br>على طول ما يقرب من 2000 ميل، تعبر الحدود بين الولايات المتحدة والمكسيك بعضًا من أكثر مناطق القارة تنوعًا بيولوجيًا. ويعد هذا النظام البيئي الهش موطنًا لمجموعة متنوعة من الثدييات والزواحف والطيور والنباتات. وتهاجر العديد من الأنواع بين المناطق الأحيائية في جنوب وشمال القارة، وستتأثر بشكل خاص إذا نفذت حكومة الولايات المتحدة خططها لإقامة جدار على طول الحدود مع المكسيك. ولن تقيد هذه البنية التحتية التحركات المحلية للحيوانات البرية فحسب، بل ستؤدي أيضًا إلى تجزئة موائلها وتعطيل طرق الهجرة التقليدية التي استخدمتها دائمًا.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT0201EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0202.jpg/info.json`],
        headerText: `<h5>Alejandro Prieto</h5>`,
        bodyText: `<b>EN</b> <i>No border wall</i><br><br>At nearly 2,000 miles long, the US-Mexico border traverses some of the continent’s most biologically diverse regions. This fragile ecosystem is home to a varied population of mammals, reptiles, birds and plants. Many species migrate between the biomes in the south and north of the continent, and will be particularly affected if the US government implements its plans to erect a wall along the border with Mexico. This infrastructure would not only restrict the local movements of wild animals but also fragment their habitats and interrupt the traditional migration routes they have always used.`,
    },

    {
        paintingId: 'LAT0301',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT0301ES', 'LAT0301EN'],
    },
    {
        paintingId: 'LAT0301ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0302.jpg/info.json`],
        headerText: `<h5>أليكس تريغو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>مجرة أتاكاما</i><br><br>يمكن العثور على أحلك السموات على هذا الكوكب في صحراء أتاكاما في شيلي. وتم صنع كل هذه الصور الفلكية تقريبًا هناك.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT0301EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0302.jpg/info.json`],
        headerText: `<h5>Alex Trigo</h5>`,
        bodyText: `<b>EN</b> <i>Atacama Galaxy</i><br><br>The darkest skies on the planet can be found in Chile’s Atacama Desert. Almost all of these astrophotographs were made there.`,
    },

    {
        paintingId: 'LAT0403',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT0403ES', 'LAT0403EN'],
    },
    {
        paintingId: 'LAT0403ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0401.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT0402.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT0403.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT0404.jpg/info.json`],
        headerText: `<h5>أندريا ألكالاي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>واجهة المبنى</i><br><br>الصور المعروضة هنا واجهات؛ وليس من المؤكد الغرض الذي تخدمه. هل هي موقع تصوير لفيلم أم معسكر تدريب للقوات الخاصة؟ وربما تكون أنقاضًا تم تثبيتها. في النهاية، لا يهم الغرض منها، لأن العمارة أصبحت مساحة فنية. ويشكل الضوء والظل هذه المساحة وينشئان المسرح. وتحاول الصور توسيع حدود التصوير والاستغناء عن التمثيل النقي. ويبدو كل شيء ممكنًا وتظهر القصص من الظل إلى الضوء الساطع.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT0403EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0401.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT0402.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT0403.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT0404.jpg/info.json`],
        headerText: `<h5>Andrea Alkalay</h5>`,
        bodyText: `<b>EN</b> <i>Facade</i><br><br>The images shown here are facades; it’s uncertain what purpose they serve. Are they a film set or a training camp for special forces? Perhaps they are ruins that have been secured. In the end, the purpose doesn't matter, because the architecture has become an art space. Light and shadow shape this space and generate the stage. The pictures try to expand the boundaries of photography and dispense pure representation. Everything seems possible and stories emerge from the shadows into the bright light.`,
    },

    {
        paintingId: 'LAT0501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT0501ES', 'LAT0501EN'],
    },
    {
        paintingId: 'LAT0501ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0501.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0501.jpg/info.json`],
        headerText: `<h5>أندريس توريس غاليانو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> مع تزايد الوفيات الناجمة عن القلق أو الاكتئاب كل عام، يمكن أن تكون عواقب العزلة الاجتماعية على الصحة العقلية والبدنية مميتة.<br><br>وفي العام الماضي، أجبر فيروس كورونا ملايين الأشخاص على العزلة في منازلهم. ووفقًا لدراسة Profamilia Solidaridad التي أجريت في كولومبيا، تتراوح أعمار الأشخاص الأكثر تضررًا من نوبات القلق أو الاكتئاب أثناء الجائحة بين 18 و33 عامًا.<br><br>وتعد Aislados (المنعزلون) قصة رمزية لظروف القلق والتوتر والاكتئاب والوحدة والملل التي نشأت من الحجر الصحي.<br><br>ونُفذت هذه السلسلة بين برشلونة وبوغوتا باستخدام الحجرة المظلمة كوسيلة للتحدث عن التغييرات التي نمر بها في تصور الزمان والمكان. وفي المقابل، يصبح ضوءها تشبيهًا للأمل الذي كان لدى كل شخص تم تصويره في العودة إلى الحياة الطبيعية.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT0501EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0501.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0501.jpg/info.json`],
        headerText: `<h5>Andrés Torres Galeano</h5>`,
        bodyText: `<b>EN</b> <i>Aislados</i><br><br>With deaths from anxiety or depression increasing each year, the consequences of social isolation on mental and physical health can be lethal.<br>Last year, Covid-19 forced millions of people to isolate in their homes. According to the Profamilia Solidaridad study carried out in Colombia, those most affected by episodes of anxiety or depression during the pandemic are aged between 18 and 33 years old.<br>Aislados (Isolated) is an allegory of the anxiety, stress, depression, loneliness and boredom that have arisen from quarantine.<br>I conducted this series between Barcelona and Bogotá by using the camera obscura as a vehicle to talk about changes we experience in the perception of time and space. In contrast, its light becomes an analogy of the hope each portrayed person had of returning to normal life.`,
    },

    {
        paintingId: 'LAT0601',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT0601ES', 'LAT0601EN'],
    },
    {
        paintingId: 'LAT0601ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0603.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0604.jpg/info.json`],
        headerText: `<h5>لولي لابوريو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>مواطن الغد</i><br><br>بدأ مشروع "مواطنو الغد" كمشروعي الشخصي أثناء الحجر الصحي. وهو عمل قيد التقدم يجمع العالم كما اعتدنا أن نعرفه وسلسلة من الصور الشخصية، تصف الوضع الطبيعي الجديد بطريقة دراماتيكية.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT0601EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0603.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0604.jpg/info.json`],
        headerText: `<h5>Loli Laboureau</h5>`,
        bodyText: `<b>EN</b> <i>Citizen of Tomorrow</i><br><br>Citizens of Tomorrow started as my personal project during the quarantine. It's a work in progress that combines the world as we used to know it and a series of portraits, describing the new normal in a dramatic way.`,
    },

    {
        paintingId: 'LAT0701',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT0701ES', 'LAT0701EN'],
    },
    {
        paintingId: 'LAT0701ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0701.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0702.jpg/info.json`],
        headerText: `<h5>فيليكس هيرنانديز</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>اللعب في المنزل</i><br><br>كان عام 2020 عامًا صعبًا للغاية للعديد من الأشخاص ولم نكن نحن المصورين الفوتوغرافيين التجاريين استثناءً.<br>ويمثل مشروع اللعب في المنزل مجموعة مختارة من بعض الصور التي أنتجتها في المنزل أثناء الإغلاق. وتم إنشاء الصور جميعها باستخدام نماذج مصغرة وإعدادات مصغرة قمت بإنشائها، بالإضافة إلى تصوير الأشياء الشائعة التي كنت في متناول اليد. وجربت تأثيرات مثل الماء والدخان، ولعبت بمنظور قسري والمستوى البؤري. وأنشأت أيضًا خلفيات مطبوعة للمشاهد المصغرة وطبقت بعض التأثيرات الرقمية.<br>وتتسم الصور بالإبداعية والتجريبية، وتجمع بين العالم التناظري والعالم الرقمي.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT0701EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0701.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0702.jpg/info.json`],
        headerText: `<h5>Félix Hernández</h5>`,
        bodyText: `<b>EN</b> <i>Playing in the house</i><br><br>2020 was a very difficult year for many people and we commercial photographers were no exception.<br>Playing in the House is a selection of some of the photographs I produced at home during lockdown. All were created using scale models and miniature settings that I made, as well as photographing common objects I had within reach. I experimented with effects such as water and smoke, and played with forced perspective and focus stacking. I also created printed backgrounds for the miniature scenes and applied some digital effects.<br>The images are creative and experimental, combining the analogue world with the digital world.`,
    },

    {
        paintingId: 'LAT0801',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT0801ES', 'LAT0801EN'],
    },
    {
        paintingId: 'LAT0801ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0801.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0802.jpg/info.json`],
        headerText: `<h5>فلورنس غوبيل</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>شيبيبو كونيبو: نباتات الشفاء</i><br><br>انتقلت بؤرة جائحة فيروس كورونا إلى منطقة الأمازون البيروفية، مما يعرض حياة سكان شيبيبو كونيبو الأصليين للخطر. وفي ديسمبر 2020، تم الإبلاغ عن أكثر من 209179 حالة مؤكدة و3106 حالة وفاة بواسطة إدارة الشعوب الأصلية في بيرو، بما في ذلك كبار السن وزعماء السكان الأصليين الذين ظهرت عليهم أعراض فيروس كورونا.<br>وفي مواجهة إهمال الحكومة بسبب نقص الرعاية الطبية وانهيار مستشفى الأمازون الوحيد، جمعت شيبيبو كونيبو مجموعة من الممرضات التقليديات، يُسمون ""Comando Matico""، لعلاج شعبهم باستخدام أدويتهم النباتية.<br>ويقول رونالد سواريز، رئيس منظمة السكان الأصليين Coshikox: ""النباتات لا تتركنا ولا نترك النباتات"". فقد رونالد والدته مؤخرًا ويقول إن موسوعة المعارف المرتبطة باستخدام النباتات والتنوع البيولوجي في منطقة الأمازون البيروفية تختفي في كل مرة يموت فيها أحد كبار السن. ومثل رونالد، يعتبر العديد من أفراد شيبيبو كونيبو هذا الوضع بمثابة إبادة جماعية بالتخلي عنهم.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT0801EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0801.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0802.jpg/info.json`],
        headerText: `<h5>Florence Goupil</h5>`,
        bodyText: `<b>EN</b> <i>Shipibo-Konibo: The Healing Plants</i><br><br>The epicenter of the Covid-19 pandemic has moved to the Peruvian Amazon, endangering the lives of the indigenous Shipibo-Konibo people. In December 2020, more than 209,179 confirmed cases and 3,106 deceased were reported by the Peruvian Department of Indigenous Peoples, including elders and indigenous leaders with the symptoms of Covid-19.<br>Faced with government negligence over the lack of medical care and the collapse of the only Amazonian hospital, the Shipibo-Konibo brought together a group of traditional nurses, named ‘Comando Matico’, in order to heal their people with the use of their plant-based medicines.<br>‘Plants don’t leave us and we don’t leave plants,’ states Ronald Suárez, president of the indigenous organisation Coshikox. Ronald recently lost his mother and states that an encyclopedia of knowledge linked to the use of plants and the biodiversity of the Peruvian Amazon disappears every time an elders dies. Like Ronald, many Shipibo-Konibo consider this situation as a genocide by abandonment.`,
    },

    {
        paintingId: 'LAT0901',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT0901ES', 'LAT0901EN'],
    },
    {
        paintingId: 'LAT0901ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0901.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0902.jpg/info.json`],
        headerText: `<h5>جوهيس ألاركون</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>لا زلت هنا</i><br><br>هذه قصة حياة يومية تستكشف عالم جيل الشباب من السكان الأصليين الذين يجدون أنفسهم قادرين بفضل ثقافتهم دون خوف من الاستعمار. وهؤلاء هم الشباب الذين قرروا البقاء في أرضهم مع عائلاتهم، وتطوير أسلوب حياة يجمع بين الحداثة ومعرفة الأجداد، رافضين ""التهجين من عرق مختلف"" بقوة هويتهم.<br>وفي الإكوادور، تبلغ نسبة السكان الأصليين حوالي 7% من السكان. وخلال القرن الماضي، لعبت العنصرية والتمييز دورًا كبيرًا في نموذج حياة أجبرت فيه عدم المساواة الكثيرين على الهجرة إلى المدينة، تاركين أراضيهم وثقافتهم. وقللت العولمة من قيمة هوية السكان الأصليين، لكنها في الوقت نفسه غذت مقاومة ثقافية لا يمكن التنبؤ بها بين شباب السكان الأصليين. وقرر هذا الجيل عدم الرحيل. ويبقون في مجتمعاتهم ويقودون الدفاع عن الأرض والثقافة، وينشئون طريقة أخرى للعيش والوجود.<br>وأوصت منظمة الصحة العالمية بالنظر إلى الشعوب الأصلية والمنحدرة من أصل أفريقي كحلفاء طبيعيين في مكافحة حالة الطوارئ الصحية العالمية. وتعتبر النظرة العالمية ومعرفة الأجداد حول الصحة موارد فورية لا تقدر بثمن، وتقدم أدلة حول كيفية بناء عالم ما بعد فيروس كورونا.<br>وعندما بدأت هذه القصة، عادت إلي ذكريات طفولتي: الجبال؛ ووجبات الأسرة وتلك الصباحات الباردة مع صوت الماء. وتتلاشى ذكرياتي أكثر فأكثر، لكن في هذا المجتمع، لن يسمح الشباب لهذه التجارب بأن تصبح شيئًا من الماضي.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT0901EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT0901.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT0902.jpg/info.json`],
        headerText: `<h5>Johis Alarcón</h5>`,
        bodyText: `<b>EN</b> <i>I am, still</i><br><br>This is a daily life story that explores the world of a young generation of indigenous people who find themselves empowered by their culture without the fear of colonialism. These are young people who have decided to stay in their land, with their families, and develop a lifestyle that combines modernity and ancestral knowledge, rejecting ‘mestizaje’ (interbreeding) with the strength of their identity.<br>In Ecuador, around 7% of the population is indigenous. During the last century, racism and discrimination played a lead role in a model of life where inequality forced many to migrate to the city, abandoning their territory and culture. Globalisation devalued indigenous identity but at the same time fuelled an unpredictable cultural resistance within the indigenous youth. This generation has decided not to leave. They stay in their communities, and lead the defence of the land and culture, creating another way of living and being.<br>The World Health Organization has recommended looking to indigenous and Afro-descendent peoples as natural allies in the fight against the global health emergency. The worldview and ancestral knowledge about health are immediate and invaluable resources, and give clues on how to build a post Covid-19 world.<br>When I started this story, my childhood memories came back to me: the mountains; the family meals; and those cold mornings with the sound of water. My memories become more and more blurred, but, in this community, the young people will not let these experiences become a thing of the past.`,
    },

    {
        paintingId: 'LAT1004',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT1004ES', 'LAT1004EN'],
    },
    {
        paintingId: 'LAT1004ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1001.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT1002.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT1003.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT1004.jpg/info.json`],
        headerText: `<h5>خوسيه لويس ريسيتي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الطلقات ومركبات مكافحة الشغب</i><br><br>أثناء احتجاجات شيلي في 2019-2020، المعروفة باسم ""الثورة الاجتماعية""، ألقى المتظاهرون زجاجات من الطلاء على سيارات مكافحة الشغب لتقييد رؤية السائقين. وتلتقط سلسلة صوري هذه البقع الملونة بأسلوب تصويري.<br><br>وتعد ""الطلقات"" نظيرًا للصور الملونة، التي تصور بقايا الخراطيش المفرغة. وجمعتها من ساحة باكيدانو في سانتياغو، وقمت بتصويرها على خلفية بيضاء نظيفة، لإضفاء طابع تحليلي جنائي.<br><br>وأدت هذه الأسلحة إلى إصابة أكثر من 460 شخصًا في شيلي بأضرار في أعينهم أو حتى الإصابة بالعمى.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT1004EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1001.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT1002.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT1003.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LAT1004.jpg/info.json`],
        headerText: `<h5>José Luís Rissetti</h5>`,
        bodyText: `<b>EN</b> <i>Vanilla and Anti-riot Vehicles</i><br><br>During the Chilean protests of 2019-2020, known as the ‘Social Outbreak’, protestors threw bottles of paint at riot control vehicles in order to restrict the drivers’ visibility. My series of images captures these coloured spots in a pictorial style.<br><br>As a counterpart to the colourful images are the ‘Vanillas’, which depict the residue of discharged pellet cartridges. I collected them in Plaza Baquedano, Santiago, and photographed them on a clean, white background, to give a forensic feel.<br><br>These weapons have resulted in more than 460 people in Chile sustaining damage to their eyes or even being blinded.`,
    },

    {
        paintingId: 'LAT1101',
        videoId: null,
        videoURL: null,

        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT1101ES', 'LAT1101EN'],
    },
    {
        paintingId: 'LAT1101ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1101.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1102.jpg/info.json`],
        headerText: `<h5>خوسيه ماريا بيريز</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>ليمبو</i><br><br>مكان بين الأماكن.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT1101EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1101.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1102.jpg/info.json`],
        headerText: `<h5>José María Pérez</h5>`,
        bodyText: `<b>EN</b> <i>Limbo</i><br><br>A place between places.`,
    },

    {
        paintingId: 'LAT1201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT1201ES', 'LAT1201EN'],
    },
    {
        paintingId: 'LAT1201ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1202.jpg/info.json`],
        headerText: `<h5>مورفي خيمينيز ميركادو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>(غير) الحقيقي</i><br><br>تنبع هذه الصور من مشاعر الخوف والحنين وعدم اليقين التي نشأت من الحجر الصحي. وباستخدام الصور من أرشيفي الخاص، ومطالبتي لأصدقائي وأولياء أمورهم بالتقاط صور شخصية، حولت هذه الصور الرقمية إلى صور سلبية مقاس 35 مم، ثم عرضتها على لوحة قماشية تبدو وكأنها شاشة محمولة. وهي تعطي فكرة أن ما نشهده ليس حقيقيًا - إنه فيلم، أو خيال، يستخدم المدينة كخلفية.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT1201EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1201.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1202.jpg/info.json`],
        headerText: `<h5>Morfi Jiménez Mercado</h5>`,
        bodyText: `<b>EN</b> <i>The (un)Real</i><br><br>These images arise from the feelings of fear, nostalgia and uncertainty that arose from the quarantine. Using images from my archive, and asking my friends and parents to take self-portraits, I converted these digital images into 35mm negatives, then projected them onto a canvas that has the appearance of a portable screen. It gives the idea that what we are experiencing is not real – that it is a movie, or a fiction, which uses the city as a backdrop.`,
    },

    {
        paintingId: 'LAT1301',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT1301ES', 'LAT1301EN'],
    },
    {
        paintingId: 'LAT1301ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1302.jpg/info.json`],
        headerText: `<h5>رودريغو أليخاندو بالافيسينو إسكوبار</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>من ذاك؟</i></span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT1301EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1301.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1302.jpg/info.json`],
        headerText: `<h5>Rodrigo Alejando Palavecino Escobar</h5>`,
        bodyText: `<b>EN</b> <i>¿Quién es aquel?</i>`,
    },

    {
        paintingId: 'LAT1401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT1401ES', 'LAT1401EN'],
    },
    {
        paintingId: 'LAT1401ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1401.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1402.jpg/info.json`],
        headerText: `<h5>صوفيا لوبيز مانان</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>ماتت الطبيعة</i><br><br>الطبيعة كما نعرفها عبارة عن تكوين ثقافي. ونراها من خلال أفكارنا وخيالاتنا الجمالية.<br><br>ماتت الطبيعة، وإذا لم تكن ميتة بعد، فعلينا أن ندفن معناها ونضع حدًا نهائيًا لمفهوم رومانسي ومثالي يكسر ويصنف ويفصل ما هو متحد: الإنسان.<br><br>الطبيعة مصطلح معقد ولا نهاية له. ويمكن أن تكون مملكة الحيوان أو البكتيريا من حولنا أو الكون. ونسميها "أمنا" وكأنها إلهة مقدسة، فكرة مجردة تمتلك صفات بشرية.<br><br>ويمثل مشروع "ماتت الطبيعة" خزانة من الفضول، وهي مجموعة بصرية متنوعة لما نعرِّفه باسم الطبيعة. وتهدف رحلتي المرئية إلى مساعدتنا في إعادة التفكير في مفهومنا عن الطبيعة وخلق ترابط جديد بين كل الأشياء.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LAT1401EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1401.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1402.jpg/info.json`],
        headerText: `<h5>Sofia Lopez Manan</h5>`,
        bodyText: `<b>EN</b> <i>Nature is dead</i><br><br>Nature as we know it is a cultural construction. We view it through our ideas and aesthetic fantasies.<br><br>Nature is dead, and if it is not dead yet we should bury its meaning and put an end once and for all to a romantic and idealised concept that fragments, classifies and separates what is united: the human being.<br><br>Nature is a complex and endless term. It could be the animal kingdom, the bacteria around us, or the universe. We call it our ‘Mother’, as if it is a divine goddess, an abstract idea with human qualities.<br><br>Nature is Dead is a cabinet of curiosities, a diverse visual collection of what we define as nature. My visual journey aims to help us rethink our notion of nature and create a new interconnectedness between all things.`,
    },

    {
        paintingId: 'LAT1501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LAT1501ES', 'LAT1501EN'],
    },
    {
        paintingId: 'LAT1501ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1501.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1502.jpg/info.json`],
        headerText: `<h5>فيكتور مانويل زيا دياز</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'LAT1501EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LAT1501.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LAT1502.jpg/info.json`],
        headerText: `<h5>Victor Manuel Zea Díaz</h5>`,
        bodyText: null,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* 2021 Latin America Competition: LATAM */

    /* ALPHA FEMALE  */
    {
        paintingId: 'ALP0101',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP0101ES', 'ALP0101EN'],
    },
    {
        paintingId: 'ALP0101ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0101.jpg/info.json`,
        headerText: `<h5>أدريانا كولومبو</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP0101EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0101.jpg/info.json`,
        headerText: `<h5>Adriana Colombo</h5>`,
        bodyText: `<b>EN</b> <i>The World in my Hands</i><br><br>There is nothing more important than a child for a parent: the world is in his hands.`,
    },

    {
        paintingId: 'ALP0201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP0201ES', 'ALP0201EN'],
    },
    {
        paintingId: 'ALP0201ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0201.jpg/info.json`,
        headerText: `<h5>أناستاسيا زيرديفا</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP0201EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0201.jpg/info.json`,
        headerText: `<h5>Anastasia Zherdieva</h5>`,
        bodyText: `<b>EN</b> <i>Stand on Your Feet</i><br><br>When equestrian vaulting competitions were cancelled due to the pandemic, girls practised elements in the field instead.`,
    },

    {
        paintingId: 'ALP0301',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP0301ES', 'ALP0301EN'],
    },
    {
        paintingId: 'ALP0301ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0301.jpg/info.json`,
        headerText: `<h5>تشو تشيا جونغ</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP0301EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0301.jpg/info.json`,
        headerText: `<h5>Chou Chia Jung</h5>`,
        bodyText: `<b>EN</b> <i>New Taipei Metropolitan Park</i><br><br>New Taipei Metropolitan Park.`,
    },

    {
        paintingId: 'ALP0401',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP0401ES', 'ALP0401EN'],
    },
    {
        paintingId: 'ALP0401ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0401.jpg/info.json`,
        headerText: `<h5>إيما كولينز</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP0401EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0401.jpg/info.json`,
        headerText: `<h5>Emma Collins</h5>`,
        bodyText: `<b>EN</b> This shot was taken while we were staying in an old French farmhouse. It was dark and cool, with beautiful slivers of sunlight creeping through the shutters. The moment captures the relationship between my girls at a time when my younger daughter still hangs on to everything her older sister does.`,
    },

    {
        paintingId: 'ALP0501',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP0501ES', 'ALP0501EN'],
    },
    {
        paintingId: 'ALP0501ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0501.jpg/info.json`,
        headerText: `<h5>ف. ديليك أويار</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP0501EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0501.jpg/info.json`,
        headerText: `<h5>F. Dilek Uyar</h5>`,
        bodyText: `<b>EN</b> <i>Lake Tuz</i><br><br>An algae called dunaliella salina gives Lake Tuz in Ankara its pink colour in summer; it can be quite surreal. On the edge of the lake is an old fountain where the shepherds occasionally bring their herds during the day, before returning to their grazing. I was lucky to be there at just the right time.`,
    },

    {
        paintingId: 'ALP0601',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP0601ES', 'ALP0601EN'],
    },
    {
        paintingId: 'ALP0601ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0601.jpg/info.json`,
        headerText: `<h5>هيون جونغ كيم</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP0601EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0601.jpg/info.json`,
        headerText: `<h5>Heun Jung Kim</h5>`,
        bodyText: `<b>EN</b> <i>Tae Jung and Ha Ru 1</i><br><br>The Korean Baek-il party is a centuries-old tradition. It celebrates a child’s 100th day, and came into being because of Korea’s high infant mortality rate during the 18th century. On the 100th day, a family traditionally prays and gives food offerings to thank the Shaman Spirit of Childbirth for the child having survived this difficult period. During the celebration, parents dress their babies in the traditional Korean 'Hanbok', as worn by my niece Ha Ru in this image. Owing to the Covid-19 pandemic, relatives and friends joined in a video call to celebrate this memorable moment for my niece.<br>This portrait shows my younger sister, Tae Jung, celebrating this milestone with her daughter, and is an attempt to reflect on the vulnerability of life and the strength of motherhood during these unprecedented times.`,
    },

    {
        paintingId: 'ALP0701',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP0701ES', 'ALP0701EN'],
    },
    {
        paintingId: 'ALP0701ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0701.jpg/info.json`,
        headerText: `<h5>هويجي نوتر</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP0701EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0701.jpg/info.json`,
        headerText: `<h5>Hoije Nuuter</h5>`,
        bodyText: `<b>EN</b> <i>Back to the Beginning 3</i><br><br>The ball in this image was originally a Christmas decoration. I couldn’t find a pure matte-white ball in the shops, so I painted one instead, then took a series of images in a quarry, and made a composite of them in Photoshop.`,
    },

    {
        paintingId: 'ALP0801',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP0801ES', 'ALP0801EN'],
    },
    {
        paintingId: 'ALP0801ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0801.jpg/info.json`,
        headerText: `<h5>جادي لاف</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP0801EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0801.jpg/info.json`,
        headerText: `<h5>Jade Lv</h5>`,
        bodyText: `<b>EN</b> <i>Alone</i><br><br>I know I'm not alone. On the way to find the best view of Mount Gongga.`,
    },
    {
        paintingId: 'ALP0901',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP0901ES', 'ALP0901EN'],
    },
    {
        paintingId: 'ALP0901ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0901.jpg/info.json`,
        headerText: `<h5>جينغ شين</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP0901EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP0901.jpg/info.json`,
        headerText: `<h5>Jing Shen</h5>`,
        bodyText: `<b>EN</b> <i>Alone</i>`,
    },
    {
        paintingId: 'ALP1001',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP1001ES', 'ALP1001EN'],
    },
    {
        paintingId: 'ALP1001ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1001.jpg/info.json`,
        headerText: `<h5>كولاكوفا إيكاترينا</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP1001EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1001.jpg/info.json`,
        headerText: `<h5>Kulakova Ekaterina</h5>`,
        bodyText: `<b>EN</b> <i>Altay Spirit</i><br><br>Whisper of the wind, calmness of the Altai mountains, foggy peaks stretch along the horizon of the Kurai steppe. Her chest is filled by the breath of freedom, and her spirit flies over the fields along the mountains, following the wind. Her hands are lifted up by the overwhelming sense of reverence for Mother Nature.<br><br>This is a photo of a beautiful Altai girl in an authentic national costume. This photo is a part of my folk photo project, dedicated to the female portrait of the Nationalities of Russia. So that the memory of our cultures and identity does not disappear, in order to preserve the cultural heritage, in order to draw attention to the beauty, value and respect of each nationality, I convey this to the viewer, through art - a photo portrait, costume and everyday life, - and tell people about them.`,
    },

    {
        paintingId: 'ALP1101',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP1101ES', 'ALP1101EN'],
    },
    {
        paintingId: 'ALP1101ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1101.jpg/info.json`,
        headerText: `<h5>ميريا فيلابلانا</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP1101EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1101.jpg/info.json`,
        headerText: `<h5>Mireia Vilaplana</h5>`,
        bodyText: `<b>EN</b> <i>Masquerade III</i><br><br>This image is part of a series shot during the 2020 lockdown. Called 'Masquerade, a visual exploration of our true selves', it aims to explore photography’s particular ability to describe a historical moment in a conceptual form. Each photograph encourages the viewer to question the way in which we reveal ourselves to others. Has society turned into one big masquerade ball?`,
    },

    {
        paintingId: 'ALP1201',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP1201ES', 'ALP1201EN'],
    },
    {
        paintingId: 'ALP1201ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1201.jpg/info.json`,
        headerText: `<h5>تاتيانا نيموفا</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP1201EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1201.jpg/info.json`,
        headerText: `<h5>Tatyana Nemova</h5>`,
        bodyText: `<b>EN</b> <i>Swan Horse</i><br><br>An Andalusian horse.`,
    },

    {
        paintingId: 'ALP1301',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALP1301ES', 'ALP1301EN'],
    },
    {
        paintingId: 'ALP1301ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1301.jpg/info.json`,
        headerText: `<h5>سابرينا بانتانو</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALP1301EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}ALP1301.jpg/info.json`,
        headerText: `<h5>Sabrina Pantano</h5>`,
        bodyText: `<b>EN</b> <i>Nature Will Save Us</i><br><br>One day during lockdown, I was out walking with my niece. Suddenly, she slipped into a bush and used it as camouflage, as if to protect herself.`,
    },
    /* ALPHA FEMALE  */

    /* GRANT */
    /* GRANT: Professional */
    {
        paintingId: 'PRO0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['PRO0103ES', 'PRO0103EN'],
    },
    {
        paintingId: 'PRO0103ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PRO0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0103.jpg/info.json`],
        headerText: `<h5>روني بنهرت</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'PRO0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PRO0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0103.jpg/info.json`],
        headerText: `<h5>Ronny Behnert</h5>`,
        bodyText: `<i>Venezia: La Serenissima</i><br><br>This is a very personal project, which I started in 2012. Venice is my favourite city in the world, and I travel there at least four to six times a year in order to capture its hidden beauty. There is more to this unique city than its renowned tourist sights. It also has a vulnerable side, which is only visible to those who take a closer look behind its dusty curtain. I love to capture the atmospheric, morbid, majestic face of Venice seen by only a few people as they pass by on their way to the likes of Piazza San Marco, San Giorgio Maggiore or Ponte di Rialto.<br>This peaceful world is under threat. Tourism is a problem, but not the main problem. The water, which makes this place so special, is reclaiming the city. Every year, it rises higher during the monthly Aqua Alta (high tide) and, little by little, it is destroying the buildings.<br>The city is sinking by a few millimetres each year, with climate change being a big factor.<br>When I started taking photographs of Venice in 2012, I didn't even notice the high tide, because the water level did not reach most of the city’s buildings. Now, during a full moon and with a soft wind from the south, the water can reach levels of 140cm or higher. At some point during every visit over the past three years, I have had to wade through water to reach the places I wanted to go. Attempts by the Italian government to fight the problem have failed either through poor planning or high cost. The most recent project, known as MOSE, is at a standstill because of rising costs. It is, perhaps, the last chance to rescue Venice.<br>Although Venice isn’t big, I am still discovering new places, even after 20 visits, and I want to capture every fascinating corner of this extraordinary city before it is gone forever. Travelling and staying there is expensive, and I usually stay between eight and 13 days, in order to get the timing right for my images. Once the body of work is complete, I plan to stage an exhibition and make a photo book of my images, with the aim of keeping Venice alive, even if there comes a time when it no longer exists. `,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'PRO0203',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['PRO0203ES', 'PRO0203EN'],
    },
    {
        paintingId: 'PRO0203ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PRO0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0203.jpg/info.json`],
        headerText: `<h5>روبن هينش</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'PRO0203EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PRO0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0203.jpg/info.json`],
        headerText: `<h5>Robin Hinsch</h5>`,
        bodyText: `<i>Junglă</i><br><br>Most of the EU’s last remaining primeval forests are found in Romania. These old-growth forests are designated national parks and UNESCO World Heritage Sites, and are home to rare species such as bear, wolf, lynx and wildcat. However, they are under immediate threat from commercial and illegal logging, and from the risk of wildfires. Their eradication is Europe’s biggest and most critical nature conservation issue today, but almost nobody is taking notice, except for a few local activists and rangers, who are alarmed at the levels of violence illegal loggers are willing to use in order to steal wood.<br>That wood can end up anywhere across Europe, and is used for furniture, paper or building materials. If no action is taken now, many of these valuable forests will be gone within the next few years.<br>I would like to spend several weeks in northern Romania, investigating the areas where logging and fires are happening. Together with the local people, I want to develop a new photographic body of work that not only deals with the challenges that arise from the illegal activities but also brings attention to rich cultural environments such as, for example, the Maramureș region in the Carpathian mountains.<br>I would see this opportunity as a natural continuation of my existing work. In the past year I have worked on several projects tackling the topics of untamed economic growth and the ecological consequences.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },

    {
        paintingId: 'PRO0303',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['PRO0303ES', 'PRO0303EN'],
    },
    {
        paintingId: 'PRO0303ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PRO0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0304.jpg/info.json`],
        headerText: `<h5>سيزار ديزفولي</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'PRO0303EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}PRO0301.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0302.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0303.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}PRO0304.jpg/info.json`],
        headerText: `<h5>César Dezfuli</h5>`,
        bodyText: `<i>The Passengers</i><br><br>My project seeks to put a face to those who have had to migrate, analysing the impact that this form of movement has on the identity of migrants.<br>On 1 August, 2016, 118 people were rescued from a rubber boat drifting in the Mediterranean Sea, 20 nautical miles off the Libyan coast – just another of the hundreds of boats that have been rescued from this migratory route in recent years. In 2016 alone, 181,436 migrants were rescued safely, while 4,576 lost their lives at sea.<br>But who are the people behind these numbers? What are the identities of the victims and survivors of this journey?<br>In an attempt to put names and face to this reality, I photographed the 118 people who travelled on board this boat, minutes after their rescue. Their faces, their expressions and the marks on their bodies reflected the mood and physical state in which they found themselves after a long journey that had already marked their lives forever.<br>But that was just the beginning of this investigation that has continued to evolve ever since. I soon realised that, in those first portraits, the individuals lacked real identity. They were not themselves, but were instead people whose experiences had made them dilute their identities. Sometimes those identities had been hidden, because of fear, and in other cases they had been stolen because of abuse and humiliation.<br>Over the past three years, I have worked to locate these 118 people, who are now scattered throughout Europe, to understand and document their real identity, showing that all they needed was a peaceful context in order to flourish again.<br>To this day, I have met 63 of them, and I have located 105, in countries such as Italy, Germany, France, Spain, Belgium, Malta, Holland and Switzerland.<br>‘Passengers’ is ongoing, and the objective of receiving the Sony Professional Grant is to meet, photograph and interview the remaining people who were on the boat. The information and stories I plan to gather mean I will be able to disseminate the story of the boat and its ‘protagonists’ with sensitivity and accuracy.<br>My ultimate aim is that the stories will lead to a deeper understanding of the reasons why these people left their homes, and to increase empathy within our society. Although ‘Passengers’ has its basis in photography, it will be complemented by other materials such as maps, handwritten texts, physical objects, video and sound. For all this, I believe that with new Sony equipment I will be able to improve the project visually. The objective is to generate enough material to make this a multiplatform project, which can be distributed through the media, through exhibitions and in digital format, with a web documentary that is under development.<br>It is an in-depth project, which provides a new narrative in terms of documenting migration. Its development so far has generated interest from the public and I hope its impact will be enhanced once the project is finished.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },

    /* GRANT: Professional */

    /* GRANT: Students */
    {
        paintingId: 'GST0103',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['GST0103ES', 'GST0103EN'],
    },
    {
        paintingId: 'GST0103ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}GST0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0104.jpg/info.json`],
        headerText: `<h5>تشيب سكينغلي</h5>`,
        // bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'GST0103EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}GST0101.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0102.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0103.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0104.jpg/info.json`],
        headerText: `<h5>Chip Skingley</h5>`,
        bodyText: `<i>Swim</i><br><br>This two-year project focuses mainly on what attracts someone to the sea. I have spent most of my life just steps away from coastal waters, and belonging to a seafaring family has resulted in my being totally consumed by the feeling of being at one with the sea. This fascination with water has resulted in me travelling to many different coasts of Britain while turning my lens towards others’ relationships with the sea.<br>Far from being a ‘screensaver’ tropical ocean, the British waters have a raw and often harsh beauty. They are unlike any other in the world I have experienced.<br>Swimmers, divers, surfers and cold-water enthusiasts provide wide-ranging possibilities for portraits, and I anticipate there is plenty of scope for my idea to evolve. Attractions of the sea include mental release, combatting health problems, exercise and as a social activity. These portraits, in conjunction with images of the changing tides and swell, show the simple nature of being up against or as one with such a dominating force, in all its beautiful complexity. With these images, I aim to unlock some of the mystery of our attraction to water.<br>I am attempting to research the psychological link between humans and the water, along with the history of our relationship with it. This involves interviewing those whom I document, in order to obtain a greater understanding of what I am trying to create.<br></br>Furthermore, I have generated a booklet of images for my own use to reflect on the relationship between people and their relationship with the sea. This is proving to be a useful tool in helping to bring images together while also allowing me to recognise the images’ strengths and weaknesses. This has meant that I have been able to document the attitude of subjects in my images so far and then to connect paths into other environmental themes. A clear example of this is that of the push against climate change and how the  ever-changing landscape of the oceans educates us.<br>By taking this project further, I believe the documentation of selected individuals in this environment will educate and help generate a respect for the oceans, with the aim of instigating a behavioural change within society. Such change is sorely needed, as is drastic action to protect these waters, as well as showing the benefits of seas and oceans to humankind.<br>With the help of the Sony grant, I plan to shoot more subjects in the sea. With more specialist equipment, such as professional water housing, I will be able to create a stronger personal relationship with those I enter the water and swim with. Where I would have once had to stop short, to protect my camera, this grant will bring a whole new exciting perspective to my work.<br>Given that my project revolves around the seas of Britain, the harsh and unforgiving yet beautiful waves of winter have also stopped me in my tracks at times. With equipment such as a thicker-skinned wetsuit, I will be able to stay in the water for longer periods of time, being the first to enter and the last to get out. This grant would allow me to work with the 20-plus people I have in place and who are ready to be documented in a safe and effective manner after the Covid-19 lockdown has ended. The grant from Sony will allow me to reach these people and tell their stories, and in doing so produce an in-depth project that will give insight to those who choose a life on and in the water.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },

    {
        paintingId: 'GST0203',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['GST0203ES', 'GST0203EN'],
    },
    {
        paintingId: 'GST0203ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}GST0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0203.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0204.jpg/info.json`],
        headerText: `<h5>رياض عابدين</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'GST0203EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}GST0201.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0202.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0203.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}GST0204.jpg/info.json`],
        headerText: `<h5>Reyad Abedin</h5>`,
        bodyText: `<i>In Search of Lost Tune</i><br><br>Why do we feel that we belong in one particular place and not in others? Our sense of place and identity are intricately bound to one another. They coexist, as people come to identify with where they live, where their homes are, and where they truly belong. We hold narratives close, and memories of spaces and places shape us. I will be exploring the relationship between place and identity, and the role of place in social and psychological development. The bonds between place and identity can influence social structures, cultural practices and political actions.<br>Like so many groups of emigrants or internally displaced peoples who have tried to establish themselves in a new city or country, I moved away from my family 12 years ago. My hometown of Noakhali is in the southeast of Bangladesh, bordered by the Meghna estuary and the Bay of Bengal on its south side. This area is also significant in terms of British Colonial history of partition.<br>The district is located on the tidal floodplain of the Meghna River delta, and is characterised by flat land. The area is influenced by diurnal tidal cycles; the tidal fluctuations vary depending on the season and are most pronounced during monsoon season. People from this area regularly fall victim to climate change and river erosion. Thousands of homes are destroyed, then rebuilt. If those new homes are also swallowed up by flooding, their owners often move away permanently.<br>With my images, I will walk you through my memories and experiences of being a displaced person, by photographing my place, identity, my route and my home, to ultimately portray what home means to anyone who has to move – whether for reasons of climate change or partition.`,
        // urlLink1Label: ,
        // urlLink1: ,
    },
    /* GRANT: Students */
    /* GRANT */


    /* LATIN AMERICA */
    {
        paintingId: 'LA01P01',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA01P01.jpg/info.json`,
        headerText: `<h5>Edgar Asencios Miranda</h5>`,
        bodyText: `<b>ES</b> <i>Puyas de Raimondi</i>Puyas de Raimondi en el Áreas de Conservación Regional (ACR) Titankayocc. PERÚ<br>Es una imagen panorámica compuesta por 4 fotografías e iluminación puntual con una linterna.<br>Es el bosque de Puyas más grande de Sudamérica que lamentablemente sufre de incendios forestales cada año. Vive en zonas muy altas de la cordillera, vive 100 años y desprende hasta 6 millones de semillas en su vida, es parte de un ecosistema del cual se alimentan algunas aves como el colibrí gigante y murciélagos. Puede llegar a medir 12 metros de altura.`,
        // hasCarouselAsParent: 'Y',
        // carouselAnnotationSiblings: ['LA01P01SP'],
    },
    // {
    //     paintingId: 'LA01P01SP',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA01P01.jpg/info.json`,
    //     headerText: `<h5>Edgar Asencios Miranda</h5>`,
    //     bodyText: `<b>ES</b> <i>Puyas de Raimondi</i>Puyas de Raimondi en el Áreas de Conservación Regional (ACR) Titankayocc. PERÚ<br>Es una imagen panorámica compuesta por 4 fotografías e iluminación puntual con una linterna.<br>Es el bosque de Puyas más grande de Sudamérica que lamentablemente sufre de incendios forestales cada año. Vive en zonas muy altas de la cordillera, vive 100 años y desprende hasta 6 millones de semillas en su vida, es parte de un ecosistema del cual se alimentan algunas aves como el colibrí gigante y murciélagos. Puede llegar a medir 12 metros de altura.`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    // {
    //     paintingId: 'LA01P01EN',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA01P01.jpg/info.json`,
    //     headerText: `<h5>Edgar Asencios Miranda</h5>`,
    //     bodyText: ``,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },

    {
        paintingId: 'LA02P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA02P02SP', 'LA02P02EN'],
    },
    {
        paintingId: 'LA02P02SP',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA02P02.jpg/info.json`,
        headerText: `<h5>Pedro Jarque Krebs</h5>`,
        bodyText: `<b>ES</b> <i>Man of the forest</i><br><br>Hay tres especies de orangutanes en el mundo y las tres se encuentran en grave peligro de extinción, principalmente debido a la destrucción de sus hábitats en las selvas del sudeste asiático, que se utilizan para el cultivo de aceite de palma. Solo quedan 70.000 ejemplares en todo el mundo. Los humanos y los orangutanes comparten el 97% del genoma. Junto con los chimpancés y los gorilas, son nuestros parientes más cercanos en el mundo animal.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA02P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA02P02.jpg/info.json`,
        headerText: `<h5>Pedro Jarque Krebs</h5>`,
        bodyText: `<b>EN</b> <i>Man of the forest</i><br><br>There are three species of orangutans in the world, and all three are in serious danger of extinction, mainly because of the destruction of their habitats in the jungles of Southeast Asia, which are used for palm oil cultivation. Only 70,000 individuals remain worldwide. Humans and orangutans share 97% of the genome. Along with chimpanzees and gorillas, they are our closest relatives in the animal world.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA03P03',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA03P03ES', 'LA03P03EN'],
    },
    {
        paintingId: 'LA03P03ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA03P03.jpg/info.json`,
        headerText: `<h5>Uriel Montufar</h5>`,
        bodyText: `<b>ES</b> <i>Roscasiri</i><br><br>Tradicional ceremonia «Roscasiri» donde los tenientes gobernadores del distrito Pomata de la provincia de Chucuito en la región peruana de Puno, dan la bienvenida al año nuevo con una de las tradiciones más enraizadas del área Aymara.<br><br>La ceremonia consiste en cubrir a las nuevas autoridades comunitarias (tenientes gobernadores) con pan como símbolo de abundancia y para desearles buenos augurios en el nuevo año donde asumirán sus funciones.<br><br>Los atuendos están hechos del famoso pan Pomata, horneado en leña y conocido por su delicioso sabor. Se emplean más de 200 panes y llegan a pesar hasta 30 kilos, que los tenientes gobernadores cargan y bailan alrededor del pódium oficial. Si el teniente gobernador lleva muchos panes, significa que tendrá un año abundante y próspero.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA03P03EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA03P03.jpg/info.json`,
        headerText: `<h5>Uriel Montufar</h5>`,
        bodyText: `<b>EN</b> <i>Roscasiri</i><br><br>With the traditional &quot;Roscasiri&quot; ceremony, the lieutenant governors of the Pomata district, Chucuito province, Puno Region, Peru, welcomed the new year, highlighting one of the most deeply rooted customs of the Aymara area. This ceremony consists of covering the new communal authorities (lieutenant governors) with bread as a symbol of abundance and wishing them good omens for the coming year where they will assume their functions, these peculiar outfits are made with the famous Pomata bread, known for its delicious flavor and its thread shape, wood-fired for the occasion and whose cost ranges from four to five for one sol. In this year 2021, 10 lieutenant governors with their respective wives were sworn in in this section, the outfits are made with more than 200 of these breads, (some also put pantheons on it), weighing 30 kilos that each political authority has to carry dancing around the official podium accompanied by his lieutenant. The locals describe the threaded as a preview to see the agricultural campaign. If the lieutenants have a large number of decorations, it means that it will be a good year, and the bread also symbolizes the abundance of products they will have in the coming year.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA04P04',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA04P04ES', 'LA04P04EN'],
    },
    {
        paintingId: 'LA04P04ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA04P04.jpg/info.json`,
        headerText: `<h5>Melisa Reymundi</h5>`,
        bodyText: `<b>ES</b> <i>Urquiza Railway Line</i><br><br>Marzo de 2020. Ferrocarril Urquiza, Buenos Aires, Argentina.<br>Puede resultar tedioso y casi imposible viajar durante las horas pico, debido a la multitud y como todos desean llegar a su destino. La rutina diaria puede llevarnos a resentir el tren que nos acompaña todos los días. Por eso, una tarde en la estación, me paré en medio de un vagón vacío y quise darle al tren la imagen que se merece. Mi objetivo era plasmarlo desde adentro, desde un punto de vista estético, mostrando la variación de sus colores y sus rasgos mas característicos, los que lo hacen único, pero que no siempre se aprecian.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA04P04EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA04P04.jpg/info.json`,
        headerText: `<h5>Melisa Reymundi</h5>`,
        bodyText: `<b>EN</b> <i>Urquiza Railway Line</i><br><br>March, 2020. Urquiza Railway Line, Buenos Aires, Argentina.<br>You may find it tedious and almost impossible to travel during rush hours, because of the crowd and how everyone desires to reach their destination. The daily routine could lead us to resent the train which comes along with us every day. Thus, an afternoon at the train station, I kept waiting for an empty train to arrive. I stood in the middle of a wagon and I rendered the train the relevance it deserves. My goal was to capture it from inside, from the an aesthetic point of view, showing off the variation of its colors and its characteristic features, those which make it unique, but they are not always appreciated.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA05P05',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA05P05ES', 'LA05P05EN'],
    },
    {
        paintingId: 'LA05P05ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA05P05.jpg/info.json`,
        headerText: `<h5>Sebastian Carreras</h5>`,
        bodyText: `<b>ES</b> <i>New reality</i><br><br>el 2020 nos encontró atrapado en un encrucijada, la pérdida de libertad a manos de un diminuto enemigo`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA05P05EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA05P05.jpg/info.json`,
        headerText: `<h5>Sebastian Carreras</h5>`,
        bodyText: `<b>EN</b> <i>New reality</i><br><br>2020 found us locked in a crossroads, the loss of freedom at the hand of a diminishing enemy`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA06P06',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA06P06ES', 'LA06P06EN'],
    },
    {
        paintingId: 'LA06P06ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA06P06.jpg/info.json`,
        headerText: `<h5>Esteban Del Solar</h5>`,
        bodyText: `<b>ES</b> <i>Plátano</i><br><br>Tomé esta foto pues no siempre vemos la belleza en los objetos cotidianos.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA06P06EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA06P06.jpg/info.json`,
        headerText: `<h5>Esteban Del Solar</h5>`,
        bodyText: `<b>EN</b> <i>Plátano</i><br><br>A simple banana with beautifull dots over some paper.<br>I took this picture because its a beautifull fruit and we don't really aprecciate how amazing something as simple as a banana can be.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA07P07',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA07P07ES', 'LA07P07EN'],
    },
    {
        paintingId: 'LA07P07ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA07P07.jpg/info.json`,
        headerText: `<h5>Francisca Roura</h5>`,
        bodyText: `<b>ES</b> <i>Coqueta</i><br><br>La vida es un gran baile`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA07P07EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA07P07.jpg/info.json`,
        headerText: `<h5>Francisca Roura</h5>`,
        bodyText: `<b>EN</b> <i>Coqueta</i><br><br>Dancer`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA08P08',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA08P08ES', 'LA08P08EN'],
    },
    {
        paintingId: 'LA08P08ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA08P08.jpg/info.json`,
        headerText: `<h5>Ramón Rodriguez</h5>`,
        bodyText: `<b>ES</b> <i>Sanhattan</i><br><br>El distrito financiero de Santiago se conoce como Sanhattan, término acuñado en 1995 por el editor del diario La Nación, cuando comparó los rascacielos del barrio de El Golf con los de Manhattan. Con el tiempo, el término se abrió camino en el lenguaje común.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA08P08EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA08P08.jpg/info.json`,
        headerText: `<h5>Ramón Rodriguez</h5>`,
        bodyText: `<b>EN</b> <i>Sanhattan</i><br><br>Santiago’s financial district is known as Sanhattan – a term coined in 1995 by the editor of newspaper La Nación, when he compared the high-rise developments in the neighbourhood of El Golf with those of Manhattan. Over time, the term made its way into common parlance.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA09P09',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA09P09ES', 'LA09P09EN'],
    },
    {
        paintingId: 'LA09P09ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA09P09.jpg/info.json`,
        headerText: `<h5>Andrea Ortiz Diaz</h5>`,
        bodyText: `<b>ES</b> <i>Night in the Tatacoa Desert</i><br><br>En 2020 tuve la oportunidad de conocer el Desierto de la Tatacoa, ubicado en Villavieja Huila, la segunda zona más árida de Colombia. Llegué el 21 de diciembre para explorar con mi cámara este bello lugar, y descubrí que cualquier momento es perfecto para entender la geología de este paisaje. Sin embargo, la noche me pareció particularmente cautivadora; el hecho de encontrarme solo con la luz de la luna para hacer una imagen era un pensamiento persistente.Siempre he sentido la luz y la oscuridad como elementos fundamentales a la hora de imaginar y crear. Había imaginado muchas posibilidades visuales, en especial la relación entre cuerpo y paisaje; relación que llamó mi atención porque creo que la escala humana permite entrever la grandeza de un paisaje y la relación que tenemos con la naturaleza, y la fotografía de paisaje es parte de una serie que explora esta relación. Además, me interesaba conocer uno de los observatorios astronómicos más importantes de Colombia. Por cierto, el día en el que capturé esta imagen, Júpiter y Saturno volvían a alinearse después de 400 años.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA09P09EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA09P09.jpg/info.json`,
        headerText: `<h5>Andrea Ortiz Diaz</h5>`,
        bodyText: `<b>EN</b> <i>Night in the Tatacoa Desert</i><br><br>The Tatacoa Desert is an arid region of Colombia, near a small town called Villavieja.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA10P10',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA10P10ES', 'LA10P10EN'],
    },
    {
        paintingId: 'LA10P10ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA10P10.jpg/info.json`,
        headerText: `<h5>Esteban Toro</h5>`,
        bodyText: `<b>ES</b> <i>Mundari kids</i><br><br>Mundari es una de las últimas tribus nómadas que se han alejado del mundo moderno. Sin embargo, tienen acceso a diferentes tipos de armas que provienen de la ciudad. Utilizan sus armas para proteger a su ganado, que significa toda su vida entre sus familiares y amigos.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA10P10EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA10P10.jpg/info.json`,
        headerText: `<h5>Esteban Toro</h5>`,
        bodyText: `<b>EN</b> <i>Mundari kids</i><br><br>Mundari is one of the last nomadic tribes that have been away from the modern world. Nevertheless, they have access to different kind of weapons that come from the city. They use their weapons to protect their cattle, who mean their entire life among their relatives and friends.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA11P11',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA11P11.jpg/info.json`,
        headerText: `<h5>Luis Salazar</h5>`,
        bodyText: `<b>ES</b> Esta fotografía fue realizada con técnica bokeh, un esquema de iluminación butterfly, quise representar la inclusión mostrando un ser androgino, resaltando la pureza y suavidad de su cuerpo, fue capturada en un balcón con vista a la ciudad, a las 19:00 hrs.`,
        // hasCarouselAsParent: 'Y',
        // carouselAnnotationSiblings: ['LA11P11ES', 'LA11P11EN'],
    },
    // {
    //     paintingId: 'LA11P11ES',
    //     videoId: null,
    //     videoURL: null,
    //
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    // {
    //     paintingId: 'LA11P11EN',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA11P11.jpg/info.json`,
    //     headerText: `<h5>Luis Salazar</h5>`,
    //     bodyText: `<b>EN</b>`,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },

    {
        paintingId: 'LA12P12',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA12P12ES', 'LA12P12EN'],
    },
    {
        paintingId: 'LA12P12ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA12P12.jpg/info.json`,
        headerText: `<h5>Miguel Saenz de Viteri</h5>`,
        bodyText: `<b>ES</b> <i>Cotopaxi Volcano</i><br><br>Vía Láctea sobre el Volcán Cotopaxi.<br>Lo tomé el 21 de septiembre de 2020.<br>Estuve intentando hacer esta foto un año entero porque para nosotros, los ecuatorianos, el Cotopaxi es un lugar muy importante`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA12P12EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA12P12.jpg/info.json`,
        headerText: `<h5>Miguel Saenz de Viteri</h5>`,
        bodyText: `<b>EN</b> <i>Cotopaxi Volcano</i><br><br>Milky way over Cotopaxi Volcano.<br>I tooked in September 21, 2020.<br>I was trying for a hole year to take this picture, because for us, Ecuadorians, Cotopaxi it´s a very important place.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA13P13',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA13P13ES', 'LA13P13EN'],
    },
    {
        paintingId: 'LA13P13ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA13P13.jpg/info.json`,
        headerText: `<h5>Roberto Valdez</h5>`,
        bodyText: `<b>ES</b> <i>Sangay at night</i><br><br>Foto tomada en septiembre de 2020, buscando el mejor punto de vista del paisaje de lava de Sangay. Este es el punto más cercano y seguro para ver la actividad volcánica.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA13P13EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA13P13.jpg/info.json`,
        headerText: `<h5>Roberto Valdez</h5>`,
        bodyText: `<b>EN</b> <i>Sangay at night</i><br><br>Photo taken on September 2020, seeking at best point of view of the Sangay lava scape. This is the closest point and safe point to see the volcanic activity.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA13P14',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA13P14ES', 'LA13P14EN'],
    },
    {
        paintingId: 'LA13P14ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA13P14.jpg/info.json`,
        headerText: `<h5>Roberto Valdez</h5>`,
        bodyText: `<b>ES</b> <i>Sangay's active volcano</i><br><br>Foto tomada en enero de 2020, desde la ciudad de Macas en Ecuador. Macas es una ciudad nublada con lluvia casi todos los días. Esperé casi un año a que hiciera buen tiempo para tomar esta foto y ver la actividad volcánica.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA13P14EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA13P14.jpg/info.json`,
        headerText: `<h5>Roberto Valdez</h5>`,
        bodyText: `<b>EN</b> <i>Sangay's active volcano</i><br><br>Photo taken on January 2020, from Macas city on Ecuador. Macas is a cloudy city with almost everyday rain. Ill wait almost a year for a good weather to take this picture and see the volcanic activity.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA14P15',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA14P15.jpg/info.json`,
        headerText: `<h5>Beatriz Salas Buendía</h5>`,
        bodyText: `<b>ES</b> <i>Ojos rojos</i><br><br>Paloma, la libertad en el confinamiento, este año que vivimos encerrados.`,
    },

    {
        paintingId: 'LA15P16',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA15P16ES', 'LA15P16EN'],
    },
    {
        paintingId: 'LA15P16ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA15P16.jpg/info.json`,
        headerText: `<h5>Brian Mena Laureano</h5>`,
        bodyText: `<b>ES</b> <i>First Breath</i><br><br>Amanecer en las faldas del volcán Popocatépetl.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA15P16EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA15P16.jpg/info.json`,
        headerText: `<h5>Brian Mena Laureano</h5>`,
        bodyText: `<b>EN</b> <i>First Breath</i><br><br>Sunrise on the slopes of the Popocatépetl volcano.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA16P17',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA16P17ES', 'LA16P17EN'],
    },
    {
        paintingId: 'LA16P17ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA16P17.jpg/info.json`,
        headerText: `<h5>Pedro Augusto Meza</h5>`,
        bodyText: `<b>ES</b> <i>Prayer</i><br><br>Tomada en una tarde tranquila en un rescate de caballos.<br>Me senté con los caballos cuando terminaron de comer. El anochecer estaba casi sobre nosotros.<br>Este rancho está ubicado en Primo Tapia, Baja California, y es el único lugar en el que me he sentido seguro este año.<br>Así es como se ve y se siente esa seguridad`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA16P17EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA16P17.jpg/info.json`,
        headerText: `<h5>Pedro Augusto Meza</h5>`,
        bodyText: `<b>EN</b> <i>Prayer</i><br><br>Shot on a quiet afternoon at a horse rescue.<br>I sat down with the horses as they finished eating. Nightfall was almost upon us.<br>This ranch is located in Primo Tapia, Baja California, and it's the only place I have actually felt safe this year.<br>Here's what that safety looks and feels like.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA17P18',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA17P18ES', 'LA17P18EN'],
    },
    {
        paintingId: 'LA17P18ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA17P18.jpg/info.json`,
        headerText: `<h5>Christian Holz</h5>`,
        bodyText: `<b>ES</b> <i>He Never Came</i><br><br>Esta fotografía es parte de una serie llamada Wabi-Sabi: nada perdura, nada está completo y nada es perfecto. Estos son los tres elementos en los que se basa wabi-sabi. Es un concepto japonés (o un tipo de visión estética) que hace referencia a la belleza de lo imperfecto, lo incompleto y lo cambiante, aunque también se refiere a la belleza en las cosas modestas y humildes. La filosofía wabi-sabi es disfrutar del presente y encontrar paz y armonía en la naturaleza y en las pequeñas cosas, mientras se acepta pacíficamente el ciclo natural de crecimiento y declive.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA17P18EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA17P18.jpg/info.json`,
        headerText: `<h5>Christian Holz</h5>`,
        bodyText: `<b>EN</b> <i>He Never Came</i><br><br>This photograph is part of a series called Wabi-Sabi: Nothing lasts, nothing is complete, and nothing is perfect. These are the three elements upon which wabi-sabi is based. It is a Japanese concept (or a type of aesthetic vision) that refers to the beauty of the imperfect, the incomplete and the changeable, although it also refers to the beauty in modest and humble things. The wabi-sabi philosophy is to enjoy the present, and to find peace and harmony in nature and in small things, while peacefully accepting the natural cycle of growth and decline.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA18P19',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA18P19ES', 'LA18P19EN'],
    },
    {
        paintingId: 'LA18P19ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA18P19.jpg/info.json`,
        headerText: `<h5>Alexis Guevara</h5>`,
        bodyText: `<b>ES</b> <i>Frío Cálido</i><br><br>Un ecosistema de grandes cerros con pinos rodea la Laguna Larga en Los Azufres, México. Al amanecer, el agua desprende vapor que, debido a los minerales que se encuentran en la zona, genera una espesa niebla.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA18P19EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA18P19.jpg/info.json`,
        headerText: `<h5>Alexis Guevara</h5>`,
        bodyText: `<b>EN</b> <i>Frío Cálido</i><br><br>An ecosystem of large hills with pine trees surrounds the Laguna Larga in Los Azufres, Mexico. At sunrise, the water gives off steam, which, because of the minerals found in the area, generates a thick mist.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA19P22',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA19P20ES', 'LA19P20EN'],
    },
    {
        paintingId: 'LA19P20ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA19P20.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA19P21.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA19P22.jpg/info.json`],
        headerText: `<h5>Matías Alejandro Acuña</h5>`,
        bodyText: `<b>ES</b> <i>Guardians of the moutains</i><br><br>Cada año, miles de bosques nativos de todo el mundo son devorados por las llamas, con resultados catastróficos. Este proyecto analiza el aumento de los incendios forestales en la Patagonia, Argentina, un reflejo del cambio climático a nivel mundial. La región en la que se encuentra el Piltriquitrón de 2.260 m de altura es el hogar de la comunidad indígena mapuche. Al igual que sus antepasados, están conectados con la naturaleza y viven sin electricidad ni agua potable del grifo. También son los primeros en responder a cualquier incendio forestal, arriesgando sus vidas, utilizando solo el equipo más básico y luchando para defender su tierra en temperaturas que pueden alcanzar los 60°C.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA19P20EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA19P20.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA19P21.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA19P22.jpg/info.json`],
        headerText: `<h5>Matías Alejandro Acuña</h5>`,
        bodyText: `<b>EN</b> <i>Guardians of the moutains</i><br><br>Every year, thousands of native forests around the world are devoured by flames, with catastrophic results. This project looks at the increase in forest fires in Patagonia, Argentina – a reflection of climate change globally. The region in which the 2,260m-high Piltriquitrón can be found is home to the Mapuche indigenous community. Like their ancestors, they are connected to nature, and live without electricity or fresh water on tap. They are also the first responders to any forest fire, risking their lives, using only the most basic equipment, and fighting to defend their land in temperatures that can reach as high as 60°C.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA20P26',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA20P23ES', 'LA20P23EN'],
    },
    {
        paintingId: 'LA20P23ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA20P23.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA20P24.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA20P25.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA20P26.jpg/info.json`],
        headerText: `<h5>Matias Garcia</h5>`,
        bodyText: `<b>ES</b> <i>The Voices of the Amazon – Waylla Nuna</i><br><br>Mi proyecto cuenta la historia de una comunidad indígena que vive entre dos ríos: el Ilikulin y el Jatunyacu. Ubicada en la región amazónica de Ecuador, esta zona ha sufrido la minería, la deforestación y las malas prácticas turísticas que han puesto en peligro no solo el agua, la flora y la fauna si no también las comunidades que lo habitan.<br>Quería contar la historia de la comunidad Kichwa de Serena, cuyas mujeres han asumido el liderazgo de las actividades económicas y sociales, deconstruyendo su sistema patriarcal y creando una jerarquía liderada por mujeres. Estas mujeres mantienen a sus familias y protegen su medio ambiente, al tiempo que reinventan la forma en que las comunidades indígenas interactúan y funcionan dentro del mundo industrializado. Con la ayuda de organizaciones internacionales y entidades locales, la comunidad de Serena ha desarrollado una cultura basada en la preservación que educa a las generaciones más jóvenes, influye en las mentalidades extranjeras y, lo más importante, defiende su hogar, sus filosofías y su cosmovisión. Necesitamos alzar la voz de esas comunidades y reconocer su comprensión de la interconexión natural y nuestra dependencia de la naturaleza. Son las voces del futuro`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA20P23EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA20P23.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA20P24.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA20P25.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA20P26.jpg/info.json`],
        headerText: `<h5>Matias Garcia</h5>`,
        bodyText: `<b>EN</b> <i>The Voices of the Amazon – Waylla Nuna</i><br><br>My project tells the story of an indigenous community that lives between two rivers: the Ilikulin and the Jatunyacu. Located in Ecuador’s Amazon region, this area has suffered from mining, deforestation and poor touristic practises that have endangered not only water, flora and fauna but also the communities that inhabit it.<br>I wanted to tell the story of the Kichwa community of Serena, whose women have taken leadership of economic and societal activities, deconstructing their patriarchal system and creating a female-led hierarchy. These women provide for their families and protect their environment, while reinventing the way in which indigenous communities interact and function within the industrialised world. With the help of international organisations and local entities, the Serena community has developed a preservation-based culture that educates the younger generations, influences foreign mentalities and, most importantly, takes a stand for its home, its philosophies and its worldview. We need to raise the voices of such communities, and acknowledge their understanding of natural interconnection and our dependence on nature. They are the voices of the future.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA21P27',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA21P27ES', 'LA21P27EN'],
    },
    {
        paintingId: 'LA21P27ES',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA21P27.jpg/info.json`,
        headerText: `<h5>Dante Mogni</h5>`,
        bodyText: `<b>ES</b> <i>Luciano</i><br><br>Un hombre descansa desnudo en una habitación de hotel en Buenos Aires, cumpliendo su cuarentena. Fueron semanas difíciles, pero él estaba en un estado de paz cautivador, como si todo fuese solo un mal sueño`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA21P27EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}LA21P27.jpg/info.json`,
        headerText: `<h5>Dante Mogni</h5>`,
        bodyText: `<b>EN</b> <i>Luciano</i><br><br>A naked man rests in a Buenos Aires hotel room, serving his quarantine. His grandmother had died very recently, but he was in a state of absolute peace, as if it were all a bad dream. So much calmness in the midst of so much madness. I think about him almost every day.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA22P29',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA22P28ES', 'LA22P28EN'],
    },
    {
        paintingId: 'LA22P28ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA22P28.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA22P29.jpg/info.json`],
        headerText: `<h5>Alejandro Prieto</h5>`,
        bodyText: `<b>ES</b> <i>No border wall</i><br><br>Con casi 2,000 millas de largo, la frontera entre Estados Unidos y México atraviesa algunas de las regiones con mayor diversidad biológica del continente. Este frágil ecosistema alberga una variada población de mamíferos, reptiles, aves y plantas. Muchas especies migran entre los biomas en el sur y el norte del continente y se verán particularmente afectadas si el gobierno de Estados Unidos implementa sus planes para erigir un muro a lo largo de la frontera con México. Esta infraestructura no solo restringiría los movimientos locales de animales salvajes, sino que también fragmentaría sus hábitats e interrumpiría las rutas migratorias tradicionales que siempre han utilizado.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA22P28EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA22P28.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA22P29.jpg/info.json`],
        headerText: `<h5>Alejandro Prieto</h5>`,
        bodyText: `<b>EN</b> <i>No border wall</i><br><br>At nearly 2,000 miles long, the US-Mexico border traverses some of the continent’s most biologically diverse regions. This fragile ecosystem is home to a varied population of mammals, reptiles, birds and plants. Many species migrate between the biomes in the south and north of the continent, and will be particularly affected if the US government implements its plans to erect a wall along the border with Mexico. This infrastructure would not only restrict the local movements of wild animals but also fragment their habitats and interrupt the traditional migration routes they have always used.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA23P31',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA23P30ES', 'LA23P30EN'],
    },
    {
        paintingId: 'LA23P30ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA23P30.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA23P31.jpg/info.json`],
        headerText: `<h5>Alex Trigo</h5>`,
        bodyText: `<b>ES</b> <i>Atacama Galaxy</i><br><br>Los cielos más oscuros del planeta se encuentran en el desierto de Atacama de Chile. Casi todas estas astrofotografías se hicieron allí.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA23P30EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA23P30.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA23P31.jpg/info.json`],
        headerText: `<h5>Alex Trigo</h5>`,
        bodyText: `<b>EN</b> <i>Atacama Galaxy</i><br><br>The darkest skies on the planet can be found in Chile’s Atacama Desert. Almost all of these astrophotographs were made there.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA24P35',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA24P32ES', 'LA24P32EN'],
    },
    {
        paintingId: 'LA24P32ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA24P32.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LA24P33.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA24P34.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LA24P35.jpg/info.json`],
        headerText: `<h5>Andrea Alkalay</h5>`,
        bodyText: `<b>ES</b> <i>Facade</i><br><br>Las imágenes que se muestran aquí son fachadas; no se sabe para qué sirven. ¿Son un set de filmación o un campo de entrenamiento para fuerzas especiales? Quizás sean ruinas que se han asegurado. Al final, el propósito no importa, porque la arquitectura se ha convertido en un espacio de arte. La luz y la sombra dan forma a este espacio y generan el escenario. Las imágenes intentan ampliar los límites de la fotografía y dispensar pura representación. Todo parece posible y las historias emergen de las sombras hacia la luz brillante.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA24P32EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA24P32.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LA24P33.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA24P34.jpg/info.json`, `${CANTALOUPE_IMAGE_SERVER}LA24P35.jpg/info.json`],
        headerText: `<h5>Andrea Alkalay</h5>`,
        bodyText: `<b>EN</b> <i>Facade</i><br><br>The images shown here are facades; it’s uncertain what purpose they serve. Are they a film set or a training camp for special forces? Perhaps they are ruins that have been secured. In the end, the purpose doesn't matter, because the architecture has become an art space. Light and shadow shape this space and generate the stage. The pictures try to expand the boundaries of photography and dispense pure representation. Everything seems possible and stories emerge from the shadows into the bright light.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA25P37',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA25P36ES', 'LA25P36EN'],
    },
    {
        paintingId: 'LA25P36ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA25P36.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA25P37.jpg/info.json`],
        headerText: `<h5>Andrés Torres Galeano</h5>`,
        bodyText: `<b>ES</b> <i>Aislados</i><br><br>""Dado que las muertes por ansiedad o depresión aumentan cada año, las consecuencias del aislamiento social en la salud mental y física pueden ser letales.<br><br>El año pasado, Covid-19 obligó a millones de personas a aislarse en sus hogares. Según el estudio Profamilia Solidaridad realizado en Colombia, los más afectados por episodios de ansiedad o depresión durante la pandemia tienen entre 18 y 33 años.<br><br>Aislados es una alegoría de la ansiedad, el estrés, la depresión, la soledad y el aburrimiento que han surgido de la cuarentena.<br><br>Realicé esta serie entre Barcelona y Bogotá utilizando la cámara oscura como vehículo para hablar sobre los cambios que experimentamos en la percepción del tiempo y el espacio. Por el contrario, su luz se convierte en una analogía de la esperanza.<br><br>cada persona retratada tenía de volver a la vida normal"".`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA25P36EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA25P36.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA25P37.jpg/info.json`],
        headerText: `<h5>Andrés Torres Galeano</h5>`,
        bodyText: `<b>EN</b> <i>Aislados</i><br><br>With deaths from anxiety or depression increasing each year, the consequences of social isolation on mental and physical health can be lethal.<br><br>Last year, Covid-19 forced millions of people to isolate in their homes. According to the Profamilia Solidaridad study carried out in Colombia, those most affected by episodes of anxiety or depression during the pandemic are aged between 18 and 33 years old.<br><br>Aislados (Isolated) is an allegory of the anxiety, stress, depression, loneliness and boredom that have arisen from quarantine.<br><br>I conducted this series between Barcelona and Bogotá by using the camera obscura as a vehicle to talk about changes we experience in the perception of time and space. In contrast, its light becomes an analogy of the hope each portrayed person had of returning to normal life.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA26P39',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA26P38ES', 'LA26P38EN'],
    },
    {
        paintingId: 'LA26P38ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA26P38.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA26P39.jpg/info.json`],
        headerText: `<h5>Facundo Ballesta</h5>`,
        bodyText: `<b>ES</b> <i>The Last Supper-2008</i><br><br>Apropiación de la obra original de Leonardo da Vinci`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA26P38EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA26P38.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA26P39.jpg/info.json`],
        headerText: `<h5>Facundo Ballesta</h5>`,
        bodyText: `<b>EN</b> <i>The Last Supper-2008</i><br><br>Appropriation of the original work of Leonardo da Vinci`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA27P41',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA27P40ES', 'LA27P40EN'],
    },
    {
        paintingId: 'LA27P40ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA27P40.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA27P41.jpg/info.json`],
        headerText: `<h5>Félix Hernández</h5>`,
        bodyText: `<b>ES</b> <i>Playing in the house</i><br><br>2020 fue un año muy difícil para muchas personas y los fotógrafos comerciales no fuimos la excepción.<br>Jugando en la casa es una selección de algunas de las fotografías que hice en casa durante el encierro. Todos fueron creados utilizando modelos a escala y escenarios en miniatura que hice, además de fotografiar objetos comunes que tenía a mi alcance. Experimenté con efectos como el agua y el humo, y jugué con perspectiva forzada y apilamiento de enfoque. También creé fondos impresos para las escenas en miniatura y apliqué algunos efectos digitales.<br>Las imágenes son creativas y experimentales, combinando el mundo analógico con el mundo digital.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA27P40EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA27P40.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA27P41.jpg/info.json`],
        headerText: `<h5>Félix Hernández</h5>`,
        bodyText: `<b>EN</b> <i>Playing in the house</i><br><br>2020 was a very difficult year for many people and we commercial photographers were no exception.<br>Playing in the House is a selection of some of the photographs I produced at home during lockdown. All were created using scale models and miniature settings that I made, as well as photographing common objects I had within reach. I experimented with effects such as water and smoke, and played with forced perspective and focus stacking. I also created printed backgrounds for the miniature scenes and applied some digital effects.<br>The images are creative and experimental, combining the analogue world with the digital world.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA28P43',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA28P42ES', 'LA28P42EN'],
    },
    {
        paintingId: 'LA28P42ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA28P42.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA28P43.jpg/info.json`],
        headerText: `<h5>Florence Goupil</h5>`,
        bodyText: `<b>ES</b> <i>Shipibo-Konibo: The Healing Plants</i><br><br>El epicentro de la pandemia Covid-19 se ha trasladado a la Amazonía peruana, poniendo en peligro la vida de los indígenas Shipibo-Konibo. En diciembre de 2020, más de 209.179 casos confirmados y 3.106 fallecidos fueron reportados por el Departamento de Pueblos Indígenas del Perú, incluidos ancianos y líderes indígenas con los síntomas de Covid-19.<br>Ante la negligencia del gobierno por la falta de atención médica y el colapso del único hospital amazónico, el Shipibo-Konibo reunió a un grupo de enfermeras tradicionales, llamado 'Comando Matico', para curar a su gente con el uso de su planta. medicamentos a base de.<br>“Las plantas no nos dejan y nosotros no dejamos plantas”, afirma Ronald Suárez, presidente de la organización indígena Coshikox. Ronald perdió recientemente a su madre y afirma que una enciclopedia de conocimientos vinculados al uso de plantas y la biodiversidad de la Amazonía peruana desaparece cada vez que muere un anciano. Como Ronald, muchos Shipibo-Konibo consideran esta situación como un genocidio por abandono.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA28P42EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA28P42.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA28P43.jpg/info.json`],
        headerText: `<h5>Florence Goupil</h5>`,
        bodyText: `<b>EN</b> <i>Shipibo-Konibo: The Healing Plants</i><br><br>The epicenter of the Covid-19 pandemic has moved to the Peruvian Amazon, endangering the lives of the indigenous Shipibo-Konibo people. In December 2020, more than 209,179 confirmed cases and 3,106 deceased were reported by the Peruvian Department of Indigenous Peoples, including elders and indigenous leaders with the symptoms of Covid-19.<br>Faced with government negligence over the lack of medical care and the collapse of the only Amazonian hospital, the Shipibo-Konibo brought together a group of traditional nurses, named ‘Comando Matico’, in order to heal their people with the use of their plant-based medicines.<br>‘Plants don’t leave us and we don’t leave plants,’ states Ronald Suárez, president of the indigenous organisation Coshikox. Ronald recently lost his mother and states that an encyclopedia of knowledge linked to the use of plants and the biodiversity of the Peruvian Amazon disappears every time an elders dies. Like Ronald, many Shipibo-Konibo consider this situation as a genocide by abandonment.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA29P45',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA29P44ES', 'LA29P44EN'],
    },
    {
        paintingId: 'LA29P44ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA29P44.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA29P45.jpg/info.json`],
        headerText: `<h5>Johis Alarcón</h5>`,
        bodyText: `<b>ES</b> <i>I am, still</i><br><br>Esta es una historia de la vida diaria que explora el mundo de una generación joven de indígenas que se encuentran empoderados por su cultura sin el miedo al colonialismo. Son jóvenes que han decidido quedarse en su tierra, con sus familias, y desarrollarse un estilo de vida que conjuga modernidad y saberes ancestrales, rechazando el mestizaje con la fuerza de su identidad.<br>En Ecuador, alrededor del 7% de la población es indígena. Durante el último siglo, el racismo y la discriminación jugaron un papel protagonista en un modelo de vida donde la desigualdad obligó a muchos a migrar a la ciudad, abandonando su territorio y cultura. La globalización devaluó la identidad indígena pero al mismo tiempo alimentó una resistencia cultural impredecible dentro de la juventud indígena. Esta generación ha decidido no irse. Se quedan en sus comunidades y lideran la defensa de la tierra y la cultura, creando otra forma de vivir y ser.<br>La Organización Mundial de la Salud ha recomendado mirar a los pueblos indígenas y afrodescendientes como aliados naturales en la lucha contra la emergencia sanitaria mundial. La cosmovisión y el conocimiento ancestral sobre la salud son recursos inmediatos e invaluables, y dan pistas sobre cómo construir un mundo post Covid-19.<br>Cuando comencé esta historia, volvieron a mí los recuerdos de mi infancia: las montañas; las comidas familiares; y esas mañanas frías con el sonido del agua. Mis recuerdos se vuelven cada vez más borrosos, pero, en esta comunidad, los jóvenes no dejarán que estas experiencias se conviertan en cosa del pasado.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA29P44EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA29P44.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA29P45.jpg/info.json`],
        headerText: `<h5>Johis Alarcón</h5>`,
        bodyText: `<b>EN</b> <i>I am, still</i><br><br>This is a daily life story that explores the world of a young generation of indigenous people who find themselves empowered by their culture without the fear of colonialism. These are young people who have decided to stay in their land, with their families, and develop a lifestyle that combines modernity and ancestral knowledge, rejecting ‘mestizaje’ (interbreeding) with the strength of their identity.<br>In Ecuador, around 7% of the population is indigenous. During the last century, racism and discrimination played a lead role in a model of life where inequality forced many to migrate to the city, abandoning their territory and culture. Globalisation devalued indigenous identity but at the same time fuelled an unpredictable cultural resistance within the indigenous youth. This generation has decided not to leave. They stay in their communities, and lead the defence of the land and culture, creating another way of living and being.<br>The World Health Organization has recommended looking to indigenous and Afro-descendent peoples as natural allies in the fight against the global health emergency. The worldview and ancestral knowledge about health are immediate and invaluable resources, and give clues on how to build a post Covid-19 world.<br>When I started this story, my childhood memories came back to me: the mountains; the family meals; and those cold mornings with the sound of water. My memories become more and more blurred, but, in this community, the young people will not let these experiences become a thing of the past.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA30P47',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA30P46ES', 'LA30P46EN'],
    },
    {
        paintingId: 'LA30P46ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA30P46.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA30P47.jpg/info.json`],
        headerText: `<h5>José Luís Rissetti</h5>`,
        bodyText: `<b>ES</b> <i>Vanilla and Anti-riot Vehicles</i><br><br>""Durante las protestas chilenas de 2019-2020, conocidas como el 'Estallido social', los manifestantes arrojaron botellas de pintura a los vehículos antidisturbios para restringir la visibilidad de los conductores. Mi serie de imágenes captura estas manchas de colores en un estilo pictórico.<br><br>Como contrapartida a las coloridas imágenes están las 'Vanillas', que representan los residuos de cartuchos de perdigones descargados. Los recogí en la Plaza Baquedano, Santiago, y los fotografié sobre un fondo blanco y limpio, para darle un aire forense.<br><br>Estas armas han provocado que más de 460 personas en Chile sufran daños en los ojos o incluso ceguen"".`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA30P46EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA30P46.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA30P47.jpg/info.json`],
        headerText: `<h5>José Luís Rissetti</h5>`,
        bodyText: `<b>EN</b> <i>Vanilla and Anti-riot Vehicles</i><br><br>During the Chilean protests of 2019-2020, known as the ‘Social Outbreak’, protestors threw bottles of paint at riot control vehicles in order to restrict the drivers’ visibility. My series of images captures these coloured spots in a pictorial style.<br><br>As a counterpart to the colourful images are the ‘Vanillas’, which depict the residue of discharged pellet cartridges. I collected them in Plaza Baquedano, Santiago, and photographed them on a clean, white background, to give a forensic feel.<br><br>These weapons have resulted in more than 460 people in Chile sustaining damage to their eyes or even being blinded.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA31P49',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA31P48ES', 'LA31P48EN'],
    },
    {
        paintingId: 'LA31P48ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA31P48.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA31P49.jpg/info.json`],
        headerText: `<h5>José María Pérez</h5>`,
        bodyText: `<b>ES</b> <i>Limbo</i><br><br>Un lugar entre lugares.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA31P48EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA31P48.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA31P49.jpg/info.json`],
        headerText: `<h5>José María Pérez</h5>`,
        bodyText: `<b>EN</b> <i>Limbo</i><br><br>A place between places.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA32P51',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA32P50ES', 'LA32P50EN'],
    },
    {
        paintingId: 'LA32P50ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA32P50.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA32P51.jpg/info.json`],
        headerText: `<h5>Morfi Jiménez Mercado</h5>`,
        bodyText: `<b>ES</b> <i>The (un)Real</i><br><br>Estas imágenes surgen de los sentimientos de miedo, nostalgia e incertidumbre que surgieron de la cuarentena. Utilizando imágenes de mi archivo y pidiéndoles a mis amigos y padres que hicieran autorretratos, convertí estas imágenes digitales en negativos de 35 mm y luego las proyecté en un lienzo que tiene la apariencia de una pantalla portátil. Da la idea de que lo que estamos viviendo no es real, que es una película, o una ficción, que utiliza la ciudad como telón de fondo.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA32P50EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA32P50.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA32P51.jpg/info.json`],
        headerText: `<h5>Morfi Jiménez Mercado</h5>`,
        bodyText: `<b>EN</b> <i>The (un)Real</i><br><br>These images arise from the feelings of fear, nostalgia and uncertainty that arose from the quarantine. Using images from my archive, and asking my friends and parents to take self-portraits, I converted these digital images into 35mm negatives, then projected them onto a canvas that has the appearance of a portable screen. It gives the idea that what we are experiencing is not real – that it is a movie, or a fiction, which uses the city as a backdrop.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA33P53',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA33P52.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA33P53.jpg/info.json`],
        headerText: `<h5>Rodrigo Alejando Palavecino Escobar</h5>`,
        bodyText: `<b>ES</b> <i>¿Quién es aquel?</i><br><br>¿Quién es aquel, que aparece en las fotografías?, esta es la pregunta que me hago cada vez que revelo fotografías en el cuarto oscuro, en donde se hace visible un pasado difuso un presente confuso. La memoria transformada en objeto; como espejo que muestra a quien se le acerca. La fotografía juega un rol muy importante, porque hace visible los horrores vendados, un momento físico extraído de lugares profundo de este ser incognito. Es allí en donde nace la pregunta ¿Quién es aquel?`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',

    },

    {
        paintingId: 'LA34P55',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA34P54ES', 'LA34P54EN'],
    },
    {
        paintingId: 'LA34P54ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA34P54.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA34P55.jpg/info.json`],
        headerText: `<h5>Sofia Lopez Manan</h5>`,
        bodyText: `<b>ES</b> <i>Nature is dead</i><br><br>“La naturaleza tal como la conocemos es una construcción cultural. La vemos a través de nuestras ideas y fantasías estéticas.<br><br>La naturaleza está muerta, y si aún no está muerta debemos enterrar su significado y acabar de una vez por todas con un concepto romántico e idealizado que fragmenta, clasifica y separa lo unido: el ser humano.<br><br>La naturaleza es un término complejo e interminable. Podría ser el reino animal, las bacterias que nos rodean o el universo. La llamamos nuestra "Madre", como si fuera una diosa divina, una idea abstracta con cualidades humanas.<br><br>Nature is Dead es un gabinete de curiosidades, una colección visual diversa de lo que definimos como naturaleza. Mi viaje visual tiene como objetivo ayudarnos a repensar nuestra noción de naturaleza y crear una nueva interconexión entre todas las cosas"`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA34P54EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA34P54.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA34P55.jpg/info.json`],
        headerText: `<h5>Sofia Lopez Manan</h5>`,
        bodyText: `<b>EN</b> <i>Nature is dead</i><br><br>Nature as we know it is a cultural construction. We view it through our ideas and aesthetic fantasies.<br><br>Nature is dead, and if it is not dead yet we should bury its meaning and put an end once and for all to a romantic and idealised concept that fragments, classifies and separates what is united: the human being.<br><br>Nature is a complex and endless term. It could be the animal kingdom, the bacteria around us, or the universe. We call it our ‘Mother’, as if it is a divine goddess, an abstract idea with human qualities.<br><br>Nature is Dead is a cabinet of curiosities, a diverse visual collection of what we define as nature. My visual journey aims to help us rethink our notion of nature and create a new interconnectedness between all things.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'LA35P57',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA35P56.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA35P57.jpg/info.json`],
        headerText: `<h5>Victor Manuel Zea Díaz</h5>`,
        bodyText: null,
    },

    {
        paintingId: 'LA36P59',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LA36P58ES', 'LA36P58EN'],
    },
    {
        paintingId: 'LA36P58ES',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA36P58.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA36P59.jpg/info.json`],
        headerText: `<h5>Loli Laboureau</h5>`,
        bodyText: `<b>ES</b> <i>Citizen of Tomorrow</i><br><br>Ciudadanos del Mañana comenzó como mi proyecto personal durante la cuarentena. Es un trabajo en progreso que combina el mundo tal como lo conocíamos y una serie de retratos que describen la nueva normalidad de una manera dramática.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'LA36P58EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}LA36P58.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}LA36P59.jpg/info.json`],
        headerText: `<h5>Loli Laboureau</h5>`,
        bodyText: `<b>EN</b> <i>Citizen of Tomorrow</i><br><br>Citizens of Tomorrow started as my personal project during the quarantine. It's a work in progress that combines the world as we used to know it and a series of portraits that describes the new normal in a dramatic way.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     hasCarouselAsParent: 'Y',
    //     carouselAnnotationSiblings: ['', ''],
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: `<b>ES</b> `,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: `<b>EN</b> `,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    //
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     hasCarouselAsParent: 'Y',
    //     carouselAnnotationSiblings: ['', ''],
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: `<b>ES</b> `,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: `<b>EN</b> `,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    //
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     hasCarouselAsParent: 'Y',
    //     carouselAnnotationSiblings: ['', ''],
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: `<b>ES</b> `,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //         `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`],
    //     headerText: `<h5></h5>`,
    //     bodyText: `<b>EN</b> `,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    /* LATIN AMERICA */

    /* Wall Text */
    {
        paintingId: 'EXIWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['EXIWT01ES', 'EXIWT01EN'],
    },
    {
        paintingId: 'EXIWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>شكرا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> نشكرك على تجربة المعرض الافتراضي لجوائز سوني العالمية للتصوير الفوتوغرافي لعام 2021، ونأمل أن تكون قد استمتعت بالعرض.<br><br>هل يمكن أن تكون المصور الفوتوغرافي للعام القادم؟ تُفتتح مسابقة جوائز سوني العالمية للتصوير الفوتوغرافي لعام 2022 في 1 يونيو 2021. ولا تفوت فرصتك لتحظي بالتقدير لصورك الفوتوغرافية، وسجل اهتمامك بالمشاركة الآن.<br><br>worldphoto.org<br><br>تابعنا على INSTAGRAM:</span>`,
        annotationTextAlignment: 'right',
        instagramUrl: "https://www.instagram.com/worldphotoorg/?hl=en",
        facebookUrl: "https://www.facebook.com/WorldPhotographyOrganisation",
        linkedInIUrl: "https://www.linkedin.com/authwall?trk=bf&trkInfo=AQHIgmOqpQLEJQAAAXjE3mMgl0-0JfUOb8iZvRpl8zhZFyu9o6MYQM2EeTj7HEsw9FNhiJtV83-dIJPVv4OPiu2yuGrnsFB4EGN_tjzzeRxhs3BxUaHacE2gHNIr5J4QeJBuzUM=&originalReferer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fworld-photography-organisation",
        twitterUrl: "https://twitter.com/WorldPhotoOrg",
        ContactURL: "https://mailchi.mp/f310b271d90e/register-your-interest-to-the-2022-sony-world-photography-awards",

    },
    {
        paintingId: 'EXIWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Thank You</h5>`,
        bodyText: `<b>EN</b> Thank you for experiencing the Sony World Photography Awards 2021 virtual exhibition, we hope you enjoyed the display.<br><br>Could you be the next Photographer of the Year? The 2022 Sony World Photography Awards open 1st June, 2021. Don’t miss your chance to receive recognition for your photographs, register your interest now!<br>''worldphoto.org''<br><br>Follow us on the links below<br><br>Also, don’t miss your chance to receive recognition for your photographs, register your interest now on our Webstie link below:`,
        instagramUrl: "https://www.instagram.com/worldphotoorg/?hl=en",
        facebookUrl: "https://www.facebook.com/WorldPhotographyOrganisation",
        linkedInIUrl: "https://www.linkedin.com/authwall?trk=bf&trkInfo=AQHIgmOqpQLEJQAAAXjE3mMgl0-0JfUOb8iZvRpl8zhZFyu9o6MYQM2EeTj7HEsw9FNhiJtV83-dIJPVv4OPiu2yuGrnsFB4EGN_tjzzeRxhs3BxUaHacE2gHNIr5J4QeJBuzUM=&originalReferer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fworld-photography-organisation",
        twitterUrl: "https://twitter.com/WorldPhotoOrg",
        ContactURL: "https://mailchi.mp/f310b271d90e/register-your-interest-to-the-2022-sony-world-photography-awards",

    },

    {
        paintingId: 'WELWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['WELWT01ES', 'WELWT01EN'],
    },
    {
        paintingId: 'WELWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>مرحبا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> مرحبًا بكم في المعرض الافتراضي لجوائز سوني العالمية للتصوير الفوتوغرافي 2021. تضم الجوائز التي أنشأتها منظمة التصوير الفوتوغرافي العالمية وترعاها سوني أربع مسابقات: الاحترافية والمفتوحة والشباب والطلاب.<br><br>تسلط 150 صورة أو نحو ذلك التي تراها هنا الضوء على المصورين الأكثر موهبة وتفانيًا وإبداعًا الذين شاركوا في جوائز هذا العام. وقد شارك في المسابقات الأربع أكثر من 330 ألف صورة مقدمة من مصورين ينتمون إلى 220 دولة وإقليمًا.<br><br>أثناء تنقلك عبر هذا العرض الافتراضي، ستكتشف المشاركات النهائية من المسابقة الاحترافية، والفائزين بالفئة في المسابقة المفتوحة بالإضافة إلى العمل الفائز من قبل المصور الفوتوغرافي الطالب لهذا العام والمصور الفوتوغرافي الشاب لهذا العام. تأكد من الاستماع إلى الأوصاف الصوتية للسلسلة الاحترافية كعامل إضافي للاستمتاع بتجربتك للعرض.<br><br>سوف نعرض كذلك الفائزون بجائزة ألفا للسيدات وجائزة الفئة الاحترافية لأمريكا اللاتينية، وهما تمثلان أحدث مبادراتنا. وستستمتع أيضًا بأعمال مختارة من الفائزين بمنحة سوني للمحترفين والطلاب.<br><br>نأمل أن تستمتع بمشاهدة صور هذا العام وقدرتها على إثراء تصوراتنا وإسعادها وتغييرها. ويستطيع الجمهور على مدار العام الاستمتاع بمعرض السفر الافتراضي، حيث خصصت مناطق معينة غرفًا مخصصة ومنسقة بشكل خاص داخل العرض.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'WELWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Welcome</h5>`,
        bodyText: `<b>EN</b> Welcome to the Sony World Photography Awards 2021 virtual exhibition. Created by the World Photography Organisation and sponsored by Sony, the Awards has four competitions: Professional, Open, Youth and Student.<br><br>The 150 or so images you see here highlight the most talented, dedicated and creative photographers from this year’s Awards. More than 330,000 images were entered with photographers from across 220 countries and territories taking part across the four competitions.<br><br>As you travel through this virtual display, you’ll discover finalist entries from the Professional competition, the category winners in the Open competition plus the winning work by the Student Photographer of the Year and Youth Photographer of the Year. Make sure you listen to the audio descriptions of the Professional series to add to your experience of the display.<br><br>Winners of the Alpha Female Award and the Latin America Professional Award, our latest initiatives, are also on show. You’ll also enjoy selected works from the Sony Professional and Student Grant recipients.<br><br>We hope you enjoy viewing this year’s photographs and their power to inform, delight and alter our perceptions. Throughout the year audiences can enjoy our virtual traveling exhibition, where specific regions have dedicated, specially curated rooms within the display.`,
    },

    {
        paintingId: 'INTWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['INTWT01ES', 'INTWT01EN'],
    },
    {
        paintingId: 'INTWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>المسابقة الاحترافية والمفتوحة</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <b>المسابقة الاحترافية</b><br>تمثل المسابقة الاحترافية أهمية مشروع التصوير الفوتوغرافي. ويستطيع المصورون الفوتوغرافيون تقديم مجموعة عمل للمشاركة في واحدة من الفئات العشر. وتم تقديم أكثر من 145000 سلسلة هذا العام ووقع الاختيار على 100 مصور لإدراجهم في قائمة المرشحين النهائيين ضمن الفئات العشر. وتعلمنا السلسلة الذكية والمكثفة والكاشفة التي تلقت التقدير في المسابقة الاحترافية شيئًا جديدًا عن العالم من خلال عيون أعظم المصورين الفوتوغرافيين في عصرنا. ويتم اختيار مصور العام من بين الفائزين في الفئة ويتم منحه جائزة بقيمة 25000 دولار أمريكي، وعرض عمله على مستوى العالم ويتلقى مجموعة تصوير رقمي من سوني.<br><br><b>المسابقة المفتوحة</b><br>تم إرسال أكثر من 165000 مشاركة إلى المسابقة المفتوحة لهذا العام، والتي تدعو المصورين الفوتوغرافيين، الخبراء منهم والمبتدئين من مجموعة واسعة من الخلفيات، إلى إرسال صورهم الفردية الأكثر روعة إلى فئة من بين عشر فئات. وتتسم الصور التي حصدت التقدير بالثراء والتنوع في تألقها وتحتفي بالطبيعة الديمقراطية للتصوير الفوتوغرافي. ووضعنا هذا العام 130 مصورًا في قائمة المرشحين النهائيين، وأعلنا عن 10 فائزين في الفئات المختلفة في وقت سابق من هذا العام. ويتم اختيار مصور العام في المسابقة المفتوحة من بين الفائزين في الفئة ويتم منحه جائزة بقيمة 5000 دولار أمريكي وعرض عمله على مستوى العالم ويتلقى مجموعة تصوير رقمي من سوني. <br><br><b>مسابقة الطلاب</b><br>تكتشف مسابقة الطلاب المواهب الناشئة في التصوير الفوتوغرافي وتحتضن هؤلاء الأفراد لإثراء الوسط وتعزيزه. وتتاح المشاركة في المسابقة للمعاهد الأكاديمية في جميع أنحاء العالم، وطُلب من الطلاب تقديم مجموعة أعمال تدور حول موضوع "بناء مستقبل أفضل". ثم تم اختيار عشرة طلاب في قائمة المرشحين النهائيين وتم إعطاؤهم ملخصًا نهائيًا: لإرسال سلسلة حول "وقتنا". ويُمنح المصور الطالب الذي يفوز بالمسابقة هذا العام مجموعة تصوير رقمي من سوني لمعهده بقيمة 30000 يورو بالإضافة إلى عرض عمله على مستوى العالم.<br><br><b>مسابقة الشباب</b><br>تشجع مسابقة الشباب الجيل القادم من المصورين الفوتوغرافيين على تعزيز رؤيتهم. ومع الحفاظ على إثارة وديناميكية الوسيط ومساحة إبداعية حقيقية، كانت المسابقة مفتوحة للمشاركين الذين تتراوح أعمارهم بين 12 و19 عامًا لإرسال ما يصل إلى ثلاث صور تتعلق بموضوع معين كل شهر. وتضمنت الموضوعات التكوين والتصميم، والعالم الطبيعي والحياة البرية، وحياة الشوارع. وخلال المسابقة التي تستمر من يوليو إلى ديسمبر، يتم اختيار فائز وقائمة بالمرشحين النهائيين كل شهر للاحتفال بهم على موقعنا على الإنترنت وعلى منصات وسائل التواصل الاجتماعي. وحصل المصور الشاب لهذا العام، الذي وقع الاختيار عليه من بين هؤلاء الفائزين الستة شهريًا، على مجموعة وات تصوير رقمي من سوني، بالإضافة إلى عرض عمله على مستوى العالم.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'INTWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>PROFESSIONAL & OPEN COMPETITION</h5>`,
        bodyText: `<b>EN - PROFESSIONAL COMPETITION</b><br><br>The Professional competition represents the importance of the photographic project. Photographers could submit a body of work interpreting one of the ten categories. More than 145,000 series were submitted this year with 100 photographers shortlisted across the ten categories. Intelligent, intense and revealing, the acknowledged series in the Professional competition teach us something new about the world through the eyes of the greatest photographers of our time. Photographer of the Year is selected from the category winners and is awarded $25,000, global exposure and Sony digital imaging kit.<br><br><b>OPEN COMPETITION</b><br><br>More than 165,000 entries were submitted to this year’s Open competition, which calls on photographers – both established and emerging from a vast range of backgrounds – to submit their most striking single images into one of ten categories. The acknowledged images are rich and varied in their brilliance, celebrating the democratic nature of photography. This year 130 photographers made the shortlist, with 10 category winners announced earlier this year. Open Photographer of the Year is selected from the category winners and is awarded $5,000, global exposure and Sony digital imaging kit.<br><br><b>STUDENT COMPETITION</b><br><br>The Student competition discovers emerging talent in photography and embraces these individuals to enrich and further the medium. Open to academic institutions worldwide, students were asked to submit a body of work responding to the topic ‘Building a Better Future’. Ten shortlisted students were then chosen and given a final brief: to submit a series relating to ‘Our Time’. The Student Photographer of the Year is awarded €30,000 of Sony digital imaging kit for their institution plus global exposure.<br><br><b>YOUTH COMPETITION</b><br><br>The Youth competition encourages the next generation of photographers to nurture their vision. Keeping the medium exciting, dynamic and a space to be truly creative, the competition was open to 12-19 year olds to submit up to three images relating to a specific theme each month. Themes included Composition & Design, Natural World & Wildlife and Street Life. Running from July to December, each month a winner and shortlist was chosen celebrated on our website and social media platforms. The Youth Photographer of the Year, who was chosen from these six monthly winners, is given a range of Sony digital imaging kit, plus global exposure.`,
    },

    {
        paintingId: 'ARCWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ARCWT01ES', 'ARCWT01EN'],
    },
    {
        paintingId: 'ARCWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>العمارة والتصميم، المسابقة الاحترافية</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>العمارة، المسابقة المفتوحة</i><br><br>أردنا هنا أن نرى صورًا تعرض فن وعلم المباني والهياكل. وتم الترحيب في هذه الفئة بالصور الخارجية والداخلية ويستطيع المصورون تصوير هدفهم في ضوء واقعي أو من خلال نهج أكثر إبداعًا.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ARCWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Architecture, Open competition</h5>`,
        bodyText: `<b>EN - Architecture & Design, Professional competition</b><br>Here we wanted to see images showcasing the art and science of buildings and structures. Both exterior and interior images were welcomed here and photographers could depict their subject in a realistic light or through a more creative approach.`,
    },

    {
        paintingId: 'CREWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['CREWT01ES', 'CREWT01EN'],
    },
    {
        paintingId: 'CREWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>الإبداع، المسابقتان الاحترافية والمفتوحة</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> تم تشجيع المصورين على إبراز خيالهم في هذه الفئة. ومن أنماط طباعة الصور الزرقاء إلى التقنيات المتطورة، تم منح جائزة للإبداع. ومن الممكن أن يكون الموضوع متنوعًا ويمكن التلاعب بالصور بشكل كبير، طالما أن الصورة ليست زائفة أو مضللة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'CREWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Creative, Professional & Open competitions </h5>`,
        bodyText: `<b>EN</b> Photographers were encouraged to embrace their imagination in this category. From cyanotypes to cutting-edge techniques, creativity was rewarded. Subject matter could be varied and images could be heavily manipulated, as long as the image didn’t misrepresent or mislead.`,
    },

    {
        paintingId: 'PORWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['PORWT01ES', 'PORWT01EN'],
    },
    {
        paintingId: 'PORWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>مجموعة الأعمال، المسابقة الاحترافية</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> كانت هذه الفئة تستهدف المصورين الفوتوغرافيين الذين يريدون المشاركة بصور فردية في المسابقة الاحترافية. وأراد الحكام معرفة مدى اتساع نطاق عمل المصور الفوتوغرافي، لذلك قد تكون الصور غير مرتبطة بموضوع أو سرد وتنتمي إلى مجموعة متنوعة من السلاسل المختلفة. وحققت المشاركات التي سلطت الضوء على المهارات الفنية للمصور نجاحًا كبيرًا.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'PORWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Portfolio, Professional competition</h5>`,
        bodyText: `<b>EN</b> This category was aimed at photographers who wanted to enter single images into the Professional competition. Judges wanted to see the breadth of a photographer’s work, so imagery could be unrelated in subject matter or narrative and from a variety of different series. Submissions highlighting the photographer’s technical skills went far.`,
    },

    {
        paintingId: 'DOCWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['DOCWT01ES', 'DOCWT01EN'],
    },
    {
        paintingId: 'DOCWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>المشاريع الوثائقية، المسابقة الاحترافية</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> تبحث لجنة التحكيم عن أعمال واقعية أو إعلامية تدور حول موضوع مختار. ونالت المشاريع التي تقدم نظرة ثاقبة على قضية معاصرة أو تقدم قصة واقعية مع أخبار أو جدول أعمال للشؤون الجارية إعجاب لجنة التحكيم.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'DOCWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Documentary Projects, Professional competition</h5>`,
        bodyText: `<b>EN</b> Judges were looking for factual or informative bodies of work about a chosen subject. Projects offering insight into a contemporary issue or presenting a factual story with a news or current affairs agenda were liked by the judges.`,
    },

    {
        paintingId: 'ENVWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ENVWT01ES', 'ENVWT01EN'],
    },
    {
        paintingId: 'ENVWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>البيئة، المسابقة الاحترافية</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> كانت السلسلة التي عرضت البيئات المحيطة أو الظروف التي يعيش فيها شخص أو حيوان أو نبات أو يعمل فيها مثالية لهذه الفئة. وأشادت لجنة التحكيم بالعمل الذي تمتع بنهج فنون جميلة وتناول القضايا البيئية التي تؤثر على العالم في الوقت الحاضر.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ENVWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Environment, Professional competition </h5>`,
        bodyText: `<b>EN</b> Series that showcased the surroundings or conditions in which a person, animal, or plant lives or operates were ideal for this category. Work that had a fine art approach and addressed environmental issues affecting the world today was applauded by the judges.`,
    },

    {
        paintingId: 'LANWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LANWT01ES', 'LANWT01EN'],
    },
    {
        paintingId: 'LANWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>المناظر الطبيعية، المسابقتان الاحترافية والمفتوحة</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> شاركت في هذه الفئة المشاريع التي تعرض المساحات في العالم بجميع أنواعها، من اللقطات الجوية واسعة النطاق إلى المناظر الموحية بالألفة والدفء. زكان التركيز الأساسي على الجودة الجمالية للصور النهائية.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LANWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Landscape, Professional and Open competitions</h5>`,
        bodyText: `<b>EN</b> Projects showing spaces within the world in all their varieties, from large scale aerial shots to intimate views, were entered into this category. The main focus was on the aesthetic quality of the final images.`,
    },

    {
        paintingId: 'NWWWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NWWWT01ES', 'NWWWT01EN'],
    },
    {
        paintingId: 'NWWWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>العالم الطبيعي والحياة البرية، المسابقتان الاحترافية والمفتوحة</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> رحبت هذه الفئة بالتركيبات الجذابة التي تُظهر روح وسلوك الحياة البرية في كل أرجاء العالم. وتم الترحيب بصور التقريب الدقيق والصور المقربة للنباتات والحشرات التي غالبًا ما تمر دون أن يلاحظها أحد في هذه الفئة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'NWWWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Natural World & Wildlife, Professional and Open competitions</h5>`,
        bodyText: `<b>EN</b> This category welcomed compelling compositions showing the spirit and behaviour of wildlife around the planet. Macro and close-up photographs of the plants and insects that often go unnoticed were also welcomed in this category.`,
    },

    {
        paintingId: 'PORTWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['PORTWT01ES', 'PORTWT01EN'],
    },
    {
        paintingId: 'PORTWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>الصور الشخصية، المسابقتان الاحترافية والمفتوحة</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> كانت لجنة التحكيم تبحث عن صور مثيرة للاهتمام وأصلية وقوية ومثيرة للعواطف، وكان المقصود تفسير الفئة لأقصى درجة. وأرادت لجنة التحكيم رؤية صور تُظهر تشابهًا بالموضوع وتنقل التعبير والعاطفة و/أو الشخصية.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'PORTWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Portraiture, Professional and Open competitions</h5>`,
        bodyText: `<b>EN</b> Judges were looking for interesting, original, strong and evocative photographs, and the category was intended to be interpreted in its widest sense. Judges wanted to see images demonstrating a likeness to the subject and convey expression, emotion and / or personality.`,
    },

    {
        paintingId: 'SPOWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['SPOWT01ES', 'SPOWT01EN'],
    },
    {
        paintingId: 'SPOWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>الرياضة، المسابقة الاحترافية</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> ستندرج السلسلة التي تلتقط الشدة والعواطف والحركة لموضوع الرياضة المختار ضمن هذه الفئة. وسواء كان المصور يلتقط الصور للرياضيين المحترفين أو الهواة، فمن الممكن أن يكون التركيز على الرياضي أو الأجواء الرياضية، لكن يجب تقديم سرد قوي بنهج أو زاوية مختلفين عن الرياضة نفسها.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'SPOWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Sport, Professional competition</h5>`,
        bodyText: `<b>EN</b> Series that capture the intensity, emotions and action of the chosen sport subject would fit into this category. Whether capturing professional or amateur athletes, the focus could be on the sportsperson or the sport environment but a strong narrative needed to be presented with a different approach or angle on the sport itself.`,
    },

    {
        paintingId: 'STIWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['STIWT01ES', 'STIWT01EN'],
    },
    {
        paintingId: 'STIWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>الطبيعة الصامتة، المسابقة الاحترافية</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> تصور الطبيعة الصامتة، التي تمثل في الغالب مجموعة أو ترتيبًا للأشياء، موضوعًا جامدًا. ومن الممكن أن تكون المشاركات كلاسيكية أو مبتكرة. ونظرت لجنة التحكيم عن كثب في تفسير الموضوع (التكوين والإضاءة والتأطير) عند مشاهدة العمل.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'STIWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Still Life, Professional competition</h5>`,
        bodyText: `<b>EN</b> Often a group or an arrangement of objects, Still Life typically depicts inanimate subject matter. Submissions could be classic or innovative. Judges closely considered the interpretation of the subject (composition, lighting and framing) when viewing the work.`,
    },

    {
        paintingId: 'LATWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['LATWT01ES', 'LATWT01EN'],
    },
    {
        paintingId: 'LATWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>مسابقة أمريكا اللاتينية</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> للاحتفاء بأفضل عمل فوتوغرافي ديناميكي وملهم تم إنشاؤه حاليًا في أمريكا اللاتينية، أطلقت منظمة التصوير العالمية وسوني أمريكا اللاتينية جائزة الفئة الاحترافية لأمريكا اللاتينية. وتتاح المشاركة للحصول على الجائزة لجميع المصورين من دول أمريكا اللاتينية الذين يشاركون بمجموعات عمل (من خمس إلى عشر صور) في المسابقة الاحترافية.<br><br>كشفت الجائزة، التي تقدم للعام الثاني، عن بعض المصورين الأكثر إثارة للاهتمام والموهبين من المنطقة ووضعت أعمالهم على المسرح المحلي والعالمي.<br><br>فازت بالجائزة هذا العام أندريا ألكالاي. وتتلقى ألكالاي معدات تصوير رقمي من سوني وسوف تُعرض أعمالها من خلال معرض محلي إلى جانب السلسلة التي كانت مدرجة في الترشيحات النهائية لجائزة الفئة الاحترافية لأمريكا اللاتينية.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'LATWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Latin America Competition</h5>`,
        bodyText: `<b>EN</b> To celebrate the best dynamic and inspiring photographic work currently created in Latin America, the World Photography Organisation and Sony Latin America launched the Latin America Professional Award. The prize is open to all photographers from Latin American countries entering bodies of work (five to ten images) to the Professional competition.<br><br>Now in its second year, the prize has uncovered some of the most interesting and talented photographers from the region and put their work on a local as well as global stage.<br><br>Andrea Alkalay is this year’s winner. Alkalay receives Sony digital imaging equipment and exposure through a local exhibition alongside the shortlisted series in the Latin America Professional Award.`,
    },

    {
        paintingId: 'ALPWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['ALPWT01ES', 'ALPWT01EN'],
    },
    {
        paintingId: 'ALPWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>جائزة سوني ألفا للسيدات</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> تنبع جائزة ألفا للسيدات من مبادرة عالم سوني ألفا للسيدات، وتركز على إتاحة فرص للمصورات الفوتوغرافيات ومصورات الفيديو وصانعات الأفلام المحترفات للمساعدة في تعزيز صناعة أكثر ثراءً وتنوعًا حيث يستطيع جميع المبدعين تكوين أصوات وأعمال قوية.<br><br>وسعت جائزة ألفا للسيدات البرنامج عالميًا من خلال تكريم المصورات اللواتي شاركن في المسابقة المفتوحة لجائزة سوني العالمية للتصوير الفوتوغرافي. ومنذ إنشائها قبل عامين، عززت الجائزة واحتفلت بالتنوع الثري لوسيلة التصوير من منظور دولي.<br><br>فازت بالجائزة هذا العام أدريانا كولومبو. وتتلقى معدات تصوير رقمي من سوني وتُعرض أعمالها على مستوى عالمي من خلال حملة إعلامية مخصصة عبر الإنترنت.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'ALPWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Sony Alpha Female Award</h5>`,
        bodyText: `<b>EN</b> The Alpha Female Award stems from the Sony Alpha Universe’s Alpha Female initiative, which focuses on creating opportunities for female professional photographers, videographers, and filmmakers to help foster a richer, more diverse industry where all creators can build strong voices and bodies of work.<br><br>The Alpha Female Award has expanded the programme globally by recognising women photographers who have entered the Sony World Photography Award Open competition. Since its inception two years ago, the award has promoted and celebrated the rich diversity of the medium from an international perspective.<br><br>Adriana Colombo is this year’s winner. She receives Sony digital imaging equipment and worldwide exposure through a dedicated online media campaign.`,
    },

    {
        paintingId: 'SGWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['SGWT01ES', 'SGWT01EN'],
    },
    {
        paintingId: 'SGWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>منحة سوني</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> منحة سوني - المحترفون تم تقديم برنامج منحة سوني للمحترفين في عام 2016 لدعم وإتاحة فرص للمصورين الفرديين الذين يحظون بالتقدير في جوائز سوني العالمية للتصوير الفوتوغرافي. ويتلقى كل مستلم 7000 دولار أمريكي ويتم إقراضه معدات التصوير الرقمي من سوني التي يختارها (حسب التوافر) لتنفيذ مشروع شخصي أو طويل الأجل. يتم اختيار الفائزين من بين المتأهلين النهائيين المحترفين لجوائز سوني العالمية للتصوير الفوتوغرافي لعام 2020، وفاز بالجوائز هذا العام روبن هينش (ألمانيا) مع جونغلا، وروني بهنرت (ألمانيا) مع فينيتسيا - (بعنوان Perfect Imperfection (عيوب مثالية)) وسيزار ديزفولي (إسبانيا) عن سلسلته بعنوان Passengers (الركاب). <br><br>منحة سوني - الطلاب يُمنح لقب المساهمة البارزة في التصوير الفوتوغرافي في جوائز سوني العالمية للتصوير الفوتوغرافي إلى شخص كان له تأثير كبير على وسط التصوير الفوتوغرافي طوال حياته المهنية. فازت بجائزة هذا العام غراسيلا إتوربيدي. ولدت إتوربيدي في مكسيكو سيتي عام 1969، والتحقت بمركز الأفلام التابع للجامعة الوطنية المستقلة في المكسيك، لكنها سرعان ما انجذبت إلى فن التصوير الفوتوغرافي الساكن على خطى أستاذ الحداثة المكسيكي مانويل ألفاريز برافو. ومن عام 1970 إلى عام 1971 عملت كمساعدة لبرافو من خلال مرافقته في رحلاته المختلفة للتصوير الفوتوغرافي في جميع أرجاء المكسيك. عرضت إتوربيدي أعمالها في بعض أهم المتاحف في المكسيك والولايات المتحدة الأمريكية وأوروبا. وحصلت على العديد من الجوائز الدولية ونُشرت العديد من كتب أعمالها في بلدان مختلفة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'SGWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Sony Grant</h5>`,
        bodyText: `<b>EN - Sony Grant - Professional</b><br>The Sony Professional Grant programme was introduced in 2016 to further support and create opportunities for individual photographers recognised in the Sony World Photography Awards. Each recipient receives $7,000 (USD) and is loaned Sony digital imaging equipment of their choice (depending on availability) to pursue a personal or long-term project.<br><br>Chosen from the Professional finalists of the Sony World Photography Awards 2020, this year’s recipients are Robin Hinsch (Germany) with Junglă, Ronny Behnert (Germany) with Venezia - Perfect Imperfection and Cesar Dezfuli (Spain) with Passengers.<br><br><b>Sony Grant - Student</b><br>The Sony World Photography Awards’ Outstanding Contribution to Photography title is given to a person who has made a significant impact on the photographic medium throughout their career. This year’s recipient is Graciela Iturbide.<br><br>Born in Mexico City, in 1969 Iturbide enrolled in the Film Center of the Universidad Nacional Autonoma de Mexico but she was soon drawn to the art of still photography as practiced by the Mexican modernist master Manuel Alvarez Bravo. From 1970 to 1971 she worked as Bravo’s assistant accompanying him on his various photographic journeys throughout Mexico.<br><br>Iturbide has had exhibitions at some of the most important museums in Mexico, USA and Europe. She has received numerous international awards and many books of her work have been published in different countries.`,
    },

    {
        paintingId: 'NATWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['NATWT01ES', 'NATWT01EN'],
        // urlLink1Label: ,
        // urlLink1: ,
    },
    {
        paintingId: 'NATWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>América Latina</h5>`,
        // bodyText: `<b>ES</b> Para celebrar el mejor trabajo fotográfico dinámico e inspirador creado actualmente en América Latina, la Organización Mundial de Fotografía y Sony Latin America lanzaron el Latin America Professional Award. El premio está abierto a todos los fotógrafos de países latinoamericanos que ingresen cuerpos de trabajo (de cinco a diez imágenes) al concurso Profesional.<br><br>Ahora en su segundo año, el premio ha descubierto a algunos de los fotógrafos más interesantes y talentosos de la región y han puesto su trabajo en un escenario local y global.<br><br>Andrea Alkalay es la ganadora de este año. Alkalay recibe equipo de imagen digital de Sony y exposición a través de una exhibición local junto con la serie preseleccionada en el Latin America Professional Award.`,
        bodyText: `<b>ES</b> En esta sala podrás ver una selección muy próxima de imágenes hechas por fotógrafos de America Latina.<br><br>Destacados talentos de esta región de nuestra lista de preselección, finalistas y ganadores de Premios. Esta colección también incluye convocatorias de los Professional Latin America awards y los Latin America National Awards ganadores.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'NATWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Latin America</h5>`,
        bodyText: `<b>EN</b> In this viewing room you will see a specially curated selection of successful images submitted by photographers based in Latin America.<br><br>Highlighting the region's talent from the shortlists, finalists and winners across the Awards, this collection also includes successful entries from the Latin America Professional Award and the local National Awards winners.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },

    {
        paintingId: 'OCPWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['OCPWT01ES', 'OCPWT01EN'],
    },
    {
        paintingId: 'OCPWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>المسابقة البارزة في التصوير الفوتوغرافي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> يُمنح لقب المساهمة البارزة في التصوير الفوتوغرافي في جوائز سوني العالمية للتصوير الفوتوغرافي إلى شخص كان له تأثير كبير على وسط التصوير الفوتوغرافي طوال حياته المهنية. فازت بجائزة هذا العام غراسيلا إتوربيدي.<br><br>ولدت إتوربيدي في مكسيكو سيتي عام 1969، والتحقت بمركز الأفلام التابع للجامعة الوطنية المستقلة في المكسيك، لكنها سرعان ما انجذبت إلى فن التصوير الفوتوغرافي الساكن على خطى أستاذ الحداثة المكسيكي مانويل ألفاريز برافو. ومن عام 1970 إلى عام 1971 عملت كمساعدة لبرافو من خلال مرافقته في رحلاته المختلفة للتصوير الفوتوغرافي في جميع أرجاء المكسيك.<br><br>عرضت إتوربيدي أعمالها في بعض أهم المتاحف في المكسيك والولايات المتحدة الأمريكية وأوروبا. وحصلت على العديد من الجوائز الدولية ونُشرت العديد من كتب أعمالها في بلدان مختلفة.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'OCPWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Outstanding Contribution to Photography</h5>`,
        bodyText: `<b>EN</b> The Sony World Photography Awards’ Outstanding Contribution to Photography title is given to a person who has made a significant impact on the photographic medium throughout their career. This year’s recipient is Graciela Iturbide.<br><br>Born in Mexico City, in 1969 Iturbide enrolled in the Film Center of the Universidad Nacional Autonoma de Mexico but she was soon drawn to the art of still photography as practiced by the Mexican modernist master Manuel Alvarez Bravo. From 1970 to 1971 she worked as Bravo’s assistant accompanying him on his various photographic journeys throughout Mexico.<br><br>Iturbide has had exhibitions at some of the most important museums in Mexico, USA and Europe. She has received numerous international awards and many books of her work have been published in different countries.`,
    },

    {
        paintingId: 'MEAWT01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEAWT01ES', 'MEAWT01EN'],
    },
    {
        paintingId: 'MEAWT01ES',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>الشرق الأوسط وأفريقيا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> ستجد في غرفة المشاهدة هذه مجموعة مختارة بعناية من الصور الناجحة المقدمة إلى جوائز 2021 في الشرق الأوسط وأفريقيا.<br><br>تسلط هذه المجموعة الضوء على المواهب الاستثنائية في المنطقة من القوائم القصيرة والمرشحين النهائيين والفائزين عبر المسابقات الأربع.</span>`,
        annotationTextAlignment: 'right',
    },
    {
        paintingId: 'MEAWT01EN',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Middle East & Africa</h5>`,
        bodyText: `<b>EN</b> In this viewing room you will find a specially curated selection of successful images submitted to the 2021 Awards based in the Middle East and Africa.<br><br>This collection highlights the region's exceptional talent from the shortlists, finalists and winners across the four competitions.`,
    },

    /* Wall Text */

    /* MEA */
    {
        paintingId: 'MEA01P01',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA01P01AR', 'MEA01P01EN'],
    },
    {
        paintingId: 'MEA01P01AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA01P01.jpg/info.json`,
        headerText: `<h5>بول فالد إيبور</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الطريق المتعرج الأخضر</i><br><br>منظر جوي لواحد من أكثر الطرق الملتوية والخلابة في رومانيا. ويمر طريق DN1A عبر جبال الكاربات المنخفضة، ويشق طريقه من شيا إلى براسوف.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA01P01EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA01P01.jpg/info.json`,
        headerText: `<h5>Paul-Vlad Epure</h5>`,
        bodyText: `<b>EN</b> <i>Green Slalom</i><br><br>Aerial view of one of Romania's most twisted and picturesque roads. Cutting through the low Carpathians, the DN1A road makes it's way from Cheia to Brasov.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA01P02',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA01P02AR', 'MEA01P02EN'],
    },
    {
        paintingId: 'MEA01P02AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA01P02.jpg/info.json`,
        headerText: `<h5>مارغريت نويل</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>البروطيا الأبدية</i><br><br>اٌلتقطت هذه الصورة في 23 مايو 2020. وقد اٌلتقطت في منزلي. وأعددت قطعة قماش بيضاء على طاولة. واستخدمت حاملًا ثلاثي القوائم ووحدة فلاش مرتدة من السقف لتعزيز تفاصيل زهرة البروطيا المجففة الجميلة تلك. وأتاح لي ذلك أيضًا التقاط بعض الظل تحت البروطيا.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA01P02EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA01P02.jpg/info.json`,
        headerText: `<h5>Margaret Newell</h5>`,
        bodyText: `<b>EN</b> <i>Everlasting Protea</i><br><br>This image was taken on 23 May 2020.  It was taken in my home.  I did a set up with a white cloth on a table.  I used a tripod and bounced flash off the ceiling to enhance the details of this beautiful dried protea.  This also enabled me to capture some shadow beneath the protea.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA01P03',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA01P03AR', 'MEA01P03EN'],
    },
    {
        paintingId: 'MEA01P03AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA01P03.jpg/info.json`,
        headerText: `<h5>إبراهيم صديق</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>جونو</i><br><br>اُلتقطت هذه الصورة في 10 أبريل 2020.<br>الموقع: غواغوالادا، أبوجا، مدينة تابعة كبيرة تقع في أقصى نهاية عاصمة نيجيريا.<br><br>واُلتقطت هذه الصورة أثناء الإغلاق بسبب جائحة فيروس كورونا.<br><br>وفي هذا الوقت الهام من التاريخ، أُتيحت لنا فرصة فريدة للنظر إلى الداخل وإبراز الأشياء التي نحبها.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA01P03EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA01P03.jpg/info.json`,
        headerText: `<h5>Ibrahim Sadiq</h5>`,
        bodyText: `<b>EN</b> <i>JUNO</i><br><br>This image was taken on the 10th of April 2020.<br><br>Location: Gwagwalada, Abuja, A Llarge sattelite town located at the extreme end of the capital city of Nigeria.<br><br>This image was taken during the covid19 pandemic lockdown.<br><br>At this monumental time in history, we have been given a unique opportunity to look inward and bring out the things we love.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA02P04',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA02P04AR', 'MEA02P04EN'],
    },
    {
        paintingId: 'MEA02P04AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P04.jpg/info.json`,
        headerText: `<h5>محمود الحسن</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>صورة معالجة بارعة لفن الفلامنغو</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA02P04EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P04.jpg/info.json`,
        headerText: `<h5>Mahmood Alhassan</h5>`,
        bodyText: `<b>EN</b> <i>Flamingozen</i><br><br>Manipulation photo of flamingo art`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA02P05',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA02P05AR', 'MEA02P05EN'],
    },
    {
        paintingId: 'MEA02P05AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P05.jpg/info.json`,
        headerText: `<h5>جيمس ماتهي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>حلقة ضخمة تطفو في الساحل الغربي لجنوب أفريقيا على شعاب مرجانية تعد البيئة المثالية لتربية الأسماك بشكل مستدام. ويبذلون قصارى جهدهم لتربية الأسماك المستزرعة بشكل مستدام وصحي ويحرصون على عدم التسبب في ضرر للنظم البيئية المحلية والطبيعية. ويبدو المنظر رائعًا من الجو.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA02P05EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P05.jpg/info.json`,
        headerText: `<h5>James Matthee</h5>`,
        bodyText: `<b>EN</b> <i>Fishing Ring</i><br><br>A huge ring floating in the West Coast of South Africa on a reef are the perfect environment to farm fish sustainably. They make every effort to raise sustainably farmed and healthy fish and take care not to cause damage to local, natural ecosystems. It also looks cool from the air.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA02P06',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA02P06AR', 'MEA02P06EN'],
    },
    {
        paintingId: 'MEA02P06AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P06.jpg/info.json`,
        headerText: `<h5>راسيل كابانتينغ</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>اُلتقطت هذه الصورة خلال رحلتنا الأخيرة إلى الهند في 5 مارس 2020 خلال احتفال هولي في ناندغاون.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA02P06EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P06.jpg/info.json`,
        headerText: `<h5>Russell Cabanting</h5>`,
        bodyText: `<b>EN</b> <i>Untitled </i><br><br>This photo was taken during our recent trip to india last March 05, 2020 during the Holi celebration in Nandgaon.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA02P07',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA02P07AR', 'MEA02P07EN'],
    },
    {
        paintingId: 'MEA02P07AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P07.jpg/info.json`,
        headerText: `<h5>أديبايو أبايومي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>مهرجان أولوجو مهرجان مهم للغاية في في إلي إيفي، الوطن الأم لجميع ثقافة اليوروبا في المنطقة الغربية من نيجيريا. وهو مهرجان يرتدي فيه أوني تاج سلفه ""آدي أآري"" ويغدق مباركته على جميع أطفال أودودوا بعد الخروج من عزلة لمدة 7 أيام ويُعتقد أنه يوم يتحدث فيه وجهًا لوجه مع أسلافه و يقدم طلبًا لأطفال أودودوا بشأن سلوكياتهم.<br><br>وتُظهر الصورة كما شوهدت أوني في بلدة إيلي إيفي القديمة جالسًا في وسط المدينة ليغمر بركات أسلافه على جميع أبناء أولودوماري المتحدرين من أودودوا.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA02P07EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P07.jpg/info.json`,
        headerText: `<h5>Adebayo  Abayomi </h5>`,
        bodyText: `<b>EN</b> <i>Untitled </i><br><br>Olojo Festival is a very important festival in Ile-Ife the motherland of all Yoruba culture in the western region of Nigeria. It's a festival the Ooni get to wear the Ancestral Crown “Ade Aare” and shower his blessings on all the children of ODUDUWA after getting out of a 7days seclusion which is believed to be a day he gets to talk face to face with his ancestors and make request for the ODUDUWA children on their behave.<br><br>The image as seen shows the Ooni of the Ancient town of Ile-Ife seated in the center of the town to shower his ancestral blessings on all ODUDUWA descendants children of OLODUMARE.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA02P08',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA02P08AR', 'MEA02P08EN'],
    },
    {
        paintingId: 'MEA02P08AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P08.jpg/info.json`,
        headerText: `<h5>ماني</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>الأبراج</i><br><br>أحد المباني في أبوظبي، الإمارات العربية المتحدة. الأبراج التي تقع في الخلف هي أبراج الاتحاد التي ظهرت في فيلم MISSION IMPOSSIBLE GHOST PROTOCOL</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA02P08EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P08.jpg/info.json`,
        headerText: `<h5>Manny</h5>`,
        bodyText: `<b>EN</b> <i>Towers</i><br><br>One of the buildings in abu dhabi,uae. the towers behind is the etihad towers featured in the mission impossible ghost protocol movie`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA02P09',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA02P09AR', 'MEA02P09EN'],
    },
    {
        paintingId: 'MEA02P09AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P09.jpg/info.json`,
        headerText: `<h5>شاجي شاندان</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>اُلتقطت الصورة من قرية كتارا الثقافية في الدوحة بقطر. ويصنع الضوء شكل رقم 7 من ظل مظلات وقوف السيارات، مما يجعل المرئيات مثيرة للاهتمام.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA02P09EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P09.jpg/info.json`,
        headerText: `<h5>Shaji CHANDRAN</h5>`,
        bodyText: `<b>EN</b> <i>The Seven</i><br><br>This was taken from Katara Cultural village, Doha Qatar. The light make a shape of No.7 from the shadow of parking shades, makes interesting visuals.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA02P10',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA02P10AR', 'MEA02P10EN'],
    },
    {
        paintingId: 'MEA02P10AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P10.jpg/info.json`,
        headerText: `<h5>ميشيل</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>المشي</i><br><br>اٌلتقطت هذه الصورة أثناء جلسة التصوير خلال المشي في الحصن بأبوظبي، وأثناء المرور شاهدنا امرأة تدخل المكان. الحصن عبارة عن حصن سابق يعود تاريخه إلى القرن الثامن عشر يضم متحفًا ومركزًا للزوار يعرض الحرف العربية التقليدية.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA02P10EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA02P10.jpg/info.json`,
        headerText: `<h5>Michelle</h5>`,
        bodyText: `<b>EN</b> <i>Walking through</i><br><br>This photo was taken during our walking photoshoot at Al Hosn Abu Dhabi, while passing by saw a woman getting inside. Al Hosn is an 18th-century former fort with a museum and a visitor center displaying traditional Arabic crafts.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA03P12',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA03P12AR', 'MEA03P12EN'],
    },
    {
        paintingId: 'MEA03P12AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P12.jpg/info.json`,
        headerText: `<h5>إيمانويل أرشيبونغ</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>عنوان هذه السلسلة من الصور هو ""Ndifreke"" ورغم أنه اسم شائع الاستخدام بين شعب إبيبيو وإفيكي، فإن اسم ""Ndifreke"" يعني ""لن أنسى"". وهم يمثلون الخوف وعدم الارتياح من الذكرى والتسامح وقبول الأشياء التي يمكن ولا يمكن تغييرها، وبالتالي العثور على القوة. وتمثل هذه الصور أيضًا تمثيلاً للنمو عند التعامل مع الصحة العقلية، وتحديداً اضطراب ما بعد الصدمة. وتشير عصابة العينين إلى الطبيعة الخالدة والروحية للذكريات. وليس من الضروري رؤيتهم لكنهم سيعيشون معنا دائمًا.<br><br>واُلتقطت الصورة في فبراير 2020 بكاميرا هاتف iPhone 7 في إينوغو، نيجيريا. وصُنعت الخلفية من ملاءات السرير. وهذه صورة شخصية ذاتية.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA03P12EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P12.jpg/info.json`,
        headerText: `<h5>Emmanuel Archibong</h5>`,
        bodyText: `<b>EN</b> <i>Ndifreke</i><br><br>The title of this series of images is &quot;Ndifreke&quot;. Although, commonly used as a name amongst the Ibibio and Efik people, &quot;Ndifreke&quot; means &quot;I will not forget.” They represent, the fear and uneasiness of remembrance &amp; the tolerance and acceptance of things that can and cannot be changed, thus, finding strength. These images also stand as a representation of growth when dealing with mental health, specifically PTSD. The blindfold signifies the immortal, almost spiritual nature of memories. They do not have to be seen but they will always live with us.<br><br>Image was taken in February 2020 on an iPhone 7 camera in Enugu, Nigeria. Backdrop was made with bed sheets. This is a self portrait.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA03P13',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA03P13AR', 'MEA03P13EN'],
    },
    {
        paintingId: 'MEA03P13AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P13.jpg/info.json`,
        headerText: `<h5>مارك</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>عامل الفحم</i><br><br>صورة لعامل الفحم وهو يستعد لإعادة تغليفه وبيعه.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA03P13EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P13.jpg/info.json`,
        headerText: `<h5>Mark</h5>`,
        bodyText: `<b>EN</b> <i>Charcoal Labourer</i><br><br>An image of a charcoal labourer as he prepares to repack and sell them.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA03P14',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA03P14AR', 'MEA03P14EN'],
    },
    {
        paintingId: 'MEA03P14AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P14.jpg/info.json`,
        headerText: `<h5>مارك أنتوني أغتاي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أحمر وأصفر</i><br><br>مزيج من لونين</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA03P14EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P14.jpg/info.json`,
        headerText: `<h5>Mark Anthony Agtay</h5>`,
        bodyText: `<b>EN</b> <i>Red and Yellow</i><br><br>The Combination of two colors`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA03P15',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA03P15AR', 'MEA03P15EN'],
    },
    {
        paintingId: 'MEA03P15AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P15.jpg/info.json`,
        headerText: `<h5>راي توه</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>اُلتقطت بواسطة طائرة بدون طيار لمجموعة من المسافرين الصحراويين يستكشفون صحراء وشاطئ قطر</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA03P15EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P15.jpg/info.json`,
        headerText: `<h5>Ray Toh</h5>`,
        bodyText: `<b>EN</b> <i>Landscape</i><br><br>Taken by a drone of a group of desert travellers exploring into the Qatar desert and beach`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA03P16',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA03P16AR', 'MEA03P16EN'],
    },
    {
        paintingId: 'MEA03P16AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P16.jpg/info.json`,
        headerText: `<h5>شيجيت أوندين شريات</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>حمام تقليدي</i><br><br>في رأس الخيمة، يتم جلب الجمال خلال فصل الشتاء إلى البحر للاستحمام. وتساعد المياه المالحة من البحر على التخلص من القراد والبراغيث والطفيليات الأخرى. ويعتبر الاستحمام بهذه الطريقة تقليدًا عربيًا قديمًا، لكنه أصبح أقل شيوعًا في المنطقة بسبب الفنادق والمنتجعات الجديدة التي يتم بناؤها على طول الخط الساحلي. وتوجد حقيقة أخرى هي وجود المزيد من العيادات البيطرية المتاحة لعلاج الإبل.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA03P16EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P16.jpg/info.json`,
        headerText: `<h5>Shyjith Onden Cheriyath</h5>`,
        bodyText: `<b>EN</b> <i>Traditional Bath</i><br><br>At Ras Al Khaimah, during winter camels are brought to the sea for a bath. The salty water from the sea helps them get rid of ticks, fleas and other parasites. Bathing camels in this way is an old Arab tradition, but it is becoming less common in the region due to new hotels and resorts being build along the coast line. Another fact is that there are more veterinarian clinics available for the camels to be treated.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA03P17',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA03P17AR', 'MEA03P17EN'],
    },
    {
        paintingId: 'MEA03P17AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P17.jpg/info.json`,
        headerText: `<h5>صالح سعيد</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أحجار صلبة</i><br><br>سماء الشتاء غائمة<br>الاقتراب من الأشكال الصخرية في قلب الماء</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA03P17EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P17.jpg/info.json`,
        headerText: `<h5>Saleh said</h5>`,
        bodyText: `<b>EN</b> <i>Hard stones</i><br><br>Winter sky is cloudy<br>Approaching the rock shapes in the heart of the water`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA03P18',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA03P18AR', 'MEA03P18EN'],
    },
    {
        paintingId: 'MEA03P18AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P18.jpg/info.json`,
        headerText: `<h5>ـيدان مورغاترويد</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>أويانو</i><br><br>هذه أويانو - اسمها يعني أنها دليل على وجود الله. بصفتي ناشطًا محليًا في "مجتمع الميم" وفنانًا وشاعرًا وموسيقيًا، يمكنني أن أرى سبب ملاءمة هذا الاسم بشكل مناسب.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA03P18EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P18.jpg/info.json`,
        headerText: `<h5>Aidan Murgatroyd</h5>`,
        bodyText: `<b>EN</b> <i>Oyano</i><br><br>This is Oyano - her name means that she is evidence of the existence of God. As a local LGBTQ activist, artist, poet and musician I can see why that name is aptly fitting.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA03P19',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA03P19AR', 'MEA03P19EN'],
    },
    {
        paintingId: 'MEA03P19AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P19.jpg/info.json`,
        headerText: `<h5></h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>نصيحة</i><br><br>رجل عجوز يعلم عاملاً شابًا</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA03P19EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P19.jpg/info.json`,
        headerText: `<h5>Musaab Alremeithi</h5>`,
        bodyText: `<b>EN</b> <i>Advice</i><br><br>Old man teaching young worker`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA04P20',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA04P20AR', 'MEA04P20EN'],
    },
    {
        paintingId: 'MEA04P20AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P20.jpg/info.json`,
        headerText: `<h5>مارينا هاني</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>فتاة تنتظر الأمل تجلس في صمت وسلام</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA04P20EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P20.jpg/info.json`,
        headerText: `<h5>Marina Hany</h5>`,
        bodyText: `<b>EN</b> <i>Untitled</i><br><br>A girl waiting for hope sitting in silence and peace`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA04P22',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA04P22AR', 'MEA04P22EN'],
    },
    {
        paintingId: 'MEA04P22AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P22.jpg/info.json`,
        headerText: `<h5>كوليكاني ماهلانغو</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>المباني المهجورة في إيكانغالا القطاع E، باستخدام كاميرا كانون مقاس 18-55 مم بطول بؤري F3.4 وعاكس يرتد من الجانب.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA04P22EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P22.jpg/info.json`,
        headerText: `<h5>Khulekani Mahlangu</h5>`,
        bodyText: `<b>EN</b> <i>Lost buildings</i><br><br>Abandoned buildings Ekangala Section E, using Canon 18-55mm F3.4 and reflector bouncing it from the side.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA04P23',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA04P23AR', 'MEA04P23EN'],
    },
    {
        paintingId: 'MEA04P23AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P23.jpg/info.json`,
        headerText: `<h5>أزيلدا أوليفييه</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>استكشاف عناصر التصميم والتكوين.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA04P23EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P23.jpg/info.json`,
        headerText: `<h5>Azelda Olivier</h5>`,
        bodyText: `<b>EN</b> <i>Untitled</i><br><br>The exploration of Elements of design and Composition.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA04P24',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA04P24AR', 'MEA04P24EN'],
    },
    {
        paintingId: 'MEA04P24AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P24.jpg/info.json`,
        headerText: `<h5>ندى عيسى</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بدون عنوان</i><br><br>أوه مرحبًا.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA04P24EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P24.jpg/info.json`,
        headerText: `<h5>Nada Essa</h5>`,
        bodyText: `<b>EN</b> <i>Untitled</i><br><br>Oh hey there!`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA04P25',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA04P25AR', 'MEA04P25EN'],
    },
    {
        paintingId: 'MEA04P25AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P25.jpg/info.json`,
        headerText: `<h5>محمد الأحمر</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>بين الظل والضوء</i><br><br>الطبيعة جميلة، ولا يوجد ظل يضيء بعيدًا عن الضوء أو ضوء يمنع رؤية الظل.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA04P25EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P25.jpg/info.json`,
        headerText: `<h5>Mohamed Elahmer</h5>`,
        bodyText: `<b>EN</b> <i>Between shadow and light</i><br><br>Nature that is beautiful, no shade shines away from light or light hides to prevent the shadow from being viewed .`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA04P26',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA04P26AR', 'MEA04P26EN'],
    },
    {
        paintingId: 'MEA04P26AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P26.jpg/info.json`,
        headerText: `<h5>تاتندا شيدورا</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>لو كان مرض فيروس كورونا لونًا</i><br><br>مع كل ما يجري في العالم، وجدت نفسي منزعجًا من كل الإجراءات الإضافية التي يتعين علينا اتخاذها فقط لنكون آمنين. وكان لون القفازات بارزًا طوال الوقت. وهذه مجموعة من القفازات التي استخدمتها ولم أتمكن من استخدامها مرة أخرى، مع مجموعة جديدة لإكمال تكويني. والتقطت الصور باستخدام الإضاءة الطبيعية.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA04P26EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P26.jpg/info.json`,
        headerText: `<h5>Tatenda Chidora</h5>`,
        bodyText: `<b>EN</b> <i>If Covid was a Colour</i><br><br>With all that is happening in the world, I found myself being annoyed by all the extra measures we have to take just to be safe. The colour of gloves has been prominent throughout. This is a collection of gloves that I had used and couldn't use again, topped up with a fresh set to complete my structure. I shot using natural light.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA06P35',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA06P35AR', 'MEA06P35EN'],
    },
    {
        paintingId: 'MEA06P35AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA06P35.jpg/info.json`,
        headerText: `<h5></h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA06P35EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA06P35.jpg/info.json`,
        headerText: `<h5>Naif Albugami</h5>`,
        bodyText: `<b>EN</b> `,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA06P36',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA06P36AR', 'MEA06P36EN'],
    },
    {
        paintingId: 'MEA06P36AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA06P36.jpg/info.json`,
        headerText: `<h5></h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA06P36EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA06P36.jpg/info.json`,
        headerText: `<h5>Abdulla AL-Mushaifri</h5>`,
        bodyText: `<b>EN</b> `,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },


    {

        paintingId: 'MEA07P37',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA07P37AR', 'MEA07P37EN'],
    },
    {
        paintingId: 'MEA07P37AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA07P37.jpg/info.json`,
        headerText: `<h5></h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA07P37EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA07P37.jpg/info.json`,
        headerText: `<h5>Azelda Olivier</h5>`,
        bodyText: `<b>EN</b> `,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA07P38',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA07P38AR', 'MEA07P38EN'],
    },
    {
        paintingId: 'MEA07P38AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA07P38.jpg/info.json`,
        headerText: `<h5></h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA07P38EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA07P38.jpg/info.json`,
        headerText: `<h5>Abdelhamid Tahoun</h5>`,
        bodyText: `<b>EN</b> `,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA07P39',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA07P39AR', 'MEA07P39EN'],
    },
    {
        paintingId: 'MEA07P39AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA07P39.jpg/info.json`,
        headerText: `<h5></h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA07P39EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA07P39.jpg/info.json`,
        headerText: `<h5>Nasseer Alomari</h5>`,
        bodyText: `<b>EN</b> `,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA05P34',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA05P27AR', 'MEA05P27EN'],
    },
    {
        paintingId: 'MEA05P27AR',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}MEA05P27.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P28.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P29.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P30.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P31.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P32.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P33.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P34.jpg/info.json`],
        headerText: `<h5>كايودي مويوسادي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>صورة شخصية السابعة صباحًا</i><br><br>تم التقاط صورة شخصية خلال الإغلاق في أبريل الناجم عن الموجة الأولى لفيروس كورونا. وكان أقل من ربع شعري مضفرًا بواسطة المصففة المترددة (صديقتي الزميلة في الشقة) قبل أن أقرر تبني هذا الشكل لبضعة أيام، وكان شروق الشمس في هذا اليوم بالذات جميلًا ويحث على التقاط صورة.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA05P27EN',
        videoId: null,
        videoURL: null,
        iiifMultiSource: [`${CANTALOUPE_IMAGE_SERVER}MEA05P27.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P28.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P29.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P30.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P31.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P32.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P33.jpg/info.json`,
            `${CANTALOUPE_IMAGE_SERVER}MEA05P34.jpg/info.json`],
        headerText: `<h5>Kayode Moyosade</h5>`,
        bodyText: `<b>EN</b> <i>7 AM Portrait</i><br><br>A portrait was taken during the lockdown in April resulting from the first wave of the coronavirus. Less than a quarter of my hair had been braided by my reluctant stylist (flatmate's girlfriend) before I decided to adopt the style for a few days, the sunrise on this particular day was beautiful and begged me to take a picture.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA04P21',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA04P21AR', 'MEA04P21EN'],
    },
    {
        paintingId: 'MEA04P21AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P21.jpg/info.json`,
        headerText: `<h5>عبد الله المشيفري</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>منظر من وردة الصحراء</i><br><br>صورة لرجل متجه إلى (وردة الصحراء) متحف قطر الوطني.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA04P21EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA04P21.jpg/info.json`,
        headerText: `<h5>Abdulla AL-Mushaifri</h5>`,
        bodyText: `<b>EN</b> <i>View From Desert Rose</i><br><br>A photo for a man Heading to the (Desert Rose) Qatar National Museum.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {

        paintingId: 'MEA03P11',
        videoId: null,
        videoURL: null,
        hasCarouselAsParent: 'Y',
        carouselAnnotationSiblings: ['MEA03P11AR', 'MEA03P11EN'],
    },
    {
        paintingId: 'MEA03P11AR',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P11.jpg/info.json`,
        headerText: `<h5>ليلا كويتزي</h5>`,
        bodyText: `<span dir="rtl"><b>ع</b><span>-</span> <i>ذكرى باللون الأرجواني</i><br><br>تعتبر مقبرة ريبيكا ستريت مكانًا غير معروف في بريتوريا لكنها مليئة بالتاريخ وتذكر الماضي. وخلال أسابيع قليلة من شهر أكتوبر، تتفتح أزهار الجاكاراندا ويبدو أن هذا الطريق القديم من الأشجار المزروعة منذ أكثر من 100 عام يحتفل بمن لم يعد موجودًا هنا. وزرتها في بعد الظهر في أواخر الربيع عندما بدأت الشمس في الغروب. وبسبب قرارات الإغلاق، لم أتمكن من زيارتها بعد هذا الوقت بقليل، لكن توهج الزهور الأرجوانية ودفء الشمس والظلال التي تسقط على شواهد القبور أضافت إحساسًا بالسلام والحنين إلى الماضي. التقطت بنسبة 1/50، بطول بؤري f/14 وإعدادات ISO 100.</span>`,
        annotationTextAlignment: 'right',
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    {
        paintingId: 'MEA03P11EN',
        videoId: null,
        videoURL: null,
        iiifSource: `${CANTALOUPE_IMAGE_SERVER}MEA03P11.jpg/info.json`,
        headerText: `<h5>Lilla Coetzee</h5>`,
        bodyText: `<b>EN</b> <i>Remembrance in Purple</i><br><br>The Rebecca Street Cemetery is a little known place in Pretoria but it is full of history and is a remembrance of the past. During a few weeks in October, the Jacaranda flowers bloom and this old avenue of trees planted over a 100 years ago, seems to celebrate those who are no longer here. I visited it in the late Spring afternoon when the sun was just starting to go down. Due to lockdown regulations I was unable to visit it a little later but the glow of the purple flowers, the warmth of the sun and the shadows falling on the gravestones added a sense of peace and nostalgia. Shot at 1/50, f/14 and ISO 100.`,
        // instagramUrl: '',
        // facebookUrl: '',
        // ContactURL: '',
        // urlLink1Label: '',
        // urlLink1: '',
        // urlLink2Label: '',
        // urlLink2: '',
    },
    // {
    //
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     hasCarouselAsParent: 'Y',
    //     carouselAnnotationSiblings: ['', ''],
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h5></h5>`,
    //     bodyText: `<span dir="rtl"><b>ع</b><span>-</span> </span>`,
    //     annotationTextAlignment: 'right',
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    // {
    //     paintingId: '',
    //     videoId: null,
    //     videoURL: null,
    //     iiifSource: `${CANTALOUPE_IMAGE_SERVER}.jpg/info.json`,
    //     headerText: `<h5></h5>`,
    //     bodyText: `<b>EN</b> `,
    //     // instagramUrl: '',
    //     // facebookUrl: '',
    //     // ContactURL: '',
    //     // urlLink1Label: '',
    //     // urlLink1: '',
    //     // urlLink2Label: '',
    //     // urlLink2: '',
    // },
    //
    /* MEA */

];

export {AnnotationsDB};